/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csscalc-cssvhunit-flexbox-flexboxlegacy-inlinesvg-localstorage-objectfit-svg-touchevents-webp-setclasses !*/
(!(function (t, e, i) {
  function o(t, e) {
    return typeof t === e;
  }
  function n(t) {
    var e = _.className,
      i = w._config.classPrefix || '';
    if ((k && (e = e.baseVal), w._config.enableJSClass)) {
      var o = new RegExp('(^|\\s)' + i + 'no-js(\\s|$)');
      e = e.replace(o, '$1' + i + 'js$2');
    }
    w._config.enableClasses &&
      ((e += ' ' + i + t.join(' ' + i)), k ? (_.className.baseVal = e) : (_.className = e));
  }
  function s() {
    return 'function' != typeof e.createElement
      ? e.createElement(arguments[0])
      : k
        ? e.createElementNS.call(e, 'http://www.w3.org/2000/svg', arguments[0])
        : e.createElement.apply(e, arguments);
  }
  function a(e, i, o) {
    var n;
    if ('getComputedStyle' in t) {
      n = getComputedStyle.call(t, e, i);
      var s = t.console;
      if (null !== n) o && (n = n.getPropertyValue(o));
      else if (s) {
        s[s.error ? 'error' : 'log'].call(
          s,
          'getComputedStyle returning null, its possible modernizr test results are inaccurate',
        );
      }
    } else n = !i && e.currentStyle && e.currentStyle[o];
    return n;
  }
  function r(t) {
    return t
      .replace(/([a-z])-([a-z])/g, function (t, e, i) {
        return e + i.toUpperCase();
      })
      .replace(/^-/, '');
  }
  function l(t, e) {
    if ('object' == typeof t) for (var i in t) x(t, i) && l(i, t[i]);
    else {
      var o = (t = t.toLowerCase()).split('.'),
        s = w[o[0]];
      if ((2 == o.length && (s = s[o[1]]), void 0 !== s)) return w;
      ((e = 'function' == typeof e ? e() : e),
        1 == o.length
          ? (w[o[0]] = e)
          : (!w[o[0]] || w[o[0]] instanceof Boolean || (w[o[0]] = new Boolean(w[o[0]])),
            (w[o[0]][o[1]] = e)),
        n([(e && 0 != e ? '' : 'no-') + o.join('-')]),
        w._trigger(t, e));
    }
    return w;
  }
  function c(t, i, o, n) {
    var a,
      r,
      l,
      c,
      d = 'modernizr',
      p = s('div'),
      u = (function () {
        var t = e.body;
        return (t || ((t = s(k ? 'svg' : 'body')).fake = !0), t);
      })();
    if (parseInt(o, 10))
      for (; o--; ) (((l = s('div')).id = n ? n[o] : d + (o + 1)), p.appendChild(l));
    return (
      ((a = s('style')).type = 'text/css'),
      (a.id = 's' + d),
      (u.fake ? u : p).appendChild(a),
      u.appendChild(p),
      a.styleSheet ? (a.styleSheet.cssText = t) : a.appendChild(e.createTextNode(t)),
      (p.id = d),
      u.fake &&
        ((u.style.background = ''),
        (u.style.overflow = 'hidden'),
        (c = _.style.overflow),
        (_.style.overflow = 'hidden'),
        _.appendChild(u)),
      (r = i(p, t)),
      u.fake
        ? (u.parentNode.removeChild(u), (_.style.overflow = c), _.offsetHeight)
        : p.parentNode.removeChild(p),
      !!r
    );
  }
  function d(t, e) {
    return !!~('' + t).indexOf(e);
  }
  function p(t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }
  function u(t) {
    return t
      .replace(/([A-Z])/g, function (t, e) {
        return '-' + e.toLowerCase();
      })
      .replace(/^ms-/, '-ms-');
  }
  function f(e, o) {
    var n = e.length;
    if ('CSS' in t && 'supports' in t.CSS) {
      for (; n--; ) if (t.CSS.supports(u(e[n]), o)) return !0;
      return !1;
    }
    if ('CSSSupportsRule' in t) {
      for (var s = []; n--; ) s.push('(' + u(e[n]) + ':' + o + ')');
      return c(
        '@supports (' + (s = s.join(' or ')) + ') { #modernizr { position: absolute; } }',
        function (t) {
          return 'absolute' == a(t, null, 'position');
        },
      );
    }
    return i;
  }
  function h(t, e, n, a) {
    function l() {
      p && (delete L.style, delete L.modElem);
    }
    if (((a = !o(a, 'undefined') && a), !o(n, 'undefined'))) {
      var c = f(t, n);
      if (!o(c, 'undefined')) return c;
    }
    for (var p, u, h, v, g, m = ['modernizr', 'tspan', 'samp']; !L.style && m.length; )
      ((p = !0), (L.modElem = s(m.shift())), (L.style = L.modElem.style));
    for (h = t.length, u = 0; h > u; u++)
      if (((v = t[u]), (g = L.style[v]), d(v, '-') && (v = r(v)), L.style[v] !== i)) {
        if (a || o(n, 'undefined')) return (l(), 'pfx' != e || v);
        try {
          L.style[v] = n;
        } catch (t) {}
        if (L.style[v] != g) return (l(), 'pfx' != e || v);
      }
    return (l(), !1);
  }
  function v(t, e, i, n, s) {
    var a = t.charAt(0).toUpperCase() + t.slice(1),
      r = (t + ' ' + z.join(a + ' ') + a).split(' ');
    return o(e, 'string') || o(e, 'undefined')
      ? h(r, e, n, s)
      : (function (t, e, i) {
          var n;
          for (var s in t)
            if (t[s] in e) return !1 === i ? t[s] : o((n = e[t[s]]), 'function') ? p(n, i || e) : n;
          return !1;
        })((r = (t + ' ' + T.join(a + ' ') + a).split(' ')), e, i);
  }
  function g(t, e, o) {
    return v(t, i, i, e, o);
  }
  var m = [],
    b = [],
    y = {
      _version: '3.6.0',
      _config: { classPrefix: '', enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
      _q: [],
      on: function (t, e) {
        var i = this;
        setTimeout(function () {
          e(i[t]);
        }, 0);
      },
      addTest: function (t, e, i) {
        b.push({ name: t, fn: e, options: i });
      },
      addAsyncTest: function (t) {
        b.push({ name: null, fn: t });
      },
    },
    w = function () {};
  ((w.prototype = y),
    (w = new w()).addTest(
      'svg',
      !!e.createElementNS && !!e.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect,
    ),
    w.addTest('localstorage', function () {
      var t = 'modernizr';
      try {
        return (localStorage.setItem(t, t), localStorage.removeItem(t), !0);
      } catch (t) {
        return !1;
      }
    }));
  var $ = y._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['', ''];
  y._prefixes = $;
  var x,
    _ = e.documentElement,
    k = 'svg' === _.nodeName.toLowerCase();
  (w.addTest('csscalc', function () {
    var t = 'width:',
      e = s('a');
    return ((e.style.cssText = t + $.join('calc(10px);' + t)), !!e.style.length);
  }),
    w.addTest('inlinesvg', function () {
      var t = s('div');
      return (
        (t.innerHTML = '<svg/>'),
        'http://www.w3.org/2000/svg' ==
          ('undefined' != typeof SVGRect && t.firstChild && t.firstChild.namespaceURI)
      );
    }),
    (function () {
      var t = {}.hasOwnProperty;
      x =
        o(t, 'undefined') || o(t.call, 'undefined')
          ? function (t, e) {
              return e in t && o(t.constructor.prototype[e], 'undefined');
            }
          : function (e, i) {
              return t.call(e, i);
            };
    })(),
    (y._l = {}),
    (y.on = function (t, e) {
      (this._l[t] || (this._l[t] = []),
        this._l[t].push(e),
        w.hasOwnProperty(t) &&
          setTimeout(function () {
            w._trigger(t, w[t]);
          }, 0));
    }),
    (y._trigger = function (t, e) {
      if (this._l[t]) {
        var i = this._l[t];
        (setTimeout(function () {
          var t;
          for (t = 0; t < i.length; t++) (0, i[t])(e);
        }, 0),
          delete this._l[t]);
      }
    }),
    w._q.push(function () {
      y.addTest = l;
    }),
    w.addAsyncTest(function () {
      function t(t, e, i) {
        function o(e) {
          var o = !(!e || 'load' !== e.type) && 1 == n.width;
          (l(t, 'webp' === t && o ? new Boolean(o) : o), i && i(e));
        }
        var n = new Image();
        ((n.onerror = o), (n.onload = o), (n.src = e));
      }
      var e = [
          {
            uri: 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=',
            name: 'webp',
          },
          {
            uri: 'data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==',
            name: 'webp.alpha',
          },
          {
            uri: 'data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
            name: 'webp.animation',
          },
          {
            uri: 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=',
            name: 'webp.lossless',
          },
        ],
        i = e.shift();
      t(i.name, i.uri, function (i) {
        if (i && 'load' === i.type) for (var o = 0; o < e.length; o++) t(e[o].name, e[o].uri);
      });
    }));
  var C = (y.testStyles = c);
  (w.addTest('touchevents', function () {
    var i;
    if ('ontouchstart' in t || (t.DocumentTouch && e instanceof DocumentTouch)) i = !0;
    else {
      var o = [
        '@media (',
        $.join('touch-enabled),('),
        'heartz',
        ')',
        '{#modernizr{top:9px;position:absolute}}',
      ].join('');
      C(o, function (t) {
        i = 9 === t.offsetTop;
      });
    }
    return i;
  }),
    C('#modernizr { height: 50vh; }', function (e) {
      var i = parseInt(t.innerHeight / 2, 10),
        o = parseInt(a(e, null, 'height'), 10);
      w.addTest(
        'cssvhunit',
        (function (t, e) {
          return t - 1 === e || t === e || t + 1 === e;
        })(o, i),
      );
    }));
  var S = 'Moz O ms Webkit',
    T = y._config.usePrefixes ? S.toLowerCase().split(' ') : [];
  y._domPrefixes = T;
  var z = y._config.usePrefixes ? S.split(' ') : [];
  y._cssomPrefixes = z;
  var A = function (e) {
    var o,
      n = $.length,
      s = t.CSSRule;
    if (void 0 === s) return i;
    if (!e) return !1;
    if ((o = (e = e.replace(/^@/, '')).replace(/-/g, '_').toUpperCase() + '_RULE') in s)
      return '@' + e;
    for (var a = 0; n > a; a++) {
      var r = $[a];
      if (r.toUpperCase() + '_' + o in s) return '@-' + r.toLowerCase() + '-' + e;
    }
    return !1;
  };
  y.atRule = A;
  var P = { elem: s('modernizr') };
  w._q.push(function () {
    delete P.elem;
  });
  var L = { style: P.elem.style };
  (w._q.unshift(function () {
    delete L.style;
  }),
    (y.testAllProps = v),
    (y.testAllProps = g),
    w.addTest('flexbox', g('flexBasis', '1px', !0)),
    w.addTest('flexboxlegacy', g('boxDirection', 'reverse', !0)));
  var E = (y.prefixed = function (t, e, i) {
    return 0 === t.indexOf('@')
      ? A(t)
      : (-1 != t.indexOf('-') && (t = r(t)), e ? v(t, e, i) : v(t, 'pfx'));
  });
  (w.addTest('objectfit', !!E('objectFit'), { aliases: ['object-fit'] }),
    (function () {
      var t, e, i, n, s, a;
      for (var r in b)
        if (b.hasOwnProperty(r)) {
          if (
            ((t = []),
            (e = b[r]).name &&
              (t.push(e.name.toLowerCase()),
              e.options && e.options.aliases && e.options.aliases.length))
          )
            for (i = 0; i < e.options.aliases.length; i++)
              t.push(e.options.aliases[i].toLowerCase());
          for (n = o(e.fn, 'function') ? e.fn() : e.fn, s = 0; s < t.length; s++)
            (1 === (a = t[s].split('.')).length
              ? (w[a[0]] = n)
              : (!w[a[0]] || w[a[0]] instanceof Boolean || (w[a[0]] = new Boolean(w[a[0]])),
                (w[a[0]][a[1]] = n)),
              m.push((n ? '' : 'no-') + a.join('-')));
        }
    })(),
    n(m),
    delete y.addTest,
    delete y.addAsyncTest);
  for (var I = 0; I < w._q.length; I++) w._q[I]();
  t.Modernizr = w;
})(window, document),
  (function (t) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['jquery'], t)
      : 'undefined' != typeof exports
        ? (module.exports = t(require('jquery')))
        : t(jQuery);
  })(function (t) {
    'use strict';
    var e,
      i = window.Slick || {};
    ((e = 0),
      ((i = function (i, o) {
        var n,
          s = this;
        ((s.defaults = {
          adaptiveHeight: !1,
          appendArrows: t(i),
          appendDots: t(i),
          arrows: !0,
          arrowsPlacement: null,
          asNavFor: null,
          prevArrow:
            '<button class="slick-prev" type="button"><span class="slick-prev-icon" aria-hidden="true"></span><span class="slick-sr-only">Previous</span></button>',
          nextArrow:
            '<button class="slick-next" type="button"><span class="slick-next-icon" aria-hidden="true"></span><span class="slick-sr-only">Next</span></button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: '50px',
          cssEase: 'ease',
          customPaging: function (e, i) {
            return t(
              '<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Go to slide ' +
                (i + 1) +
                '</span></button>',
            );
          },
          dots: !1,
          dotsClass: 'slick-dots',
          draggable: !0,
          easing: 'linear',
          edgeFriction: 0.35,
          fade: !1,
          infinite: !0,
          initialSlide: 0,
          instructionsText: null,
          lazyLoad: 'ondemand',
          mobileFirst: !1,
          playIcon: '<span class="slick-play-icon" aria-hidden="true"></span>',
          pauseIcon: '<span class="slick-pause-icon" aria-hidden="true"></span>',
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          regionLabel: 'carousel',
          respondTo: 'window',
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: '',
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useAutoplayToggleButton: !0,
          useCSS: !0,
          useGroupRole: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (s.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            $instructionsText: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $pauseButton: null,
            $pauseIcon: null,
            $playIcon: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          t.extend(s, s.initials),
          (s.activeBreakpoint = null),
          (s.animType = null),
          (s.animProp = null),
          (s.breakpoints = []),
          (s.breakpointSettings = []),
          (s.cssTransitions = !1),
          (s.focussed = !1),
          (s.interrupted = !1),
          (s.hidden = 'hidden'),
          (s.paused = !0),
          (s.positionProp = null),
          (s.respondTo = null),
          (s.rowCount = 1),
          (s.shouldClick = !0),
          (s.$slider = t(i)),
          (s.$slidesCache = null),
          (s.transformType = null),
          (s.transitionType = null),
          (s.visibilityChange = 'visibilitychange'),
          (s.windowWidth = 0),
          (s.windowTimer = null),
          (n = t(i).data('slick') || {}),
          (s.options = t.extend({}, s.defaults, o, n)),
          (s.currentSlide = s.options.initialSlide),
          (s.originalSettings = s.options),
          void 0 !== document.mozHidden
            ? ((s.hidden = 'mozHidden'), (s.visibilityChange = 'mozvisibilitychange'))
            : void 0 !== document.webkitHidden &&
              ((s.hidden = 'webkitHidden'), (s.visibilityChange = 'webkitvisibilitychange')),
          (s.autoPlay = t.proxy(s.autoPlay, s)),
          (s.autoPlayClear = t.proxy(s.autoPlayClear, s)),
          (s.autoPlayIterator = t.proxy(s.autoPlayIterator, s)),
          (s.autoPlayToggleHandler = t.proxy(s.autoPlayToggleHandler, s)),
          (s.changeSlide = t.proxy(s.changeSlide, s)),
          (s.clickHandler = t.proxy(s.clickHandler, s)),
          (s.selectHandler = t.proxy(s.selectHandler, s)),
          (s.setPosition = t.proxy(s.setPosition, s)),
          (s.swipeHandler = t.proxy(s.swipeHandler, s)),
          (s.dragHandler = t.proxy(s.dragHandler, s)),
          (s.instanceUid = e++),
          (s.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          s.registerBreakpoints(),
          s.init(!0));
      }).prototype.addSlide = i.prototype.slickAdd =
        function (e, i, o) {
          var n = this;
          if ('boolean' == typeof i) ((o = i), (i = null));
          else if (i < 0 || i >= n.slideCount) return !1;
          (n.unload(),
            'number' == typeof i
              ? 0 === i && 0 === n.$slides.length
                ? t(e).appendTo(n.$slideTrack)
                : o
                  ? t(e).insertBefore(n.$slides.eq(i))
                  : t(e).insertAfter(n.$slides.eq(i))
              : !0 === o
                ? t(e).prependTo(n.$slideTrack)
                : t(e).appendTo(n.$slideTrack),
            (n.$slides = n.$slideTrack.children(this.options.slide)),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            n.$slides.each(function (e, i) {
              (t(i).attr('data-slick-index', e),
                t(i).attr('role', 'group'),
                t(i).attr('aria-label', 'slide ' + e));
            }),
            (n.$slidesCache = n.$slides),
            n.reinit());
        }),
      (i.prototype.animateHeight = function () {
        var t,
          e = this;
        1 === e.options.slidesToShow &&
          !0 === e.options.adaptiveHeight &&
          !1 === e.options.vertical &&
          ((t = e.$slides.eq(e.currentSlide).outerHeight(!0)),
          e.$list.animate({ height: t }, e.options.speed));
      }),
      (i.prototype.animateSlide = function (e, i) {
        var o = {},
          n = this;
        (n.animateHeight(),
          !0 === n.options.rtl && !1 === n.options.vertical && (e = -e),
          !1 === n.transformsEnabled
            ? !1 === n.options.vertical
              ? n.$slideTrack.animate({ left: e }, n.options.speed, n.options.easing, i)
              : n.$slideTrack.animate({ top: e }, n.options.speed, n.options.easing, i)
            : !1 === n.cssTransitions
              ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
                t({ animStart: n.currentLeft }).animate(
                  { animStart: e },
                  {
                    duration: n.options.speed,
                    easing: n.options.easing,
                    step: function (t) {
                      ((t = Math.ceil(t)),
                        !1 === n.options.vertical
                          ? (o[n.animType] = 'translate(' + t + 'px, 0px)')
                          : (o[n.animType] = 'translate(0px,' + t + 'px)'),
                        n.$slideTrack.css(o));
                    },
                    complete: function () {
                      i && i.call();
                    },
                  },
                ))
              : (n.applyTransition(),
                (e = Math.ceil(e)),
                !1 === n.options.vertical
                  ? (o[n.animType] = 'translate3d(' + e + 'px, 0px, 0px)')
                  : (o[n.animType] = 'translate3d(0px,' + e + 'px, 0px)'),
                n.$slideTrack.css(o),
                i &&
                  setTimeout(function () {
                    (n.disableTransition(), i.call());
                  }, n.options.speed)));
      }),
      (i.prototype.getNavTarget = function () {
        var e = this.options.asNavFor;
        return (e && null !== e && (e = t(e).not(this.$slider)), e);
      }),
      (i.prototype.asNavFor = function (e) {
        var i = this.getNavTarget();
        null !== i &&
          'object' == typeof i &&
          i.each(function () {
            var i = t(this).slick('getSlick');
            i.unslicked || i.slideHandler(e, !0);
          });
      }),
      (i.prototype.applyTransition = function (t) {
        var e = this,
          i = {};
        (!1 === e.options.fade
          ? (i[e.transitionType] =
              e.transformType + ' ' + e.options.speed + 'ms ' + e.options.cssEase)
          : (i[e.transitionType] = 'opacity ' + e.options.speed + 'ms ' + e.options.cssEase),
          !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i));
      }),
      (i.prototype.autoPlay = function () {
        var t = this;
        (t.autoPlayClear(),
          t.slideCount > t.options.slidesToShow &&
            (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed)));
      }),
      (i.prototype.autoPlayClear = function () {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
      }),
      (i.prototype.autoPlayIterator = function () {
        var t = this,
          e = t.currentSlide + t.options.slidesToScroll;
        t.paused ||
          t.interrupted ||
          t.focussed ||
          (!1 === t.options.infinite &&
            (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1
              ? (t.direction = 0)
              : 0 === t.direction &&
                ((e = t.currentSlide - t.options.slidesToScroll),
                t.currentSlide - 1 == 0 && (t.direction = 1))),
          t.slideHandler(e));
      }),
      (i.prototype.autoPlayToggleHandler = function () {
        var t = this;
        t.paused
          ? (t.$playIcon.css('display', 'none'),
            t.$pauseIcon.css('display', 'inline'),
            t.$pauseButton.find('.slick-play-text').attr('style', 'display: none'),
            t.$pauseButton.find('.slick-pause-text').removeAttr('style'),
            t.slickPlay())
          : (t.$playIcon.css('display', 'inline'),
            t.$pauseIcon.css('display', 'none'),
            t.$pauseButton.find('.slick-play-text').removeAttr('style'),
            t.$pauseButton.find('.slick-pause-text').attr('style', 'display: none'),
            t.slickPause());
      }),
      (i.prototype.buildArrows = function () {
        var e = this;
        if (!0 === e.options.arrows)
          if (
            ((e.$prevArrow = t(e.options.prevArrow).addClass('slick-arrow')),
            (e.$nextArrow = t(e.options.nextArrow).addClass('slick-arrow')),
            e.slideCount > e.options.slidesToShow)
          ) {
            if (e.htmlExpr.test(e.options.prevArrow))
              if (null != e.options.arrowsPlacement)
                switch (e.options.arrowsPlacement) {
                  case 'beforeSlides':
                  case 'split':
                    (console.log('test'), e.$prevArrow.prependTo(e.options.appendArrows));
                    break;
                  case 'afterSlides':
                    e.$prevArrow.appendTo(e.options.appendArrows);
                }
              else e.$prevArrow.prependTo(e.options.appendArrows);
            if (e.htmlExpr.test(e.options.nextArrow))
              if (null != e.options.arrowsPlacement)
                switch (e.options.arrowsPlacement) {
                  case 'beforeSlides':
                    (console.log('test2'), e.$prevArrow.after(e.$nextArrow));
                    break;
                  case 'afterSlides':
                  case 'split':
                    e.$nextArrow.appendTo(e.options.appendArrows);
                }
              else e.$nextArrow.appendTo(e.options.appendArrows);
            !0 !== e.options.infinite &&
              e.$prevArrow.addClass('slick-disabled').prop('disabled', !0);
          } else e.$prevArrow.add(e.$nextArrow).addClass('slick-hidden').prop('disabled', !0);
      }),
      (i.prototype.buildDots = function () {
        var e,
          i,
          o = this;
        if (!0 === o.options.dots && o.slideCount > o.options.slidesToShow) {
          for (
            o.$slider.addClass('slick-dotted'),
              i = t('<ul />').addClass(o.options.dotsClass),
              e = 0;
            e <= o.getDotCount();
            e += 1
          )
            i.append(t('<li />').append(o.options.customPaging.call(this, o, e)));
          ((o.$dots = i.appendTo(o.options.appendDots)),
            o.$dots.find('li').first().addClass('slick-active'));
        }
      }),
      (i.prototype.buildOut = function () {
        var e = this;
        ((e.$slides = e.$slider
          .children(e.options.slide + ':not(.slick-cloned)')
          .addClass('slick-slide')),
          (e.slideCount = e.$slides.length),
          e.$slides.each(function (i, o) {
            (t(o)
              .attr('data-slick-index', i)
              .data('originalStyling', t(o).attr('style') || ''),
              e.options.useGroupRole &&
                t(o)
                  .attr('role', 'group')
                  .attr('aria-label', 'slide ' + (i + 1)));
          }),
          e.$slider.addClass('slick-slider'),
          e.$slider.attr('role', 'region'),
          e.$slider.attr('aria-label', e.options.regionLabel),
          (e.$slideTrack =
            0 === e.slideCount
              ? t('<div class="slick-track"/>').appendTo(e.$slider)
              : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
          e.$slideTrack.css('opacity', 0),
          (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
            (e.options.slidesToScroll = 1),
          t('img[data-lazy]', e.$slider).not('[src]').addClass('slick-loading'),
          e.setupInfinite(),
          e.buildArrows(),
          e.buildDots(),
          e.updateDots(),
          e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0),
          !0 === e.options.draggable && e.$list.addClass('draggable'),
          e.options.autoplay &&
            e.options.useAutoplayToggleButton &&
            ((e.$pauseIcon = t(e.options.pauseIcon).attr('aria-hidden', !0)),
            (e.$playIcon = t(e.options.playIcon).attr('aria-hidden', !0)),
            (e.$pauseButton = t('<button type="button" class="slick-autoplay-toggle-button">')),
            e.$pauseButton.append(e.$pauseIcon),
            e.$pauseButton.append(e.$playIcon.css('display', 'none')),
            e.$pauseButton.append(t('<span class="slick-pause-text slick-sr-only">Pause</span>')),
            e.$pauseButton.append(
              t('<span class="slick-play-text slick-sr-only" style="display: none">Play</span>'),
            ),
            e.$pauseButton.prependTo(e.$slider)),
          null != e.options.instructionsText &&
            '' != e.options.instructionsText &&
            ((e.$instructionsText = t(
              '<p class="slick-instructions slick-sr-only">' + e.options.instructionsText + '</p>',
            )),
            e.$instructionsText.prependTo(e.$slider)));
      }),
      (i.prototype.buildRows = function () {
        var t,
          e,
          i,
          o = this,
          n = document.createDocumentFragment(),
          s = o.$slider.children();
        if (0 < o.options.rows) {
          for (
            i = o.options.slidesPerRow * o.options.rows, e = Math.ceil(s.length / i), t = 0;
            t < e;
            t++
          ) {
            for (var a = document.createElement('div'), r = 0; r < o.options.rows; r++) {
              for (var l = document.createElement('div'), c = 0; c < o.options.slidesPerRow; c++) {
                var d = t * i + (r * o.options.slidesPerRow + c);
                s.get(d) && l.appendChild(s.get(d));
              }
              a.appendChild(l);
            }
            n.appendChild(a);
          }
          (o.$slider.empty().append(n),
            o.$slider
              .children()
              .children()
              .children()
              .css({ width: 100 / o.options.slidesPerRow + '%', display: 'inline-block' }));
        }
      }),
      (i.prototype.checkResponsive = function (e, i) {
        var o,
          n,
          s,
          a = this,
          r = !1,
          l = a.$slider.width(),
          c = window.innerWidth || t(window).width();
        if (
          ('window' === a.respondTo
            ? (s = c)
            : 'slider' === a.respondTo
              ? (s = l)
              : 'min' === a.respondTo && (s = Math.min(c, l)),
          a.options.responsive && a.options.responsive.length && null !== a.options.responsive)
        ) {
          for (o in ((n = null), a.breakpoints))
            a.breakpoints.hasOwnProperty(o) &&
              (!1 === a.originalSettings.mobileFirst
                ? s < a.breakpoints[o] && (n = a.breakpoints[o])
                : s > a.breakpoints[o] && (n = a.breakpoints[o]));
          (null !== n
            ? (null !== a.activeBreakpoint && n === a.activeBreakpoint && !i) ||
              ((a.activeBreakpoint = n),
              'unslick' === a.breakpointSettings[n]
                ? a.unslick(n)
                : ((a.options = t.extend({}, a.originalSettings, a.breakpointSettings[n])),
                  !0 === e && (a.currentSlide = a.options.initialSlide),
                  a.refresh(e)),
              (r = n))
            : null !== a.activeBreakpoint &&
              ((a.activeBreakpoint = null),
              (a.options = a.originalSettings),
              !0 === e && (a.currentSlide = a.options.initialSlide),
              a.refresh(e),
              (r = n)),
            e || !1 === r || a.$slider.trigger('breakpoint', [a, r]));
        }
      }),
      (i.prototype.changeSlide = function (e, i) {
        var o,
          n,
          s = this,
          a = t(e.currentTarget);
        switch (
          (a.is('a') && e.preventDefault(),
          a.is('li') || (a = a.closest('li')),
          (o =
            s.slideCount % s.options.slidesToScroll != 0
              ? 0
              : (s.slideCount - s.currentSlide) % s.options.slidesToScroll),
          e.data.message)
        ) {
          case 'previous':
            ((n = 0 == o ? s.options.slidesToScroll : s.options.slidesToShow - o),
              s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - n, !1, i));
            break;
          case 'next':
            ((n = 0 == o ? s.options.slidesToScroll : o),
              s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + n, !1, i));
            break;
          case 'index':
            var r = 0 === e.data.index ? 0 : e.data.index || a.index() * s.options.slidesToScroll;
            (s.slideHandler(s.checkNavigable(r), !1, i), a.children().trigger('focus'));
            break;
          default:
            return;
        }
      }),
      (i.prototype.checkNavigable = function (t) {
        var e = this.getNavigableIndexes(),
          i = 0;
        if (t > e[e.length - 1]) t = e[e.length - 1];
        else
          for (var o in e) {
            if (t < e[o]) {
              t = i;
              break;
            }
            i = e[o];
          }
        return t;
      }),
      (i.prototype.cleanUpEvents = function () {
        var e = this;
        (e.options.autoplay &&
          e.options.useAutoplayToggleButton &&
          e.$pauseButton.off('click.slick', e.autoPlayToggleHandler),
          e.options.dots &&
            null !== e.$dots &&
            t('li', e.$dots)
              .off('click.slick', e.changeSlide)
              .off('mouseenter.slick', t.proxy(e.interrupt, e, !0))
              .off('mouseleave.slick', t.proxy(e.interrupt, e, !1)),
          e.$slider.off('focus.slick blur.slick'),
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow && e.$prevArrow.off('click.slick', e.changeSlide),
            e.$nextArrow && e.$nextArrow.off('click.slick', e.changeSlide)),
          e.$list.off('touchstart.slick mousedown.slick', e.swipeHandler),
          e.$list.off('touchmove.slick mousemove.slick', e.swipeHandler),
          e.$list.off('touchend.slick mouseup.slick', e.swipeHandler),
          e.$list.off('touchcancel.slick mouseleave.slick', e.swipeHandler),
          e.$list.off('click.slick', e.clickHandler),
          t(document).off(e.visibilityChange, e.visibility),
          e.cleanUpSlideEvents(),
          t(window).off('orientationchange.slick.slick-' + e.instanceUid, e.orientationChange),
          t(window).off('resize.slick.slick-' + e.instanceUid, e.resize),
          t('[draggable!=true]', e.$slideTrack).off('dragstart', e.preventDefault),
          t(window).off('load.slick.slick-' + e.instanceUid, e.setPosition));
      }),
      (i.prototype.cleanUpSlideEvents = function () {
        var e = this;
        (e.$list.off('mouseenter.slick', t.proxy(e.interrupt, e, !0)),
          e.$list.off('mouseleave.slick', t.proxy(e.interrupt, e, !1)));
      }),
      (i.prototype.cleanUpRows = function () {
        var t;
        0 < this.options.rows &&
          ((t = this.$slides.children().children()).removeAttr('style'),
          this.$slider.empty().append(t));
      }),
      (i.prototype.clickHandler = function (t) {
        !1 === this.shouldClick &&
          (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault());
      }),
      (i.prototype.destroy = function (e) {
        var i = this;
        (i.autoPlayClear(),
          (i.touchObject = {}),
          i.cleanUpEvents(),
          t('.slick-cloned', i.$slider).detach(),
          i.options.autoplay && i.options.useAutoplayToggleButton && i.$pauseButton.remove(),
          i.$dots && i.$dots.remove(),
          i.$prevArrow &&
            i.$prevArrow.length &&
            (i.$prevArrow
              .removeClass('slick-disabled slick-arrow slick-hidden')
              .prop('disabled', !1)
              .css('display', ''),
            i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()),
          i.$nextArrow &&
            i.$nextArrow.length &&
            (i.$nextArrow
              .removeClass('slick-disabled slick-arrow slick-hidden')
              .prop('disabled', !1)
              .css('display', ''),
            i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()),
          i.$slides &&
            (i.$slides
              .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
              .removeAttr('aria-hidden')
              .removeAttr('data-slick-index')
              .each(function () {
                t(this).attr('style', t(this).data('originalStyling'));
              }),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slideTrack.detach(),
            i.$list.detach(),
            i.$slider.append(i.$slides)),
          i.cleanUpRows(),
          i.$slider.removeClass('slick-slider'),
          i.$slider.removeClass('slick-initialized'),
          i.$slider.removeClass('slick-dotted'),
          (i.unslicked = !0),
          e || i.$slider.trigger('destroy', [i]));
      }),
      (i.prototype.disableTransition = function (t) {
        var e = {};
        ((e[this.transitionType] = ''),
          !1 === this.options.fade ? this.$slideTrack.css(e) : this.$slides.eq(t).css(e));
      }),
      (i.prototype.fadeSlide = function (t, e) {
        var i = this;
        !1 === i.cssTransitions
          ? (i.$slides.eq(t).css({ zIndex: i.options.zIndex }),
            i.$slides.eq(t).animate({ opacity: 1 }, i.options.speed, i.options.easing, e))
          : (i.applyTransition(t),
            i.$slides.eq(t).css({ opacity: 1, zIndex: i.options.zIndex }),
            e &&
              setTimeout(function () {
                (i.disableTransition(t), e.call());
              }, i.options.speed));
      }),
      (i.prototype.fadeSlideOut = function (t) {
        var e = this;
        !1 === e.cssTransitions
          ? e.$slides
              .eq(t)
              .animate(
                { opacity: 0, zIndex: e.options.zIndex - 2 },
                e.options.speed,
                e.options.easing,
              )
          : (e.applyTransition(t),
            e.$slides.eq(t).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
      }),
      (i.prototype.filterSlides = i.prototype.slickFilter =
        function (t) {
          var e = this;
          null !== t &&
            ((e.$slidesCache = e.$slides),
            e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.filter(t).appendTo(e.$slideTrack),
            e.reinit());
        }),
      (i.prototype.focusHandler = function () {
        var e = this;
        e.$slider
          .off('focus.slick blur.slick')
          .on('focus.slick', '*', function (i) {
            var o = t(this);
            setTimeout(function () {
              e.options.pauseOnFocus && o.is(':focus') && ((e.focussed = !0), e.autoPlay());
            }, 0);
          })
          .on('blur.slick', '*', function (i) {
            (t(this), e.options.pauseOnFocus && ((e.focussed = !1), e.autoPlay()));
          });
      }),
      (i.prototype.getCurrent = i.prototype.slickCurrentSlide =
        function () {
          return this.currentSlide;
        }),
      (i.prototype.getDotCount = function () {
        var t = this,
          e = 0,
          i = 0,
          o = 0;
        if (!0 === t.options.infinite)
          if (t.slideCount <= t.options.slidesToShow) ++o;
          else
            for (; e < t.slideCount; )
              (++o,
                (e = i + t.options.slidesToScroll),
                (i +=
                  t.options.slidesToScroll <= t.options.slidesToShow
                    ? t.options.slidesToScroll
                    : t.options.slidesToShow));
        else if (!0 === t.options.centerMode) o = t.slideCount;
        else if (t.options.asNavFor)
          for (; e < t.slideCount; )
            (++o,
              (e = i + t.options.slidesToScroll),
              (i +=
                t.options.slidesToScroll <= t.options.slidesToShow
                  ? t.options.slidesToScroll
                  : t.options.slidesToShow));
        else o = 1 + Math.ceil((t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll);
        return o - 1;
      }),
      (i.prototype.getLeft = function (t) {
        var e,
          i,
          o,
          n,
          s = this,
          a = 0;
        return (
          (s.slideOffset = 0),
          (i = s.$slides.first().outerHeight(!0)),
          !0 === s.options.infinite
            ? (s.slideCount > s.options.slidesToShow &&
                ((s.slideOffset = s.slideWidth * s.options.slidesToShow * -1),
                (n = -1),
                !0 === s.options.vertical &&
                  !0 === s.options.centerMode &&
                  (2 === s.options.slidesToShow
                    ? (n = -1.5)
                    : 1 === s.options.slidesToShow && (n = -2)),
                (a = i * s.options.slidesToShow * n)),
              s.slideCount % s.options.slidesToScroll != 0 &&
                t + s.options.slidesToScroll > s.slideCount &&
                s.slideCount > s.options.slidesToShow &&
                (a =
                  t > s.slideCount
                    ? ((s.slideOffset =
                        (s.options.slidesToShow - (t - s.slideCount)) * s.slideWidth * -1),
                      (s.options.slidesToShow - (t - s.slideCount)) * i * -1)
                    : ((s.slideOffset =
                        (s.slideCount % s.options.slidesToScroll) * s.slideWidth * -1),
                      (s.slideCount % s.options.slidesToScroll) * i * -1)))
            : t + s.options.slidesToShow > s.slideCount &&
              ((s.slideOffset = (t + s.options.slidesToShow - s.slideCount) * s.slideWidth),
              (a = (t + s.options.slidesToShow - s.slideCount) * i)),
          s.slideCount <= s.options.slidesToShow && (a = s.slideOffset = 0),
          !0 === s.options.centerMode && s.slideCount <= s.options.slidesToShow
            ? (s.slideOffset =
                (s.slideWidth * Math.floor(s.options.slidesToShow)) / 2 -
                (s.slideWidth * s.slideCount) / 2)
            : !0 === s.options.centerMode && !0 === s.options.infinite
              ? (s.slideOffset +=
                  s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth)
              : !0 === s.options.centerMode &&
                ((s.slideOffset = 0),
                (s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2))),
          (e = !1 === s.options.vertical ? t * s.slideWidth * -1 + s.slideOffset : t * i * -1 + a),
          !0 === s.options.variableWidth &&
            ((o =
              s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite
                ? s.$slideTrack.children('.slick-slide').eq(t)
                : s.$slideTrack.children('.slick-slide').eq(t + s.options.slidesToShow)),
            (e =
              !0 === s.options.rtl
                ? o[0]
                  ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                  ? -1 * o[0].offsetLeft
                  : 0),
            !0 === s.options.centerMode &&
              ((o =
                s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite
                  ? s.$slideTrack.children('.slick-slide').eq(t)
                  : s.$slideTrack.children('.slick-slide').eq(t + s.options.slidesToShow + 1)),
              (e =
                !0 === s.options.rtl
                  ? o[0]
                    ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width())
                    : 0
                  : o[0]
                    ? -1 * o[0].offsetLeft
                    : 0),
              (e += (s.$list.width() - o.outerWidth()) / 2))),
          e
        );
      }),
      (i.prototype.getOption = i.prototype.slickGetOption =
        function (t) {
          return this.options[t];
        }),
      (i.prototype.getNavigableIndexes = function () {
        for (
          var t = this,
            e = 0,
            i = 0,
            o = [],
            n =
              !1 === t.options.infinite
                ? t.slideCount
                : ((e = -1 * t.options.slidesToScroll),
                  (i = -1 * t.options.slidesToScroll),
                  2 * t.slideCount);
          e < n;

        )
          (o.push(e),
            (e = i + t.options.slidesToScroll),
            (i +=
              t.options.slidesToScroll <= t.options.slidesToShow
                ? t.options.slidesToScroll
                : t.options.slidesToShow));
        return o;
      }),
      (i.prototype.getSlick = function () {
        return this;
      }),
      (i.prototype.getSlideCount = function () {
        var e,
          i = this,
          o = !0 === i.options.centerMode ? Math.floor(i.$list.width() / 2) : 0,
          n = -1 * i.swipeLeft + o;
        return !0 === i.options.swipeToSlide
          ? (i.$slideTrack.find('.slick-slide').each(function (o, s) {
              var a = t(s).outerWidth(),
                r = s.offsetLeft;
              if ((!0 !== i.options.centerMode && (r += a / 2), n < r + a)) return ((e = s), !1);
            }),
            Math.abs(t(e).attr('data-slick-index') - i.currentSlide) || 1)
          : i.options.slidesToScroll;
      }),
      (i.prototype.goTo = i.prototype.slickGoTo =
        function (t, e) {
          this.changeSlide({ data: { message: 'index', index: parseInt(t) } }, e);
        }),
      (i.prototype.init = function (e) {
        var i = this;
        (t(i.$slider).hasClass('slick-initialized') ||
          (t(i.$slider).addClass('slick-initialized'),
          i.buildRows(),
          i.buildOut(),
          i.setProps(),
          i.startLoad(),
          i.loadSlider(),
          i.initializeEvents(),
          i.updateArrows(),
          i.updateDots(),
          i.checkResponsive(!0),
          i.focusHandler()),
          e && i.$slider.trigger('init', [i]),
          i.options.autoplay && ((i.paused = !1), i.autoPlay()),
          i.updateSlideVisibility(),
          null != i.options.accessibility &&
            console.warn('accessibility setting is no longer supported.'),
          null != i.options.focusOnChange && console.warn('focusOnChange is no longer supported.'),
          null != i.options.focusOnSelect && console.warn('focusOnSelect is no longer supported.'));
      }),
      (i.prototype.initArrowEvents = function () {
        var t = this;
        !0 === t.options.arrows &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow
            .off('click.slick')
            .on('click.slick', { message: 'previous' }, t.changeSlide),
          t.$nextArrow.off('click.slick').on('click.slick', { message: 'next' }, t.changeSlide));
      }),
      (i.prototype.initDotEvents = function () {
        var e = this;
        (!0 === e.options.dots &&
          e.slideCount > e.options.slidesToShow &&
          t('li', e.$dots).on('click.slick', { message: 'index' }, e.changeSlide),
          !0 === e.options.dots &&
            !0 === e.options.pauseOnDotsHover &&
            e.slideCount > e.options.slidesToShow &&
            t('li', e.$dots)
              .on('mouseenter.slick', t.proxy(e.interrupt, e, !0))
              .on('mouseleave.slick', t.proxy(e.interrupt, e, !1)));
      }),
      (i.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover &&
          (e.$list.on('mouseenter.slick', t.proxy(e.interrupt, e, !0)),
          e.$list.on('mouseleave.slick', t.proxy(e.interrupt, e, !1)));
      }),
      (i.prototype.initializeEvents = function () {
        var e = this;
        (e.initArrowEvents(),
          e.initDotEvents(),
          e.initSlideEvents(),
          e.options.autoplay &&
            e.options.useAutoplayToggleButton &&
            e.$pauseButton.on('click.slick', e.autoPlayToggleHandler),
          e.$list.on('touchstart.slick mousedown.slick', { action: 'start' }, e.swipeHandler),
          e.$list.on('touchmove.slick mousemove.slick', { action: 'move' }, e.swipeHandler),
          e.$list.on('touchend.slick mouseup.slick', { action: 'end' }, e.swipeHandler),
          e.$list.on('touchcancel.slick mouseleave.slick', { action: 'end' }, e.swipeHandler),
          e.$list.on('click.slick', e.clickHandler),
          t(document).on(e.visibilityChange, t.proxy(e.visibility, e)),
          t(window).on(
            'orientationchange.slick.slick-' + e.instanceUid,
            t.proxy(e.orientationChange, e),
          ),
          t(window).on('resize.slick.slick-' + e.instanceUid, t.proxy(e.resize, e)),
          t('[draggable!=true]', e.$slideTrack).on('dragstart', e.preventDefault),
          t(window).on('load.slick.slick-' + e.instanceUid, e.setPosition),
          t(e.setPosition));
      }),
      (i.prototype.initUI = function () {
        var t = this;
        (!0 === t.options.arrows &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow.show(), t.$nextArrow.show()),
          !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.show());
      }),
      (i.prototype.lazyLoad = function () {
        var e,
          i,
          o,
          n = this;
        function s(e) {
          t('img[data-lazy]', e).each(function () {
            var e = t(this),
              i = t(this).attr('data-lazy'),
              o = t(this).attr('data-srcset'),
              s = t(this).attr('data-sizes') || n.$slider.attr('data-sizes'),
              a = document.createElement('img');
            ((a.onload = function () {
              e.animate({ opacity: 0 }, 100, function () {
                (o && (e.attr('srcset', o), s && e.attr('sizes', s)),
                  e.attr('src', i).animate({ opacity: 1 }, 200, function () {
                    e.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                  }),
                  n.$slider.trigger('lazyLoaded', [n, e, i]));
              });
            }),
              (a.onerror = function () {
                (e
                  .removeAttr('data-lazy')
                  .removeClass('slick-loading')
                  .addClass('slick-lazyload-error'),
                  n.$slider.trigger('lazyLoadError', [n, e, i]));
              }),
              (a.src = i));
          });
        }
        if (
          (!0 === n.options.centerMode
            ? (o =
                !0 === n.options.infinite
                  ? (i = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                    n.options.slidesToShow +
                    2
                  : ((i = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1))),
                    n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
            : ((i = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide),
              (o = Math.ceil(i + n.options.slidesToShow)),
              !0 === n.options.fade && (0 < i && i--, o <= n.slideCount && o++)),
          (e = n.$slider.find('.slick-slide').slice(i, o)),
          'anticipated' === n.options.lazyLoad)
        )
          for (
            var a = i - 1, r = o, l = n.$slider.find('.slick-slide'), c = 0;
            c < n.options.slidesToScroll;
            c++
          )
            (a < 0 && (a = n.slideCount - 1), (e = (e = e.add(l.eq(a))).add(l.eq(r))), a--, r++);
        (s(e),
          n.slideCount <= n.options.slidesToShow
            ? s(n.$slider.find('.slick-slide'))
            : n.currentSlide >= n.slideCount - n.options.slidesToShow
              ? s(n.$slider.find('.slick-cloned').slice(0, n.options.slidesToShow))
              : 0 === n.currentSlide &&
                s(n.$slider.find('.slick-cloned').slice(-1 * n.options.slidesToShow)));
      }),
      (i.prototype.loadSlider = function () {
        var t = this;
        (t.setPosition(),
          t.$slideTrack.css({ opacity: 1 }),
          t.$slider.removeClass('slick-loading'),
          t.initUI(),
          'progressive' === t.options.lazyLoad && t.progressiveLazyLoad());
      }),
      (i.prototype.next = i.prototype.slickNext =
        function () {
          this.changeSlide({ data: { message: 'next' } });
        }),
      (i.prototype.orientationChange = function () {
        (this.checkResponsive(), this.setPosition());
      }),
      (i.prototype.pause = i.prototype.slickPause =
        function () {
          (this.autoPlayClear(), (this.paused = !0));
        }),
      (i.prototype.play = i.prototype.slickPlay =
        function () {
          var t = this;
          (t.autoPlay(),
            (t.options.autoplay = !0),
            (t.paused = !1),
            (t.focussed = !1),
            (t.interrupted = !1));
        }),
      (i.prototype.postSlide = function (t) {
        var e = this;
        e.unslicked ||
          (e.$slider.trigger('afterChange', [e, t]),
          (e.animating = !1),
          e.slideCount > e.options.slidesToShow && e.setPosition(),
          (e.swipeLeft = null),
          e.options.autoplay && e.autoPlay(),
          e.updateSlideVisibility());
      }),
      (i.prototype.prev = i.prototype.slickPrev =
        function () {
          this.changeSlide({ data: { message: 'previous' } });
        }),
      (i.prototype.preventDefault = function (t) {
        t.preventDefault();
      }),
      (i.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var i,
          o,
          n,
          s,
          a,
          r = this,
          l = t('img[data-lazy]', r.$slider);
        l.length
          ? ((i = l.first()),
            (o = i.attr('data-lazy')),
            (n = i.attr('data-srcset')),
            (s = i.attr('data-sizes') || r.$slider.attr('data-sizes')),
            ((a = document.createElement('img')).onload = function () {
              (n && (i.attr('srcset', n), s && i.attr('sizes', s)),
                i
                  .attr('src', o)
                  .removeAttr('data-lazy data-srcset data-sizes')
                  .removeClass('slick-loading'),
                !0 === r.options.adaptiveHeight && r.setPosition(),
                r.$slider.trigger('lazyLoaded', [r, i, o]),
                r.progressiveLazyLoad());
            }),
            (a.onerror = function () {
              e < 3
                ? setTimeout(function () {
                    r.progressiveLazyLoad(e + 1);
                  }, 500)
                : (i
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading')
                    .addClass('slick-lazyload-error'),
                  r.$slider.trigger('lazyLoadError', [r, i, o]),
                  r.progressiveLazyLoad());
            }),
            (a.src = o))
          : r.$slider.trigger('allImagesLoaded', [r]);
      }),
      (i.prototype.refresh = function (e) {
        var i,
          o = this,
          n = o.slideCount - o.options.slidesToShow;
        (!o.options.infinite && o.currentSlide > n && (o.currentSlide = n),
          o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
          (i = o.currentSlide),
          o.destroy(!0),
          t.extend(o, o.initials, { currentSlide: i }),
          o.init(),
          e || o.changeSlide({ data: { message: 'index', index: i } }, !1));
      }),
      (i.prototype.registerBreakpoints = function () {
        var e,
          i,
          o,
          n = this,
          s = n.options.responsive || null;
        if ('array' === t.type(s) && s.length) {
          for (e in ((n.respondTo = n.options.respondTo || 'window'), s))
            if (((o = n.breakpoints.length - 1), s.hasOwnProperty(e))) {
              for (i = s[e].breakpoint; 0 <= o; )
                (n.breakpoints[o] && n.breakpoints[o] === i && n.breakpoints.splice(o, 1), o--);
              (n.breakpoints.push(i), (n.breakpointSettings[i] = s[e].settings));
            }
          n.breakpoints.sort(function (t, e) {
            return n.options.mobileFirst ? t - e : e - t;
          });
        }
      }),
      (i.prototype.reinit = function () {
        var t = this;
        ((t.$slides = t.$slideTrack.children(t.options.slide).addClass('slick-slide')),
          (t.slideCount = t.$slides.length),
          t.currentSlide >= t.slideCount &&
            0 !== t.currentSlide &&
            (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
          t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
          t.registerBreakpoints(),
          t.setProps(),
          t.setupInfinite(),
          t.buildArrows(),
          t.updateArrows(),
          t.initArrowEvents(),
          t.buildDots(),
          t.updateDots(),
          t.initDotEvents(),
          t.cleanUpSlideEvents(),
          t.initSlideEvents(),
          t.checkResponsive(!1, !0),
          t.setSlideClasses('number' == typeof t.currentSlide ? t.currentSlide : 0),
          t.setPosition(),
          t.focusHandler(),
          (t.paused = !t.options.autoplay),
          t.autoPlay(),
          t.$slider.trigger('reInit', [t]));
      }),
      (i.prototype.resize = function () {
        var e = this;
        t(window).width() !== e.windowWidth &&
          (clearTimeout(e.windowDelay),
          (e.windowDelay = window.setTimeout(function () {
            ((e.windowWidth = t(window).width()),
              e.checkResponsive(),
              e.unslicked || e.setPosition());
          }, 50)));
      }),
      (i.prototype.removeSlide = i.prototype.slickRemove =
        function (t, e, i) {
          var o = this;
          if (
            ((t =
              'boolean' == typeof t ? (!0 === (e = t) ? 0 : o.slideCount - 1) : !0 === e ? --t : t),
            o.slideCount < 1 || t < 0 || t > o.slideCount - 1)
          )
            return !1;
          (o.unload(),
            !0 === i
              ? o.$slideTrack.children().remove()
              : o.$slideTrack.children(this.options.slide).eq(t).remove(),
            (o.$slides = o.$slideTrack.children(this.options.slide)),
            o.$slideTrack.children(this.options.slide).detach(),
            o.$slideTrack.append(o.$slides),
            (o.$slidesCache = o.$slides),
            o.reinit());
        }),
      (i.prototype.setCSS = function (t) {
        var e,
          i,
          o = this,
          n = {};
        (!0 === o.options.rtl && (t = -t),
          (e = 'left' == o.positionProp ? Math.ceil(t) + 'px' : '0px'),
          (i = 'top' == o.positionProp ? Math.ceil(t) + 'px' : '0px'),
          (n[o.positionProp] = t),
          !1 === o.transformsEnabled ||
            (!(n = {}) === o.cssTransitions
              ? (n[o.animType] = 'translate(' + e + ', ' + i + ')')
              : (n[o.animType] = 'translate3d(' + e + ', ' + i + ', 0px)')),
          o.$slideTrack.css(n));
      }),
      (i.prototype.setDimensions = function () {
        var t = this;
        (!1 === t.options.vertical
          ? !0 === t.options.centerMode &&
            t.$list.css({ padding: '0px ' + t.options.centerPadding })
          : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow),
            !0 === t.options.centerMode &&
              t.$list.css({ padding: t.options.centerPadding + ' 0px' })),
          (t.listWidth = t.$list.width()),
          (t.listHeight = t.$list.height()),
          !1 === t.options.vertical && !1 === t.options.variableWidth
            ? ((t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow)),
              t.$slideTrack.width(
                Math.ceil(t.slideWidth * t.$slideTrack.children('.slick-slide').length),
              ))
            : !0 === t.options.variableWidth
              ? t.$slideTrack.width(5e3 * t.slideCount)
              : ((t.slideWidth = Math.ceil(t.listWidth)),
                t.$slideTrack.height(
                  Math.ceil(
                    t.$slides.first().outerHeight(!0) *
                      t.$slideTrack.children('.slick-slide').length,
                  ),
                )));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        !1 === t.options.variableWidth &&
          t.$slideTrack.children('.slick-slide').width(t.slideWidth - e);
      }),
      (i.prototype.setFade = function () {
        var e,
          i = this;
        (i.$slides.each(function (o, n) {
          ((e = i.slideWidth * o * -1),
            !0 === i.options.rtl
              ? t(n).css({
                  position: 'relative',
                  right: e,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0,
                })
              : t(n).css({
                  position: 'relative',
                  left: e,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0,
                }));
        }),
          i.$slides.eq(i.currentSlide).css({ zIndex: i.options.zIndex - 1, opacity: 1 }));
      }),
      (i.prototype.setHeight = function () {
        var t,
          e = this;
        1 === e.options.slidesToShow &&
          !0 === e.options.adaptiveHeight &&
          !1 === e.options.vertical &&
          ((t = e.$slides.eq(e.currentSlide).outerHeight(!0)), e.$list.css('height', t));
      }),
      (i.prototype.setOption = i.prototype.slickSetOption =
        function () {
          var e,
            i,
            o,
            n,
            s,
            a = this,
            r = !1;
          if (
            ('object' === t.type(arguments[0])
              ? ((o = arguments[0]), (r = arguments[1]), (s = 'multiple'))
              : 'string' === t.type(arguments[0]) &&
                ((n = arguments[1]),
                (r = arguments[2]),
                'responsive' === (o = arguments[0]) && 'array' === t.type(arguments[1])
                  ? (s = 'responsive')
                  : void 0 !== arguments[1] && (s = 'single')),
            'single' === s)
          )
            a.options[o] = n;
          else if ('multiple' === s)
            t.each(o, function (t, e) {
              a.options[t] = e;
            });
          else if ('responsive' === s)
            for (i in n)
              if ('array' !== t.type(a.options.responsive)) a.options.responsive = [n[i]];
              else {
                for (e = a.options.responsive.length - 1; 0 <= e; )
                  (a.options.responsive[e].breakpoint === n[i].breakpoint &&
                    a.options.responsive.splice(e, 1),
                    e--);
                a.options.responsive.push(n[i]);
              }
          r && (a.unload(), a.reinit());
        }),
      (i.prototype.setPosition = function () {
        var t = this;
        (t.setDimensions(),
          t.setHeight(),
          !1 === t.options.fade ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(),
          t.$slider.trigger('setPosition', [t]));
      }),
      (i.prototype.setProps = function () {
        var t = this,
          e = document.body.style;
        ((t.positionProp = !0 === t.options.vertical ? 'top' : 'left'),
          'top' === t.positionProp
            ? t.$slider.addClass('slick-vertical')
            : t.$slider.removeClass('slick-vertical'),
          (void 0 === e.WebkitTransition &&
            void 0 === e.MozTransition &&
            void 0 === e.msTransition) ||
            (!0 === t.options.useCSS && (t.cssTransitions = !0)),
          t.options.fade &&
            ('number' == typeof t.options.zIndex
              ? t.options.zIndex < 3 && (t.options.zIndex = 3)
              : (t.options.zIndex = t.defaults.zIndex)),
          void 0 !== e.OTransform &&
            ((t.animType = 'OTransform'),
            (t.transformType = '-o-transform'),
            (t.transitionType = 'OTransition'),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (t.animType = !1)),
          void 0 !== e.MozTransform &&
            ((t.animType = 'MozTransform'),
            (t.transformType = '-moz-transform'),
            (t.transitionType = 'MozTransition'),
            void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)),
          void 0 !== e.webkitTransform &&
            ((t.animType = 'webkitTransform'),
            (t.transformType = '-webkit-transform'),
            (t.transitionType = 'webkitTransition'),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (t.animType = !1)),
          void 0 !== e.msTransform &&
            ((t.animType = 'msTransform'),
            (t.transformType = '-ms-transform'),
            (t.transitionType = 'msTransition'),
            void 0 === e.msTransform && (t.animType = !1)),
          void 0 !== e.transform &&
            !1 !== t.animType &&
            ((t.animType = 'transform'),
            (t.transformType = 'transform'),
            (t.transitionType = 'transition')),
          (t.transformsEnabled =
            t.options.useTransform && null !== t.animType && !1 !== t.animType));
      }),
      (i.prototype.setSlideClasses = function (e) {
        var i,
          o,
          n,
          s,
          a = this,
          r = a.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true')
            .attr('aria-label', function () {
              return t(this).attr('aria-label').replace(' (centered)', '');
            });
        (a.$slides.eq(e).addClass('slick-current'),
          !0 === a.options.centerMode
            ? ((n = a.options.slidesToShow % 2 == 0 ? 1 : 0),
              (s = Math.floor(a.options.slidesToShow / 2)),
              !0 === a.options.infinite &&
                (s <= e && e <= a.slideCount - 1 - s
                  ? a.$slides
                      .slice(e - s + n, e + s + 1)
                      .addClass('slick-active')
                      .removeAttr('aria-hidden')
                  : ((i = a.options.slidesToShow + e),
                    r
                      .slice(i - s + 1 + n, i + s + 2)
                      .addClass('slick-active')
                      .removeAttr('aria-hidden')),
                0 === e
                  ? r
                      .eq(a.options.slidesToShow + a.slideCount + 1)
                      .addClass('slick-center')
                      .attr('aria-label', function () {
                        return t(this).attr('aria-label') + ' (centered)';
                      })
                  : e === a.slideCount - 1 &&
                    r
                      .eq(a.options.slidesToShow)
                      .addClass('slick-center')
                      .attr('aria-label', function () {
                        return t(this).attr('aria-label') + ' (centered)';
                      })),
              a.$slides
                .eq(e)
                .addClass('slick-center')
                .attr('aria-label', function () {
                  return t(this).attr('aria-label') + ' (centered)';
                }))
            : 0 <= e && e <= a.slideCount - a.options.slidesToShow
              ? a.$slides
                  .slice(e, e + a.options.slidesToShow)
                  .addClass('slick-active')
                  .removeAttr('aria-hidden')
              : r.length <= a.options.slidesToShow
                ? r.addClass('slick-active').removeAttr('aria-hidden')
                : ((o = a.slideCount % a.options.slidesToShow),
                  (i = !0 === a.options.infinite ? a.options.slidesToShow + e : e),
                  a.options.slidesToShow == a.options.slidesToScroll &&
                  a.slideCount - e < a.options.slidesToShow
                    ? r
                        .slice(i - (a.options.slidesToShow - o), i + o)
                        .addClass('slick-active')
                        .removeAttr('aria-hidden')
                    : r
                        .slice(i, i + a.options.slidesToShow)
                        .addClass('slick-active')
                        .removeAttr('aria-hidden')),
          ('ondemand' !== a.options.lazyLoad && 'anticipated' !== a.options.lazyLoad) ||
            a.lazyLoad());
      }),
      (i.prototype.setupInfinite = function () {
        var e,
          i,
          o,
          n = this;
        if (
          (!0 === n.options.fade && (n.options.centerMode = !1),
          !0 === n.options.infinite &&
            !1 === n.options.fade &&
            ((i = null), n.slideCount > n.options.slidesToShow))
        ) {
          for (
            o = !0 === n.options.centerMode ? n.options.slidesToShow + 1 : n.options.slidesToShow,
              e = n.slideCount;
            e > n.slideCount - o;
            --e
          )
            ((i = e - 1),
              t(n.$slides[i])
                .clone(!0)
                .attr('id', '')
                .attr('data-slick-index', i - n.slideCount)
                .prependTo(n.$slideTrack)
                .addClass('slick-cloned'));
          for (e = 0; e < o + n.slideCount; e += 1)
            ((i = e),
              t(n.$slides[i])
                .clone(!0)
                .attr('id', '')
                .attr('data-slick-index', i + n.slideCount)
                .appendTo(n.$slideTrack)
                .addClass('slick-cloned'));
          n.$slideTrack
            .find('.slick-cloned')
            .find('[id]')
            .each(function () {
              t(this).attr('id', '');
            });
        }
      }),
      (i.prototype.interrupt = function (t) {
        (t || this.autoPlay(), (this.interrupted = t));
      }),
      (i.prototype.selectHandler = function (e) {
        var i = t(e.target).is('.slick-slide') ? t(e.target) : t(e.target).parents('.slick-slide'),
          o = (o = parseInt(i.attr('data-slick-index'))) || 0;
        this.slideCount <= this.options.slidesToShow
          ? this.slideHandler(o, !1, !0)
          : this.slideHandler(o);
      }),
      (i.prototype.slideHandler = function (t, e, i) {
        var o,
          n,
          s,
          a,
          r,
          l,
          c = this;
        if (
          ((e = e || !1),
          !(
            (!0 === c.animating && !0 === c.options.waitForAnimate) ||
            (!0 === c.options.fade && c.currentSlide === t)
          ))
        )
          if (
            (!1 === e && c.asNavFor(t),
            (o = t),
            (r = c.getLeft(o)),
            (a = c.getLeft(c.currentSlide)),
            (c.currentLeft = null === c.swipeLeft ? a : c.swipeLeft),
            !1 === c.options.infinite &&
              !1 === c.options.centerMode &&
              (t < 0 || t > c.getDotCount() * c.options.slidesToScroll))
          )
            !1 === c.options.fade &&
              ((o = c.currentSlide),
              !0 !== i && c.slideCount > c.options.slidesToShow
                ? c.animateSlide(a, function () {
                    c.postSlide(o);
                  })
                : c.postSlide(o));
          else if (
            !1 === c.options.infinite &&
            !0 === c.options.centerMode &&
            (t < 0 || t > c.slideCount - c.options.slidesToScroll)
          )
            !1 === c.options.fade &&
              ((o = c.currentSlide),
              !0 !== i && c.slideCount > c.options.slidesToShow
                ? c.animateSlide(a, function () {
                    c.postSlide(o);
                  })
                : c.postSlide(o));
          else {
            if (
              (c.options.autoplay && clearInterval(c.autoPlayTimer),
              (n =
                o < 0
                  ? c.slideCount % c.options.slidesToScroll != 0
                    ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                    : c.slideCount + o
                  : o >= c.slideCount
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? 0
                      : o - c.slideCount
                    : o),
              (c.animating = !0),
              c.$slider.trigger('beforeChange', [c, c.currentSlide, n]),
              (s = c.currentSlide),
              (c.currentSlide = n),
              c.setSlideClasses(c.currentSlide),
              c.options.asNavFor &&
                (l = (l = c.getNavTarget()).slick('getSlick')).slideCount <=
                  l.options.slidesToShow &&
                l.setSlideClasses(c.currentSlide),
              c.updateDots(),
              c.updateArrows(),
              !0 === c.options.fade)
            )
              return (
                !0 !== i
                  ? (c.fadeSlideOut(s),
                    c.fadeSlide(n, function () {
                      c.postSlide(n);
                    }))
                  : c.postSlide(n),
                void c.animateHeight()
              );
            !0 !== i && c.slideCount > c.options.slidesToShow
              ? c.animateSlide(r, function () {
                  c.postSlide(n);
                })
              : c.postSlide(n);
          }
      }),
      (i.prototype.startLoad = function () {
        var t = this;
        (!0 === t.options.arrows &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow.hide(), t.$nextArrow.hide()),
          !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.hide(),
          t.$slider.addClass('slick-loading'));
      }),
      (i.prototype.swipeDirection = function () {
        var t = this,
          e = t.touchObject.startX - t.touchObject.curX,
          i = t.touchObject.startY - t.touchObject.curY,
          o = Math.atan2(i, e),
          n = Math.round((180 * o) / Math.PI);
        return (
          n < 0 && (n = 360 - Math.abs(n)),
          (n <= 45 && 0 <= n) || (n <= 360 && 315 <= n)
            ? !1 === t.options.rtl
              ? 'left'
              : 'right'
            : 135 <= n && n <= 225
              ? !1 === t.options.rtl
                ? 'right'
                : 'left'
              : !0 === t.options.verticalSwiping
                ? 35 <= n && n <= 135
                  ? 'down'
                  : 'up'
                : 'vertical'
        );
      }),
      (i.prototype.swipeEnd = function (t) {
        var e,
          i,
          o = this;
        if (((o.dragging = !1), (o.swiping = !1), o.scrolling)) return (o.scrolling = !1);
        if (
          ((o.interrupted = !1),
          (o.shouldClick = !(10 < o.touchObject.swipeLength)),
          void 0 === o.touchObject.curX)
        )
          return !1;
        if (
          (!0 === o.touchObject.edgeHit && o.$slider.trigger('edge', [o, o.swipeDirection()]),
          o.touchObject.swipeLength >= o.touchObject.minSwipe)
        ) {
          switch ((i = o.swipeDirection())) {
            case 'left':
            case 'down':
              ((e = o.options.swipeToSlide
                ? o.checkNavigable(o.currentSlide + o.getSlideCount())
                : o.currentSlide + o.getSlideCount()),
                (o.currentDirection = 0));
              break;
            case 'right':
            case 'up':
              ((e = o.options.swipeToSlide
                ? o.checkNavigable(o.currentSlide - o.getSlideCount())
                : o.currentSlide - o.getSlideCount()),
                (o.currentDirection = 1));
          }
          'vertical' != i &&
            (o.slideHandler(e), (o.touchObject = {}), o.$slider.trigger('swipe', [o, i]));
        } else
          o.touchObject.startX !== o.touchObject.curX &&
            (o.slideHandler(o.currentSlide), (o.touchObject = {}));
      }),
      (i.prototype.swipeHandler = function (t) {
        var e = this;
        if (
          !(
            !1 === e.options.swipe ||
            ('ontouchend' in document && !1 === e.options.swipe) ||
            (!1 === e.options.draggable && -1 !== t.type.indexOf('mouse'))
          )
        )
          switch (
            ((e.touchObject.fingerCount =
              t.originalEvent && void 0 !== t.originalEvent.touches
                ? t.originalEvent.touches.length
                : 1),
            (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
            !0 === e.options.verticalSwiping &&
              (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
            t.data.action)
          ) {
            case 'start':
              e.swipeStart(t);
              break;
            case 'move':
              e.swipeMove(t);
              break;
            case 'end':
              e.swipeEnd(t);
          }
      }),
      (i.prototype.swipeMove = function (t) {
        var e,
          i,
          o,
          n,
          s,
          a = this,
          r = void 0 !== t.originalEvent ? t.originalEvent.touches : null;
        return (
          !(!a.dragging || a.scrolling || (r && 1 !== r.length)) &&
          ((e = a.getLeft(a.currentSlide)),
          (a.touchObject.curX = void 0 !== r ? r[0].pageX : t.clientX),
          (a.touchObject.curY = void 0 !== r ? r[0].pageY : t.clientY),
          (a.touchObject.swipeLength = Math.round(
            Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2)),
          )),
          (s = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2)))),
          !a.options.verticalSwiping && !a.swiping && 4 < s
            ? !(a.scrolling = !0)
            : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = s),
              (i = a.swipeDirection()),
              void 0 !== t.originalEvent &&
                4 < a.touchObject.swipeLength &&
                ((a.swiping = !0), t.preventDefault()),
              (n =
                (!1 === a.options.rtl ? 1 : -1) *
                (a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
              !0 === a.options.verticalSwiping &&
                (n = a.touchObject.curY > a.touchObject.startY ? 1 : -1),
              (o = a.touchObject.swipeLength),
              (a.touchObject.edgeHit = !1) === a.options.infinite &&
                ((0 === a.currentSlide && 'right' === i) ||
                  (a.currentSlide >= a.getDotCount() && 'left' === i)) &&
                ((o = a.touchObject.swipeLength * a.options.edgeFriction),
                (a.touchObject.edgeHit = !0)),
              !1 === a.options.vertical
                ? (a.swipeLeft = e + o * n)
                : (a.swipeLeft = e + o * (a.$list.height() / a.listWidth) * n),
              !0 === a.options.verticalSwiping && (a.swipeLeft = e + o * n),
              !0 !== a.options.fade &&
                !1 !== a.options.touchMove &&
                (!0 === a.animating ? ((a.swipeLeft = null), !1) : void a.setCSS(a.swipeLeft))))
        );
      }),
      (i.prototype.swipeStart = function (t) {
        var e,
          i = this;
        if (
          ((i.interrupted = !0),
          1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow)
        )
          return !(i.touchObject = {});
        (void 0 !== t.originalEvent &&
          void 0 !== t.originalEvent.touches &&
          (e = t.originalEvent.touches[0]),
          (i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX),
          (i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY),
          (i.dragging = !0));
      }),
      (i.prototype.unfilterSlides = i.prototype.slickUnfilter =
        function () {
          var t = this;
          null !== t.$slidesCache &&
            (t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.appendTo(t.$slideTrack),
            t.reinit());
        }),
      (i.prototype.unload = function () {
        var e = this;
        (t('.slick-cloned', e.$slider).remove(),
          e.$dots && e.$dots.remove(),
          e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
          e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
          e.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', ''));
      }),
      (i.prototype.unslick = function (t) {
        (this.$slider.trigger('unslick', [this, t]), this.destroy());
      }),
      (i.prototype.updateArrows = function () {
        var t = this;
        (Math.floor(t.options.slidesToShow / 2),
          !0 === t.options.arrows &&
            t.slideCount > t.options.slidesToShow &&
            !t.options.infinite &&
            (t.$prevArrow.removeClass('slick-disabled').prop('disabled', !1),
            t.$nextArrow.removeClass('slick-disabled').prop('disabled', !1),
            0 === t.currentSlide
              ? (t.$prevArrow.addClass('slick-disabled').prop('disabled', !0),
                t.$nextArrow.removeClass('slick-disabled').prop('disabled', !1))
              : ((t.currentSlide >= t.slideCount - t.options.slidesToShow &&
                  !1 === t.options.centerMode) ||
                  (t.currentSlide >= t.slideCount - 1 && !0 === t.options.centerMode)) &&
                (t.$nextArrow.addClass('slick-disabled').prop('disabled', !0),
                t.$prevArrow.removeClass('slick-disabled').prop('disabled', !1))));
      }),
      (i.prototype.updateDots = function () {
        var t = this;
        null !== t.$dots &&
          (t.$dots
            .find('li')
            .removeClass('slick-active')
            .find('button')
            .removeAttr('aria-current')
            .end()
            .end(),
          t.$dots
            .find('li')
            .eq(Math.floor(t.currentSlide / t.options.slidesToScroll))
            .addClass('slick-active')
            .find('button')
            .attr('aria-current', !0)
            .end()
            .end());
      }),
      (i.prototype.updateSlideVisibility = function () {
        (this.$slideTrack
          .find('.slick-slide')
          .attr('aria-hidden', 'true')
          .find('a, input, button, select')
          .attr('tabindex', '-1'),
          this.$slideTrack
            .find('.slick-active')
            .removeAttr('aria-hidden')
            .find('a, input, button, select')
            .removeAttr('tabindex'));
      }),
      (i.prototype.visibility = function () {
        this.options.autoplay &&
          (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1));
      }),
      (t.fn.slick = function () {
        for (
          var t,
            e = this,
            o = arguments[0],
            n = Array.prototype.slice.call(arguments, 1),
            s = e.length,
            a = 0;
          a < s;
          a++
        )
          if (
            ('object' == typeof o || void 0 === o
              ? (e[a].slick = new i(e[a], o))
              : (t = e[a].slick[o].apply(e[a].slick, n)),
            void 0 !== t)
          )
            return t;
        return e;
      }));
  }),
  /*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
  (function (t) {
    var e = {
      url: !1,
      callback: !1,
      target: !1,
      duration: 120,
      on: 'mouseover',
      touch: !0,
      onZoomIn: !1,
      onZoomOut: !1,
      magnify: 1,
    };
    ((t.zoom = function (e, i, o, n) {
      var s,
        a,
        r,
        l,
        c,
        d,
        p,
        u = t(e),
        f = u.css('position'),
        h = t(i);
      return (
        (e.style.position = /(absolute|fixed)/.test(f) ? f : 'relative'),
        (e.style.overflow = 'hidden'),
        (o.style.width = o.style.height = ''),
        t(o)
          .addClass('zoomImg')
          .css({
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: 0,
            width: o.width * n,
            height: o.height * n,
            border: 'none',
            maxWidth: 'none',
            maxHeight: 'none',
          })
          .appendTo(e),
        {
          init: function () {
            ((a = u.outerWidth()),
              (s = u.outerHeight()),
              i === e ? ((l = a), (r = s)) : ((l = h.outerWidth()), (r = h.outerHeight())),
              (c = (o.width - a) / l),
              (d = (o.height - s) / r),
              (p = h.offset()));
          },
          move: function (t) {
            var e = t.pageX - p.left,
              i = t.pageY - p.top;
            ((i = Math.max(Math.min(i, r), 0)),
              (e = Math.max(Math.min(e, l), 0)),
              (o.style.left = e * -c + 'px'),
              (o.style.top = i * -d + 'px'));
          },
        }
      );
    }),
      (t.fn.zoom = function (i) {
        return this.each(function () {
          var o = t.extend({}, e, i || {}),
            n = (o.target && t(o.target)[0]) || this,
            s = this,
            a = t(s),
            r = document.createElement('img'),
            l = t(r),
            c = 'mousemove.zoom',
            d = !1,
            p = !1;
          if (!o.url) {
            var u = s.querySelector('img');
            if ((u && (o.url = u.getAttribute('data-src') || u.currentSrc || u.src), !o.url))
              return;
          }
          (a.one(
            'zoom.destroy',
            function (t, e) {
              (a.off('.zoom'),
                (n.style.position = t),
                (n.style.overflow = e),
                (r.onload = null),
                l.remove());
            }.bind(this, n.style.position, n.style.overflow),
          ),
            (r.onload = function () {
              function e(e) {
                (u.init(),
                  u.move(e),
                  l
                    .stop()
                    .fadeTo(
                      t.support.opacity ? o.duration : 0,
                      1,
                      !!t.isFunction(o.onZoomIn) && o.onZoomIn.call(r),
                    ));
              }
              function i() {
                l.stop().fadeTo(o.duration, 0, !!t.isFunction(o.onZoomOut) && o.onZoomOut.call(r));
              }
              var u = t.zoom(n, s, r, o.magnify);
              ('grab' === o.on
                ? a.on('mousedown.zoom', function (o) {
                    1 === o.which &&
                      (t(document).one('mouseup.zoom', function () {
                        (i(), t(document).off(c, u.move));
                      }),
                      e(o),
                      t(document).on(c, u.move),
                      o.preventDefault());
                  })
                : 'click' === o.on
                  ? a.on('click.zoom', function (o) {
                      return d
                        ? void 0
                        : ((d = !0),
                          e(o),
                          t(document).on(c, u.move),
                          t(document).one('click.zoom', function () {
                            (i(), (d = !1), t(document).off(c, u.move));
                          }),
                          !1);
                    })
                  : 'toggle' === o.on
                    ? a.on('click.zoom', function (t) {
                        (d ? i() : e(t), (d = !d));
                      })
                    : 'mouseover' === o.on &&
                      (u.init(), a.on('mouseenter.zoom', e).on('mouseleave.zoom', i).on(c, u.move)),
                o.touch &&
                  a
                    .on('touchstart.zoom', function (t) {
                      (t.preventDefault(),
                        p
                          ? ((p = !1), i())
                          : ((p = !0),
                            e(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])));
                    })
                    .on('touchmove.zoom', function (t) {
                      (t.preventDefault(),
                        u.move(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0]));
                    })
                    .on('touchend.zoom', function (t) {
                      (t.preventDefault(), p && ((p = !1), i()));
                    }),
                t.isFunction(o.callback) && o.callback.call(r));
            }),
            r.setAttribute('role', 'presentation'),
            (r.alt = ''),
            (r.src = o.url));
        });
      }),
      (t.fn.zoom.defaults = e));
  })(window.jQuery),
  (function (t, e, i, o) {
    'use strict';
    function n(t, e) {
      var o,
        n,
        s,
        a = [],
        r = 0;
      (t && t.isDefaultPrevented()) ||
        (t.preventDefault(),
        (e = e || {}),
        t && t.data && (e = f(t.data.options, e)),
        (o = e.$target || i(t.currentTarget).trigger('blur')),
        ((s = i.fancybox.getInstance()) && s.$trigger && s.$trigger.is(o)) ||
          (e.selector
            ? (a = i(e.selector))
            : (n = o.attr('data-fancybox') || '')
              ? (a = (a = t.data ? t.data.items : []).length
                  ? a.filter('[data-fancybox="' + n + '"]')
                  : i('[data-fancybox="' + n + '"]'))
              : (a = [o]),
          (r = i(a).index(o)) < 0 && (r = 0),
          ((s = i.fancybox.open(a, e, r)).$trigger = o)));
    }
    if (((t.console = t.console || { info: function (t) {} }), i)) {
      if (i.fn.fancybox) return void console.info('fancyBox already initialized');
      var s = {
          closeExisting: !1,
          loop: !1,
          gutter: 50,
          keyboard: !0,
          preventCaptionOverlap: !0,
          arrows: !0,
          infobar: !0,
          smallBtn: 'auto',
          toolbar: 'auto',
          buttons: ['zoom', 'slideShow', 'thumbs', 'close'],
          idleTime: 3,
          protect: !1,
          modal: !1,
          image: { preload: !1 },
          ajax: { settings: { data: { fancybox: !0 } } },
          iframe: {
            tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
            preload: !0,
            css: {},
            attr: { scrolling: 'auto' },
          },
          video: {
            tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
            format: '',
            autoStart: !0,
          },
          defaultType: 'image',
          animationEffect: 'zoom',
          animationDuration: 366,
          zoomOpacity: 'auto',
          transitionEffect: 'fade',
          transitionDuration: 366,
          slideClass: '',
          baseClass: '',
          baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
          spinnerTpl: '<div class="fancybox-loading"></div>',
          errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
          btnTpl: {
            download:
              '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
            zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
            close:
              '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
            arrowLeft:
              '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
            arrowRight:
              '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
            smallBtn:
              '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
          },
          parentEl: 'body',
          hideScrollbar: !0,
          autoFocus: !0,
          backFocus: !0,
          trapFocus: !0,
          fullScreen: { autoStart: !1 },
          touch: { vertical: !0, momentum: !0 },
          hash: null,
          media: {},
          slideShow: { autoStart: !1, speed: 3e3 },
          thumbs: { autoStart: !1, hideOnClose: !0, parentEl: '.fancybox-container', axis: 'y' },
          wheel: 'auto',
          onInit: i.noop,
          beforeLoad: i.noop,
          afterLoad: i.noop,
          beforeShow: i.noop,
          afterShow: i.noop,
          beforeClose: i.noop,
          afterClose: i.noop,
          onActivate: i.noop,
          onDeactivate: i.noop,
          clickContent: function (t, e) {
            return 'image' === t.type && 'zoom';
          },
          clickSlide: 'close',
          clickOutside: 'close',
          dblclickContent: !1,
          dblclickSlide: !1,
          dblclickOutside: !1,
          mobile: {
            preventCaptionOverlap: !1,
            idleTime: !1,
            clickContent: function (t, e) {
              return 'image' === t.type && 'toggleControls';
            },
            clickSlide: function (t, e) {
              return 'image' === t.type ? 'toggleControls' : 'close';
            },
            dblclickContent: function (t, e) {
              return 'image' === t.type && 'zoom';
            },
            dblclickSlide: function (t, e) {
              return 'image' === t.type && 'zoom';
            },
          },
          lang: 'en',
          i18n: {
            en: {
              CLOSE: 'Close',
              NEXT: 'Next',
              PREV: 'Previous',
              ERROR: 'The requested content cannot be loaded. <br/> Please try again later.',
              PLAY_START: 'Start slideshow',
              PLAY_STOP: 'Pause slideshow',
              FULL_SCREEN: 'Full screen',
              THUMBS: 'Thumbnails',
              DOWNLOAD: 'Download',
              SHARE: 'Share',
              ZOOM: 'Zoom',
            },
            de: {
              CLOSE: 'Schlie&szlig;en',
              NEXT: 'Weiter',
              PREV: 'Zur&uuml;ck',
              ERROR:
                'Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.',
              PLAY_START: 'Diaschau starten',
              PLAY_STOP: 'Diaschau beenden',
              FULL_SCREEN: 'Vollbild',
              THUMBS: 'Vorschaubilder',
              DOWNLOAD: 'Herunterladen',
              SHARE: 'Teilen',
              ZOOM: 'Vergr&ouml;&szlig;ern',
            },
          },
        },
        a = i(t),
        r = i(e),
        l = 0,
        c =
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          },
        d =
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          },
        p = (function () {
          var t,
            i = e.createElement('fakeelement'),
            o = {
              transition: 'transitionend',
              OTransition: 'oTransitionEnd',
              MozTransition: 'transitionend',
              WebkitTransition: 'webkitTransitionEnd',
            };
          for (t in o) if (void 0 !== i.style[t]) return o[t];
          return 'transitionend';
        })(),
        u = function (t) {
          return t && t.length && t[0].offsetHeight;
        },
        f = function (t, e) {
          var o = i.extend(!0, {}, t, e);
          return (
            i.each(e, function (t, e) {
              i.isArray(e) && (o[t] = e);
            }),
            o
          );
        },
        h = function (t) {
          var o, n;
          return (
            !(!t || t.ownerDocument !== e) &&
            (i('.fancybox-container').css('pointer-events', 'none'),
            (o = {
              x: t.getBoundingClientRect().left + t.offsetWidth / 2,
              y: t.getBoundingClientRect().top + t.offsetHeight / 2,
            }),
            (n = e.elementFromPoint(o.x, o.y) === t),
            i('.fancybox-container').css('pointer-events', ''),
            n)
          );
        },
        v = function (t, e, o) {
          var n = this;
          ((n.opts = f({ index: o }, i.fancybox.defaults)),
            i.isPlainObject(e) && (n.opts = f(n.opts, e)),
            i.fancybox.isMobile && (n.opts = f(n.opts, n.opts.mobile)),
            (n.id = n.opts.id || ++l),
            (n.currIndex = parseInt(n.opts.index, 10) || 0),
            (n.prevIndex = null),
            (n.prevPos = null),
            (n.currPos = 0),
            (n.firstRun = !0),
            (n.group = []),
            (n.slides = {}),
            n.addContent(t),
            n.group.length && n.init());
        };
      (i.extend(v.prototype, {
        init: function () {
          var o,
            n,
            s = this,
            a = s.group[s.currIndex].opts;
          (a.closeExisting && i.fancybox.close(!0),
            i('body').addClass('fancybox-active'),
            !i.fancybox.getInstance() &&
              !1 !== a.hideScrollbar &&
              !i.fancybox.isMobile &&
              e.body.scrollHeight > t.innerHeight &&
              (i('head').append(
                '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' +
                  (t.innerWidth - e.documentElement.clientWidth) +
                  'px;}</style>',
              ),
              i('body').addClass('compensate-for-scrollbar')),
            (n = ''),
            i.each(a.buttons, function (t, e) {
              n += a.btnTpl[e] || '';
            }),
            (o = i(
              s.translate(
                s,
                a.baseTpl
                  .replace('{{buttons}}', n)
                  .replace('{{arrows}}', a.btnTpl.arrowLeft + a.btnTpl.arrowRight),
              ),
            )
              .attr('id', 'fancybox-container-' + s.id)
              .addClass(a.baseClass)
              .data('FancyBox', s)
              .appendTo(a.parentEl)),
            (s.$refs = { container: o }),
            ['bg', 'inner', 'infobar', 'toolbar', 'stage', 'caption', 'navigation'].forEach(
              function (t) {
                s.$refs[t] = o.find('.fancybox-' + t);
              },
            ),
            s.trigger('onInit'),
            s.activate(),
            s.jumpTo(s.currIndex));
        },
        translate: function (t, e) {
          var i = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
          return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
            return void 0 === i[e] ? t : i[e];
          });
        },
        addContent: function (t) {
          var e,
            o = this,
            n = i.makeArray(t);
          (i.each(n, function (t, e) {
            var n,
              s,
              a,
              r,
              l,
              c = {},
              d = {};
            (i.isPlainObject(e)
              ? ((c = e), (d = e.opts || e))
              : 'object' === i.type(e) && i(e).length
                ? ((d = (n = i(e)).data() || {}),
                  ((d = i.extend(!0, {}, d, d.options)).$orig = n),
                  (c.src = o.opts.src || d.src || n.attr('href')),
                  c.type || c.src || ((c.type = 'inline'), (c.src = e)))
                : (c = { type: 'html', src: e + '' }),
              (c.opts = i.extend(!0, {}, o.opts, d)),
              i.isArray(d.buttons) && (c.opts.buttons = d.buttons),
              i.fancybox.isMobile && c.opts.mobile && (c.opts = f(c.opts, c.opts.mobile)),
              (s = c.type || c.opts.type),
              (r = c.src || ''),
              !s &&
                r &&
                ((a = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                  ? ((s = 'video'),
                    c.opts.video.format ||
                      (c.opts.video.format = 'video/' + ('ogv' === a[1] ? 'ogg' : a[1])))
                  : r.match(
                        /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i,
                      )
                    ? (s = 'image')
                    : r.match(/\.(pdf)((\?|#).*)?$/i)
                      ? ((s = 'iframe'),
                        (c = i.extend(!0, c, {
                          contentType: 'pdf',
                          opts: { iframe: { preload: !1 } },
                        })))
                      : '#' === r.charAt(0) && (s = 'inline')),
              s ? (c.type = s) : o.trigger('objectNeedsType', c),
              c.contentType ||
                (c.contentType =
                  i.inArray(c.type, ['html', 'inline', 'ajax']) > -1 ? 'html' : c.type),
              (c.index = o.group.length),
              'auto' == c.opts.smallBtn &&
                (c.opts.smallBtn = i.inArray(c.type, ['html', 'inline', 'ajax']) > -1),
              'auto' === c.opts.toolbar && (c.opts.toolbar = !c.opts.smallBtn),
              (c.$thumb = c.opts.$thumb || null),
              c.opts.$trigger &&
                c.index === o.opts.index &&
                ((c.$thumb = c.opts.$trigger.find('img:first')),
                c.$thumb.length && (c.opts.$orig = c.opts.$trigger)),
              (c.$thumb && c.$thumb.length) ||
                !c.opts.$orig ||
                (c.$thumb = c.opts.$orig.find('img:first')),
              c.$thumb && !c.$thumb.length && (c.$thumb = null),
              (c.thumb = c.opts.thumb || (c.$thumb ? c.$thumb[0].src : null)),
              'function' === i.type(c.opts.caption) &&
                (c.opts.caption = c.opts.caption.apply(e, [o, c])),
              'function' === i.type(o.opts.caption) &&
                (c.opts.caption = o.opts.caption.apply(e, [o, c])),
              c.opts.caption instanceof i ||
                (c.opts.caption = void 0 === c.opts.caption ? '' : c.opts.caption + ''),
              'ajax' === c.type &&
                (l = r.split(/\s+/, 2)).length > 1 &&
                ((c.src = l.shift()), (c.opts.filter = l.shift())),
              c.opts.modal &&
                (c.opts = i.extend(!0, c.opts, {
                  trapFocus: !0,
                  infobar: 0,
                  toolbar: 0,
                  smallBtn: 0,
                  keyboard: 0,
                  slideShow: 0,
                  fullScreen: 0,
                  thumbs: 0,
                  touch: 0,
                  clickContent: !1,
                  clickSlide: !1,
                  clickOutside: !1,
                  dblclickContent: !1,
                  dblclickSlide: !1,
                  dblclickOutside: !1,
                })),
              o.group.push(c));
          }),
            Object.keys(o.slides).length &&
              (o.updateControls(), (e = o.Thumbs) && e.isActive && (e.create(), e.focus())));
        },
        addEvents: function () {
          var e = this;
          (e.removeEvents(),
            e.$refs.container
              .on('click.fb-close', '[data-fancybox-close]', function (t) {
                (t.stopPropagation(), t.preventDefault(), e.close(t));
              })
              .on('touchstart.fb-prev click.fb-prev', '[data-fancybox-prev]', function (t) {
                (t.stopPropagation(), t.preventDefault(), e.previous());
              })
              .on('touchstart.fb-next click.fb-next', '[data-fancybox-next]', function (t) {
                (t.stopPropagation(), t.preventDefault(), e.next());
              })
              .on('click.fb', '[data-fancybox-zoom]', function (t) {
                e[e.isScaledDown() ? 'scaleToActual' : 'scaleToFit']();
              }),
            a.on('orientationchange.fb resize.fb', function (t) {
              t && t.originalEvent && 'resize' === t.originalEvent.type
                ? (e.requestId && d(e.requestId),
                  (e.requestId = c(function () {
                    e.update(t);
                  })))
                : (e.current && 'iframe' === e.current.type && e.$refs.stage.hide(),
                  setTimeout(
                    function () {
                      (e.$refs.stage.show(), e.update(t));
                    },
                    i.fancybox.isMobile ? 600 : 250,
                  ));
            }),
            r.on('keydown.fb', function (t) {
              var o = (i.fancybox ? i.fancybox.getInstance() : null).current,
                n = t.keyCode || t.which;
              if (9 != n)
                return !o.opts.keyboard ||
                  t.ctrlKey ||
                  t.altKey ||
                  t.shiftKey ||
                  i(t.target).is('input,textarea,video,audio,select')
                  ? void 0
                  : 8 === n || 27 === n
                    ? (t.preventDefault(), void e.close(t))
                    : 37 === n || 38 === n
                      ? (t.preventDefault(), void e.previous())
                      : 39 === n || 40 === n
                        ? (t.preventDefault(), void e.next())
                        : void e.trigger('afterKeydown', t, n);
              o.opts.trapFocus && e.focus(t);
            }),
            e.group[e.currIndex].opts.idleTime &&
              ((e.idleSecondsCounter = 0),
              r.on(
                'mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle',
                function (t) {
                  ((e.idleSecondsCounter = 0), e.isIdle && e.showControls(), (e.isIdle = !1));
                },
              ),
              (e.idleInterval = t.setInterval(function () {
                ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime &&
                  !e.isDragging &&
                  ((e.isIdle = !0), (e.idleSecondsCounter = 0), e.hideControls());
              }, 1e3))));
        },
        removeEvents: function () {
          var e = this;
          (a.off('orientationchange.fb resize.fb'),
            r.off('keydown.fb .fb-idle'),
            this.$refs.container.off('.fb-close .fb-prev .fb-next'),
            e.idleInterval && (t.clearInterval(e.idleInterval), (e.idleInterval = null)));
        },
        previous: function (t) {
          return this.jumpTo(this.currPos - 1, t);
        },
        next: function (t) {
          return this.jumpTo(this.currPos + 1, t);
        },
        jumpTo: function (t, e) {
          var o,
            n,
            s,
            a,
            r,
            l,
            c,
            d,
            p,
            f = this,
            h = f.group.length;
          if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
            if (
              ((t = parseInt(t, 10)),
              !(s = f.current ? f.current.opts.loop : f.opts.loop) && (t < 0 || t >= h))
            )
              return !1;
            if (
              ((o = f.firstRun = !Object.keys(f.slides).length),
              (r = f.current),
              (f.prevIndex = f.currIndex),
              (f.prevPos = f.currPos),
              (a = f.createSlide(t)),
              h > 1 &&
                ((s || a.index < h - 1) && f.createSlide(t + 1),
                (s || a.index > 0) && f.createSlide(t - 1)),
              (f.current = a),
              (f.currIndex = a.index),
              (f.currPos = a.pos),
              f.trigger('beforeShow', o),
              f.updateControls(),
              (a.forcedDuration = void 0),
              i.isNumeric(e)
                ? (a.forcedDuration = e)
                : (e = a.opts[o ? 'animationDuration' : 'transitionDuration']),
              (e = parseInt(e, 10)),
              (n = f.isMoved(a)),
              a.$slide.addClass('fancybox-slide--current'),
              o)
            )
              return (
                a.opts.animationEffect &&
                  e &&
                  f.$refs.container.css('transition-duration', e + 'ms'),
                f.$refs.container.addClass('fancybox-is-open').trigger('focus'),
                f.loadSlide(a),
                void f.preload('image')
              );
            ((l = i.fancybox.getTranslate(r.$slide)),
              (c = i.fancybox.getTranslate(f.$refs.stage)),
              i.each(f.slides, function (t, e) {
                i.fancybox.stop(e.$slide, !0);
              }),
              r.pos !== a.pos && (r.isComplete = !1),
              r.$slide.removeClass('fancybox-slide--complete fancybox-slide--current'),
              n
                ? ((p = l.left - (r.pos * l.width + r.pos * r.opts.gutter)),
                  i.each(f.slides, function (t, o) {
                    o.$slide.removeClass('fancybox-animated').removeClass(function (t, e) {
                      return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(' ');
                    });
                    var n = o.pos * l.width + o.pos * o.opts.gutter;
                    (i.fancybox.setTranslate(o.$slide, { top: 0, left: n - c.left + p }),
                      o.pos !== a.pos &&
                        o.$slide.addClass(
                          'fancybox-slide--' + (o.pos > a.pos ? 'next' : 'previous'),
                        ),
                      u(o.$slide),
                      i.fancybox.animate(
                        o.$slide,
                        {
                          top: 0,
                          left: (o.pos - a.pos) * l.width + (o.pos - a.pos) * o.opts.gutter,
                        },
                        e,
                        function () {
                          (o.$slide
                            .css({ transform: '', opacity: '' })
                            .removeClass('fancybox-slide--next fancybox-slide--previous'),
                            o.pos === f.currPos && f.complete());
                        },
                      ));
                  }))
                : e &&
                  a.opts.transitionEffect &&
                  ((d = 'fancybox-animated fancybox-fx-' + a.opts.transitionEffect),
                  r.$slide.addClass('fancybox-slide--' + (r.pos > a.pos ? 'next' : 'previous')),
                  i.fancybox.animate(
                    r.$slide,
                    d,
                    e,
                    function () {
                      r.$slide
                        .removeClass(d)
                        .removeClass('fancybox-slide--next fancybox-slide--previous');
                    },
                    !1,
                  )),
              a.isLoaded ? f.revealContent(a) : f.loadSlide(a),
              f.preload('image'));
          }
        },
        createSlide: function (t) {
          var e,
            o,
            n = this;
          return (
            (o = (o = t % n.group.length) < 0 ? n.group.length + o : o),
            !n.slides[t] &&
              n.group[o] &&
              ((e = i('<div class="fancybox-slide"></div>').appendTo(n.$refs.stage)),
              (n.slides[t] = i.extend(!0, {}, n.group[o], { pos: t, $slide: e, isLoaded: !1 })),
              n.updateSlide(n.slides[t])),
            n.slides[t]
          );
        },
        scaleToActual: function (t, e, o) {
          var n,
            s,
            a,
            r,
            l,
            c = this,
            d = c.current,
            p = d.$content,
            u = i.fancybox.getTranslate(d.$slide).width,
            f = i.fancybox.getTranslate(d.$slide).height,
            h = d.width,
            v = d.height;
          c.isAnimating ||
            c.isMoved() ||
            !p ||
            'image' != d.type ||
            !d.isLoaded ||
            d.hasError ||
            ((c.isAnimating = !0),
            i.fancybox.stop(p),
            (t = void 0 === t ? 0.5 * u : t),
            (e = void 0 === e ? 0.5 * f : e),
            ((n = i.fancybox.getTranslate(p)).top -= i.fancybox.getTranslate(d.$slide).top),
            (n.left -= i.fancybox.getTranslate(d.$slide).left),
            (r = h / n.width),
            (l = v / n.height),
            (s = 0.5 * u - 0.5 * h),
            (a = 0.5 * f - 0.5 * v),
            h > u && ((s = n.left * r - (t * r - t)) > 0 && (s = 0), s < u - h && (s = u - h)),
            v > f && ((a = n.top * l - (e * l - e)) > 0 && (a = 0), a < f - v && (a = f - v)),
            c.updateCursor(h, v),
            i.fancybox.animate(p, { top: a, left: s, scaleX: r, scaleY: l }, o || 366, function () {
              c.isAnimating = !1;
            }),
            c.SlideShow && c.SlideShow.isActive && c.SlideShow.stop());
        },
        scaleToFit: function (t) {
          var e,
            o = this,
            n = o.current,
            s = n.$content;
          o.isAnimating ||
            o.isMoved() ||
            !s ||
            'image' != n.type ||
            !n.isLoaded ||
            n.hasError ||
            ((o.isAnimating = !0),
            i.fancybox.stop(s),
            (e = o.getFitPos(n)),
            o.updateCursor(e.width, e.height),
            i.fancybox.animate(
              s,
              {
                top: e.top,
                left: e.left,
                scaleX: e.width / s.width(),
                scaleY: e.height / s.height(),
              },
              t || 366,
              function () {
                o.isAnimating = !1;
              },
            ));
        },
        getFitPos: function (t) {
          var e,
            o,
            n,
            s,
            a = t.$content,
            r = t.$slide,
            l = t.width || t.opts.width,
            c = t.height || t.opts.height,
            d = {};
          return (
            !!(t.isLoaded && a && a.length) &&
            ((e = i.fancybox.getTranslate(this.$refs.stage).width),
            (o = i.fancybox.getTranslate(this.$refs.stage).height),
            (e -=
              parseFloat(r.css('paddingLeft')) +
              parseFloat(r.css('paddingRight')) +
              parseFloat(a.css('marginLeft')) +
              parseFloat(a.css('marginRight'))),
            (o -=
              parseFloat(r.css('paddingTop')) +
              parseFloat(r.css('paddingBottom')) +
              parseFloat(a.css('marginTop')) +
              parseFloat(a.css('marginBottom'))),
            (l && c) || ((l = e), (c = o)),
            (l *= n = Math.min(1, e / l, o / c)) > e - 0.5 && (l = e),
            (c *= n) > o - 0.5 && (c = o),
            'image' === t.type
              ? ((d.top = Math.floor(0.5 * (o - c)) + parseFloat(r.css('paddingTop'))),
                (d.left = Math.floor(0.5 * (e - l)) + parseFloat(r.css('paddingLeft'))))
              : 'video' === t.contentType &&
                (c > l / (s = t.opts.width && t.opts.height ? l / c : t.opts.ratio || 16 / 9)
                  ? (c = l / s)
                  : l > c * s && (l = c * s)),
            (d.width = l),
            (d.height = c),
            d)
          );
        },
        update: function (t) {
          var e = this;
          i.each(e.slides, function (i, o) {
            e.updateSlide(o, t);
          });
        },
        updateSlide: function (t, e) {
          var o = this,
            n = t && t.$content,
            s = t.width || t.opts.width,
            a = t.height || t.opts.height,
            r = t.$slide;
          (o.adjustCaption(t),
            n &&
              (s || a || 'video' === t.contentType) &&
              !t.hasError &&
              (i.fancybox.stop(n),
              i.fancybox.setTranslate(n, o.getFitPos(t)),
              t.pos === o.currPos && ((o.isAnimating = !1), o.updateCursor())),
            o.adjustLayout(t),
            r.length &&
              (r.trigger('refresh'),
              t.pos === o.currPos &&
                o.$refs.toolbar
                  .add(o.$refs.navigation.find('.fancybox-button--arrow_right'))
                  .toggleClass(
                    'compensate-for-scrollbar',
                    r.get(0).scrollHeight > r.get(0).clientHeight,
                  )),
            o.trigger('onUpdate', t, e));
        },
        centerSlide: function (t) {
          var e = this,
            o = e.current,
            n = o.$slide;
          !e.isClosing &&
            o &&
            (n.siblings().css({ transform: '', opacity: '' }),
            n.parent().children().removeClass('fancybox-slide--previous fancybox-slide--next'),
            i.fancybox.animate(
              n,
              { top: 0, left: 0, opacity: 1 },
              void 0 === t ? 0 : t,
              function () {
                (n.css({ transform: '', opacity: '' }), o.isComplete || e.complete());
              },
              !1,
            ));
        },
        isMoved: function (t) {
          var e,
            o,
            n = t || this.current;
          return (
            !!n &&
            ((o = i.fancybox.getTranslate(this.$refs.stage)),
            (e = i.fancybox.getTranslate(n.$slide)),
            !n.$slide.hasClass('fancybox-animated') &&
              (Math.abs(e.top - o.top) > 0.5 || Math.abs(e.left - o.left) > 0.5))
          );
        },
        updateCursor: function (t, e) {
          var o,
            n,
            s = this,
            a = s.current,
            r = s.$refs.container;
          a &&
            !s.isClosing &&
            s.Guestures &&
            (r.removeClass(
              'fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan',
            ),
            (n = !!(o = s.canPan(t, e)) || s.isZoomable()),
            r.toggleClass('fancybox-is-zoomable', n),
            i('[data-fancybox-zoom]').prop('disabled', !n),
            o
              ? r.addClass('fancybox-can-pan')
              : n &&
                  ('zoom' === a.opts.clickContent ||
                    (i.isFunction(a.opts.clickContent) && 'zoom' == a.opts.clickContent(a)))
                ? r.addClass('fancybox-can-zoomIn')
                : a.opts.touch &&
                  (a.opts.touch.vertical || s.group.length > 1) &&
                  'video' !== a.contentType &&
                  r.addClass('fancybox-can-swipe'));
        },
        isZoomable: function () {
          var t,
            e = this,
            i = e.current;
          if (i && !e.isClosing && 'image' === i.type && !i.hasError) {
            if (!i.isLoaded) return !0;
            if ((t = e.getFitPos(i)) && (i.width > t.width || i.height > t.height)) return !0;
          }
          return !1;
        },
        isScaledDown: function (t, e) {
          var o = !1,
            n = this.current,
            s = n.$content;
          return (
            void 0 !== t && void 0 !== e
              ? (o = t < n.width && e < n.height)
              : s && (o = (o = i.fancybox.getTranslate(s)).width < n.width && o.height < n.height),
            o
          );
        },
        canPan: function (t, e) {
          var o = this.current,
            n = null,
            s = !1;
          return (
            'image' === o.type &&
              (o.isComplete || (t && e)) &&
              !o.hasError &&
              ((s = this.getFitPos(o)),
              void 0 !== t && void 0 !== e
                ? (n = { width: t, height: e })
                : o.isComplete && (n = i.fancybox.getTranslate(o.$content)),
              n &&
                s &&
                (s = Math.abs(n.width - s.width) > 1.5 || Math.abs(n.height - s.height) > 1.5)),
            s
          );
        },
        loadSlide: function (t) {
          var e,
            o,
            n,
            s = this;
          if (!t.isLoading && !t.isLoaded) {
            if (((t.isLoading = !0), !1 === s.trigger('beforeLoad', t)))
              return ((t.isLoading = !1), !1);
            switch (
              ((e = t.type),
              (o = t.$slide).off('refresh').trigger('onReset').addClass(t.opts.slideClass),
              e)
            ) {
              case 'image':
                s.setImage(t);
                break;
              case 'iframe':
                s.setIframe(t);
                break;
              case 'html':
                s.setContent(t, t.src || t.content);
                break;
              case 'video':
                s.setContent(
                  t,
                  t.opts.video.tpl
                    .replace(/\{\{src\}\}/gi, t.src)
                    .replace('{{format}}', t.opts.videoFormat || t.opts.video.format || '')
                    .replace('{{poster}}', t.thumb || ''),
                );
                break;
              case 'inline':
                i(t.src).length ? s.setContent(t, i(t.src)) : s.setError(t);
                break;
              case 'ajax':
                (s.showLoading(t),
                  (n = i.ajax(
                    i.extend({}, t.opts.ajax.settings, {
                      url: t.src,
                      success: function (e, i) {
                        'success' === i && s.setContent(t, e);
                      },
                      error: function (e, i) {
                        e && 'abort' !== i && s.setError(t);
                      },
                    }),
                  )),
                  o.one('onReset', function () {
                    n.abort();
                  }));
                break;
              default:
                s.setError(t);
            }
            return !0;
          }
        },
        setImage: function (t) {
          var o,
            n = this;
          (setTimeout(function () {
            var e = t.$image;
            n.isClosing ||
              !t.isLoading ||
              (e && e.length && e[0].complete) ||
              t.hasError ||
              n.showLoading(t);
          }, 50),
            n.checkSrcset(t),
            (t.$content = i('<div class="fancybox-content"></div>')
              .addClass('fancybox-is-hidden')
              .appendTo(t.$slide.addClass('fancybox-slide--image'))),
            !1 !== t.opts.preload &&
              t.opts.width &&
              t.opts.height &&
              t.thumb &&
              ((t.width = t.opts.width),
              (t.height = t.opts.height),
              ((o = e.createElement('img')).onerror = function () {
                (i(this).remove(), (t.$ghost = null));
              }),
              (o.onload = function () {
                n.afterLoad(t);
              }),
              (t.$ghost = i(o)
                .addClass('fancybox-image')
                .appendTo(t.$content)
                .attr('src', t.thumb))),
            n.setBigImage(t));
        },
        checkSrcset: function (e) {
          var i,
            o,
            n,
            s,
            a = e.opts.srcset || e.opts.image.srcset;
          if (a) {
            ((n = t.devicePixelRatio || 1),
              (s = t.innerWidth * n),
              (o = a.split(',').map(function (t) {
                var e = {};
                return (
                  t
                    .trim()
                    .split(/\s+/)
                    .forEach(function (t, i) {
                      var o = parseInt(t.substring(0, t.length - 1), 10);
                      if (0 === i) return (e.url = t);
                      o && ((e.value = o), (e.postfix = t[t.length - 1]));
                    }),
                  e
                );
              })),
              o.sort(function (t, e) {
                return t.value - e.value;
              }));
            for (var r = 0; r < o.length; r++) {
              var l = o[r];
              if (('w' === l.postfix && l.value >= s) || ('x' === l.postfix && l.value >= n)) {
                i = l;
                break;
              }
            }
            (!i && o.length && (i = o[o.length - 1]),
              i &&
                ((e.src = i.url),
                e.width &&
                  e.height &&
                  'w' == i.postfix &&
                  ((e.height = (e.width / e.height) * i.value), (e.width = i.value)),
                (e.opts.srcset = a)));
          }
        },
        setBigImage: function (t) {
          var o = this,
            n = e.createElement('img'),
            s = i(n);
          ((t.$image = s
            .one('error', function () {
              o.setError(t);
            })
            .one('load', function () {
              var e;
              (t.$ghost ||
                (o.resolveImageSlideSize(t, this.naturalWidth, this.naturalHeight), o.afterLoad(t)),
                o.isClosing ||
                  (t.opts.srcset &&
                    (((e = t.opts.sizes) && 'auto' !== e) ||
                      (e =
                        (t.width / t.height > 1 && a.width() / a.height() > 1
                          ? '100'
                          : Math.round((t.width / t.height) * 100)) + 'vw'),
                    s.attr('sizes', e).attr('srcset', t.opts.srcset)),
                  t.$ghost &&
                    setTimeout(
                      function () {
                        t.$ghost && !o.isClosing && t.$ghost.hide();
                      },
                      Math.min(300, Math.max(1e3, t.height / 1600)),
                    ),
                  o.hideLoading(t)));
            })
            .addClass('fancybox-image')
            .attr('src', t.src)
            .appendTo(t.$content)),
            (n.complete || 'complete' == n.readyState) && s.naturalWidth && s.naturalHeight
              ? s.trigger('load')
              : n.error && s.trigger('error'));
        },
        resolveImageSlideSize: function (t, e, i) {
          var o = parseInt(t.opts.width, 10),
            n = parseInt(t.opts.height, 10);
          ((t.width = e),
            (t.height = i),
            o > 0 && ((t.width = o), (t.height = Math.floor((o * i) / e))),
            n > 0 && ((t.width = Math.floor((n * e) / i)), (t.height = n)));
        },
        setIframe: function (t) {
          var e,
            o = this,
            n = t.opts.iframe,
            s = t.$slide;
          ((t.$content = i(
            '<div class="fancybox-content' + (n.preload ? ' fancybox-is-hidden' : '') + '"></div>',
          )
            .css(n.css)
            .appendTo(s)),
            s.addClass('fancybox-slide--' + t.contentType),
            (t.$iframe = e =
              i(n.tpl.replace(/\{rnd\}/g, new Date().getTime()))
                .attr(n.attr)
                .appendTo(t.$content)),
            n.preload
              ? (o.showLoading(t),
                e.on('load.fb error.fb', function (e) {
                  ((this.isReady = 1), t.$slide.trigger('refresh'), o.afterLoad(t));
                }),
                s.on('refresh.fb', function () {
                  var i,
                    o = t.$content,
                    a = n.css.width,
                    r = n.css.height;
                  if (1 === e[0].isReady) {
                    try {
                      i = e.contents().find('body');
                    } catch (t) {}
                    (i &&
                      i.length &&
                      i.children().length &&
                      (s.css('overflow', 'visible'),
                      o.css({ width: '100%', 'max-width': '100%', height: '9999px' }),
                      void 0 === a && (a = Math.ceil(Math.max(i[0].clientWidth, i.outerWidth(!0)))),
                      o.css('width', a || '').css('max-width', ''),
                      void 0 === r &&
                        (r = Math.ceil(Math.max(i[0].clientHeight, i.outerHeight(!0)))),
                      o.css('height', r || ''),
                      s.css('overflow', 'auto')),
                      o.removeClass('fancybox-is-hidden'));
                  }
                }))
              : o.afterLoad(t),
            e.attr('src', t.src),
            s.one('onReset', function () {
              try {
                i(this).find('iframe').hide().unbind().attr('src', '//about:blank');
              } catch (t) {}
              (i(this).off('refresh.fb').empty(), (t.isLoaded = !1), (t.isRevealed = !1));
            }));
        },
        setContent: function (t, e) {
          var o = this;
          o.isClosing ||
            (o.hideLoading(t),
            t.$content && i.fancybox.stop(t.$content),
            t.$slide.empty(),
            (function (t) {
              return t && t.hasOwnProperty && t instanceof i;
            })(e) && e.parent().length
              ? ((e.hasClass('fancybox-content') || e.parent().hasClass('fancybox-content')) &&
                  e.parents('.fancybox-slide').trigger('onReset'),
                (t.$placeholder = i('<div>').hide().insertAfter(e)),
                e.css('display', 'inline-block'))
              : t.hasError ||
                ('string' === i.type(e) && (e = i('<div>').append(i.trim(e)).contents()),
                t.opts.filter && (e = i('<div>').html(e).find(t.opts.filter))),
            t.$slide.one('onReset', function () {
              (i(this).find('video,audio').trigger('pause'),
                t.$placeholder &&
                  (t.$placeholder.after(e.removeClass('fancybox-content').hide()).remove(),
                  (t.$placeholder = null)),
                t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
                t.hasError || (i(this).empty(), (t.isLoaded = !1), (t.isRevealed = !1)));
            }),
            i(e).appendTo(t.$slide),
            i(e).is('video,audio') &&
              (i(e).addClass('fancybox-video'),
              i(e).wrap('<div></div>'),
              (t.contentType = 'video'),
              (t.opts.width = t.opts.width || i(e).attr('width')),
              (t.opts.height = t.opts.height || i(e).attr('height'))),
            (t.$content = t.$slide
              .children()
              .filter('div,form,main,video,audio,article,.fancybox-content')
              .first()),
            t.$content.siblings().hide(),
            t.$content.length ||
              (t.$content = t.$slide.wrapInner('<div></div>').children().first()),
            t.$content.addClass('fancybox-content'),
            t.$slide.addClass('fancybox-slide--' + t.contentType),
            o.afterLoad(t));
        },
        setError: function (t) {
          ((t.hasError = !0),
            t.$slide
              .trigger('onReset')
              .removeClass('fancybox-slide--' + t.contentType)
              .addClass('fancybox-slide--error'),
            (t.contentType = 'html'),
            this.setContent(t, this.translate(t, t.opts.errorTpl)),
            t.pos === this.currPos && (this.isAnimating = !1));
        },
        showLoading: function (t) {
          var e = this;
          (t = t || e.current) &&
            !t.$spinner &&
            (t.$spinner = i(e.translate(e, e.opts.spinnerTpl))
              .appendTo(t.$slide)
              .hide()
              .fadeIn('fast'));
        },
        hideLoading: function (t) {
          (t = t || this.current) && t.$spinner && (t.$spinner.stop().remove(), delete t.$spinner);
        },
        afterLoad: function (t) {
          var e = this;
          e.isClosing ||
            ((t.isLoading = !1),
            (t.isLoaded = !0),
            e.trigger('afterLoad', t),
            e.hideLoading(t),
            !t.opts.smallBtn ||
              (t.$smallBtn && t.$smallBtn.length) ||
              (t.$smallBtn = i(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(t.$content)),
            t.opts.protect &&
              t.$content &&
              !t.hasError &&
              (t.$content.on('contextmenu.fb', function (t) {
                return (2 == t.button && t.preventDefault(), !0);
              }),
              'image' === t.type &&
                i('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
            e.adjustCaption(t),
            e.adjustLayout(t),
            t.pos === e.currPos && e.updateCursor(),
            e.revealContent(t));
        },
        adjustCaption: function (t) {
          var e,
            i = this,
            o = t || i.current,
            n = o.opts.caption,
            s = o.opts.preventCaptionOverlap,
            a = i.$refs.caption,
            r = !1;
          (a.toggleClass('fancybox-caption--separate', s),
            s &&
              n &&
              n.length &&
              (o.pos !== i.currPos
                ? ((e = a.clone().appendTo(a.parent())).children().eq(0).empty().html(n),
                  (r = e.outerHeight(!0)),
                  e.empty().remove())
                : i.$caption && (r = i.$caption.outerHeight(!0)),
              o.$slide.css('padding-bottom', r || '')));
        },
        adjustLayout: function (t) {
          var e,
            i,
            o,
            n,
            s = t || this.current;
          s.isLoaded &&
            !0 !== s.opts.disableLayoutFix &&
            (s.$content.css('margin-bottom', ''),
            s.$content.outerHeight() > s.$slide.height() + 0.5 &&
              ((o = s.$slide[0].style['padding-bottom']),
              (n = s.$slide.css('padding-bottom')),
              parseFloat(n) > 0 &&
                ((e = s.$slide[0].scrollHeight),
                s.$slide.css('padding-bottom', 0),
                Math.abs(e - s.$slide[0].scrollHeight) < 1 && (i = n),
                s.$slide.css('padding-bottom', o))),
            s.$content.css('margin-bottom', i));
        },
        revealContent: function (t) {
          var e,
            o,
            n,
            s,
            a = this,
            r = t.$slide,
            l = !1,
            c = !1,
            d = a.isMoved(t),
            p = t.isRevealed;
          return (
            (t.isRevealed = !0),
            (e = t.opts[a.firstRun ? 'animationEffect' : 'transitionEffect']),
            (n = t.opts[a.firstRun ? 'animationDuration' : 'transitionDuration']),
            (n = parseInt(void 0 === t.forcedDuration ? n : t.forcedDuration, 10)),
            (!d && t.pos === a.currPos && n) || (e = !1),
            'zoom' === e &&
              (t.pos === a.currPos &&
              n &&
              'image' === t.type &&
              !t.hasError &&
              (c = a.getThumbPos(t))
                ? (l = a.getFitPos(t))
                : (e = 'fade')),
            'zoom' === e
              ? ((a.isAnimating = !0),
                (l.scaleX = l.width / c.width),
                (l.scaleY = l.height / c.height),
                'auto' == (s = t.opts.zoomOpacity) &&
                  (s = Math.abs(t.width / t.height - c.width / c.height) > 0.1),
                s && ((c.opacity = 0.1), (l.opacity = 1)),
                i.fancybox.setTranslate(t.$content.removeClass('fancybox-is-hidden'), c),
                u(t.$content),
                void i.fancybox.animate(t.$content, l, n, function () {
                  ((a.isAnimating = !1), a.complete());
                }))
              : (a.updateSlide(t),
                e
                  ? (i.fancybox.stop(r),
                    (o =
                      'fancybox-slide--' +
                      (t.pos >= a.prevPos ? 'next' : 'previous') +
                      ' fancybox-animated fancybox-fx-' +
                      e),
                    r.addClass(o).removeClass('fancybox-slide--current'),
                    t.$content.removeClass('fancybox-is-hidden'),
                    u(r),
                    'image' !== t.type && t.$content.hide().show(0),
                    void i.fancybox.animate(
                      r,
                      'fancybox-slide--current',
                      n,
                      function () {
                        (r.removeClass(o).css({ transform: '', opacity: '' }),
                          t.pos === a.currPos && a.complete());
                      },
                      !0,
                    ))
                  : (t.$content.removeClass('fancybox-is-hidden'),
                    p || !d || 'image' !== t.type || t.hasError || t.$content.hide().fadeIn('fast'),
                    void (t.pos === a.currPos && a.complete())))
          );
        },
        getThumbPos: function (t) {
          var e,
            o,
            n,
            s,
            a,
            r = !1,
            l = t.$thumb;
          return (
            !(!l || !h(l[0])) &&
            ((e = i.fancybox.getTranslate(l)),
            (o = parseFloat(l.css('border-top-width') || 0)),
            (n = parseFloat(l.css('border-right-width') || 0)),
            (s = parseFloat(l.css('border-bottom-width') || 0)),
            (a = parseFloat(l.css('border-left-width') || 0)),
            (r = {
              top: e.top + o,
              left: e.left + a,
              width: e.width - n - a,
              height: e.height - o - s,
              scaleX: 1,
              scaleY: 1,
            }),
            e.width > 0 && e.height > 0 && r)
          );
        },
        complete: function () {
          var t,
            e = this,
            o = e.current,
            n = {};
          !e.isMoved() &&
            o.isLoaded &&
            (o.isComplete ||
              ((o.isComplete = !0),
              o.$slide.siblings().trigger('onReset'),
              e.preload('inline'),
              u(o.$slide),
              o.$slide.addClass('fancybox-slide--complete'),
              i.each(e.slides, function (t, o) {
                o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1
                  ? (n[o.pos] = o)
                  : o && (i.fancybox.stop(o.$slide), o.$slide.off().remove());
              }),
              (e.slides = n)),
            (e.isAnimating = !1),
            e.updateCursor(),
            e.trigger('afterShow'),
            o.opts.video.autoStart &&
              o.$slide
                .find('video,audio')
                .filter(':visible:first')
                .trigger('play')
                .one('ended', function () {
                  (Document.exitFullscreen
                    ? Document.exitFullscreen()
                    : this.webkitExitFullscreen && this.webkitExitFullscreen(),
                    e.next());
                }),
            o.opts.autoFocus &&
              'html' === o.contentType &&
              ((t = o.$content.find('input[autofocus]:enabled:visible:first')).length
                ? t.trigger('focus')
                : e.focus(null, !0)),
            o.$slide.scrollTop(0).scrollLeft(0));
        },
        preload: function (t) {
          var e,
            i,
            o = this;
          o.group.length < 2 ||
            ((i = o.slides[o.currPos + 1]),
            (e = o.slides[o.currPos - 1]) && e.type === t && o.loadSlide(e),
            i && i.type === t && o.loadSlide(i));
        },
        focus: function (t, o) {
          var n,
            s,
            a = this,
            r = [
              'a[href]',
              'area[href]',
              'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
              'select:not([disabled]):not([aria-hidden])',
              'textarea:not([disabled]):not([aria-hidden])',
              'button:not([disabled]):not([aria-hidden])',
              'iframe',
              'object',
              'embed',
              'video',
              'audio',
              '[contenteditable]',
              '[tabindex]:not([tabindex^="-"])',
            ].join(',');
          a.isClosing ||
            ((n = (n =
              !t && a.current && a.current.isComplete
                ? a.current.$slide.find('*:visible' + (o ? ':not(.fancybox-close-small)' : ''))
                : a.$refs.container.find('*:visible'))
              .filter(r)
              .filter(function () {
                return 'hidden' !== i(this).css('visibility') && !i(this).hasClass('disabled');
              })).length
              ? ((s = n.index(e.activeElement)),
                t && t.shiftKey
                  ? (s < 0 || 0 == s) && (t.preventDefault(), n.eq(n.length - 1).trigger('focus'))
                  : (s < 0 || s == n.length - 1) &&
                    (t && t.preventDefault(), n.eq(0).trigger('focus')))
              : a.$refs.container.trigger('focus'));
        },
        activate: function () {
          var t = this;
          (i('.fancybox-container').each(function () {
            var e = i(this).data('FancyBox');
            e &&
              e.id !== t.id &&
              !e.isClosing &&
              (e.trigger('onDeactivate'), e.removeEvents(), (e.isVisible = !1));
          }),
            (t.isVisible = !0),
            (t.current || t.isIdle) && (t.update(), t.updateControls()),
            t.trigger('onActivate'),
            t.addEvents());
        },
        close: function (t, e) {
          var o,
            n,
            s,
            a,
            r,
            l,
            d,
            p = this,
            f = p.current,
            h = function () {
              p.cleanUp(t);
            };
          return !(
            p.isClosing ||
            ((p.isClosing = !0),
            !1 === p.trigger('beforeClose', t)
              ? ((p.isClosing = !1),
                c(function () {
                  p.update();
                }),
                1)
              : (p.removeEvents(),
                (s = f.$content),
                (o = f.opts.animationEffect),
                (n = i.isNumeric(e) ? e : o ? f.opts.animationDuration : 0),
                f.$slide.removeClass(
                  'fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated',
                ),
                !0 !== t ? i.fancybox.stop(f.$slide) : (o = !1),
                f.$slide.siblings().trigger('onReset').remove(),
                n &&
                  p.$refs.container
                    .removeClass('fancybox-is-open')
                    .addClass('fancybox-is-closing')
                    .css('transition-duration', n + 'ms'),
                p.hideLoading(f),
                p.hideControls(!0),
                p.updateCursor(),
                'zoom' !== o ||
                  (s &&
                    n &&
                    'image' === f.type &&
                    !p.isMoved() &&
                    !f.hasError &&
                    (d = p.getThumbPos(f))) ||
                  (o = 'fade'),
                'zoom' === o
                  ? (i.fancybox.stop(s),
                    (a = i.fancybox.getTranslate(s)),
                    (l = {
                      top: a.top,
                      left: a.left,
                      scaleX: a.width / d.width,
                      scaleY: a.height / d.height,
                      width: d.width,
                      height: d.height,
                    }),
                    (r = f.opts.zoomOpacity),
                    'auto' == r && (r = Math.abs(f.width / f.height - d.width / d.height) > 0.1),
                    r && (d.opacity = 0),
                    i.fancybox.setTranslate(s, l),
                    u(s),
                    i.fancybox.animate(s, d, n, h),
                    0)
                  : (o && n
                      ? i.fancybox.animate(
                          f.$slide
                            .addClass('fancybox-slide--previous')
                            .removeClass('fancybox-slide--current'),
                          'fancybox-animated fancybox-fx-' + o,
                          n,
                          h,
                        )
                      : !0 === t
                        ? setTimeout(h, n)
                        : h(),
                    0)))
          );
        },
        cleanUp: function (e) {
          var o,
            n,
            s,
            a = this,
            r = a.current.opts.$orig;
          (a.current.$slide.trigger('onReset'),
            a.$refs.container.empty().remove(),
            a.trigger('afterClose', e),
            a.current.opts.backFocus &&
              ((r && r.length && r.is(':visible')) || (r = a.$trigger),
              r &&
                r.length &&
                ((n = t.scrollX),
                (s = t.scrollY),
                r.trigger('focus'),
                i('html, body').scrollTop(s).scrollLeft(n))),
            (a.current = null),
            (o = i.fancybox.getInstance())
              ? o.activate()
              : (i('body').removeClass('fancybox-active compensate-for-scrollbar'),
                i('#fancybox-style-noscroll').remove()));
        },
        trigger: function (t, e) {
          var o,
            n = Array.prototype.slice.call(arguments, 1),
            s = this,
            a = e && e.opts ? e : s.current;
          if (
            (a ? n.unshift(a) : (a = s),
            n.unshift(s),
            i.isFunction(a.opts[t]) && (o = a.opts[t].apply(a, n)),
            !1 === o)
          )
            return o;
          'afterClose' !== t && s.$refs
            ? s.$refs.container.trigger(t + '.fb', n)
            : r.trigger(t + '.fb', n);
        },
        updateControls: function () {
          var t = this,
            o = t.current,
            n = o.index,
            s = t.$refs.container,
            a = t.$refs.caption,
            r = o.opts.caption;
          (o.$slide.trigger('refresh'),
            r && r.length ? ((t.$caption = a), a.children().eq(0).html(r)) : (t.$caption = null),
            t.hasHiddenControls || t.isIdle || t.showControls(),
            s.find('[data-fancybox-count]').html(t.group.length),
            s.find('[data-fancybox-index]').html(n + 1),
            s.find('[data-fancybox-prev]').prop('disabled', !o.opts.loop && n <= 0),
            s
              .find('[data-fancybox-next]')
              .prop('disabled', !o.opts.loop && n >= t.group.length - 1),
            'image' === o.type
              ? s
                  .find('[data-fancybox-zoom]')
                  .show()
                  .end()
                  .find('[data-fancybox-download]')
                  .attr('href', o.opts.image.src || o.src)
                  .show()
              : o.opts.toolbar && s.find('[data-fancybox-download],[data-fancybox-zoom]').hide(),
            i(e.activeElement).is(':hidden,[disabled]') && t.$refs.container.trigger('focus'));
        },
        hideControls: function (t) {
          var e = ['infobar', 'toolbar', 'nav'];
          ((!t && this.current.opts.preventCaptionOverlap) || e.push('caption'),
            this.$refs.container.removeClass(
              e
                .map(function (t) {
                  return 'fancybox-show-' + t;
                })
                .join(' '),
            ),
            (this.hasHiddenControls = !0));
        },
        showControls: function () {
          var t = this,
            e = t.current ? t.current.opts : t.opts,
            i = t.$refs.container;
          ((t.hasHiddenControls = !1),
            (t.idleSecondsCounter = 0),
            i
              .toggleClass('fancybox-show-toolbar', !(!e.toolbar || !e.buttons))
              .toggleClass('fancybox-show-infobar', !!(e.infobar && t.group.length > 1))
              .toggleClass('fancybox-show-caption', !!t.$caption)
              .toggleClass('fancybox-show-nav', !!(e.arrows && t.group.length > 1))
              .toggleClass('fancybox-is-modal', !!e.modal));
        },
        toggleControls: function () {
          this.hasHiddenControls ? this.showControls() : this.hideControls();
        },
      }),
        (i.fancybox = {
          version: '3.5.7',
          defaults: s,
          getInstance: function (t) {
            var e = i('.fancybox-container:not(".fancybox-is-closing"):last').data('FancyBox'),
              o = Array.prototype.slice.call(arguments, 1);
            return (
              e instanceof v &&
              ('string' === i.type(t)
                ? e[t].apply(e, o)
                : 'function' === i.type(t) && t.apply(e, o),
              e)
            );
          },
          open: function (t, e, i) {
            return new v(t, e, i);
          },
          close: function (t) {
            var e = this.getInstance();
            e && (e.close(), !0 === t && this.close(t));
          },
          destroy: function () {
            (this.close(!0), r.add('body').off('click.fb-start', '**'));
          },
          isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent,
          ),
          use3d: (function () {
            var i = e.createElement('div');
            return (
              t.getComputedStyle &&
              t.getComputedStyle(i) &&
              t.getComputedStyle(i).getPropertyValue('transform') &&
              !(e.documentMode && e.documentMode < 11)
            );
          })(),
          getTranslate: function (t) {
            var e;
            return (
              !(!t || !t.length) && {
                top: (e = t[0].getBoundingClientRect()).top || 0,
                left: e.left || 0,
                width: e.width,
                height: e.height,
                opacity: parseFloat(t.css('opacity')),
              }
            );
          },
          setTranslate: function (t, e) {
            var i = '',
              o = {};
            if (t && e)
              return (
                (void 0 === e.left && void 0 === e.top) ||
                  ((i =
                    (void 0 === e.left ? t.position().left : e.left) +
                    'px, ' +
                    (void 0 === e.top ? t.position().top : e.top) +
                    'px'),
                  (i = this.use3d ? 'translate3d(' + i + ', 0px)' : 'translate(' + i + ')')),
                void 0 !== e.scaleX && void 0 !== e.scaleY
                  ? (i += ' scale(' + e.scaleX + ', ' + e.scaleY + ')')
                  : void 0 !== e.scaleX && (i += ' scaleX(' + e.scaleX + ')'),
                i.length && (o.transform = i),
                void 0 !== e.opacity && (o.opacity = e.opacity),
                void 0 !== e.width && (o.width = e.width),
                void 0 !== e.height && (o.height = e.height),
                t.css(o)
              );
          },
          animate: function (t, e, o, n, s) {
            var a,
              r = this;
            (i.isFunction(o) && ((n = o), (o = null)),
              r.stop(t),
              (a = r.getTranslate(t)),
              t.on(p, function (l) {
                (!l ||
                  !l.originalEvent ||
                  (t.is(l.originalEvent.target) && 'z-index' != l.originalEvent.propertyName)) &&
                  (r.stop(t),
                  i.isNumeric(o) && t.css('transition-duration', ''),
                  i.isPlainObject(e)
                    ? void 0 !== e.scaleX &&
                      void 0 !== e.scaleY &&
                      r.setTranslate(t, {
                        top: e.top,
                        left: e.left,
                        width: a.width * e.scaleX,
                        height: a.height * e.scaleY,
                        scaleX: 1,
                        scaleY: 1,
                      })
                    : !0 !== s && t.removeClass(e),
                  i.isFunction(n) && n(l));
              }),
              i.isNumeric(o) && t.css('transition-duration', o + 'ms'),
              i.isPlainObject(e)
                ? (void 0 !== e.scaleX &&
                    void 0 !== e.scaleY &&
                    (delete e.width,
                    delete e.height,
                    t.parent().hasClass('fancybox-slide--image') &&
                      t.parent().addClass('fancybox-is-scaling')),
                  i.fancybox.setTranslate(t, e))
                : t.addClass(e),
              t.data(
                'timer',
                setTimeout(function () {
                  t.trigger(p);
                }, o + 33),
              ));
          },
          stop: function (t, e) {
            t &&
              t.length &&
              (clearTimeout(t.data('timer')),
              e && t.trigger(p),
              t.off(p).css('transition-duration', ''),
              t.parent().removeClass('fancybox-is-scaling'));
          },
        }),
        (i.fn.fancybox = function (t) {
          var e;
          return (
            (e = (t = t || {}).selector || !1)
              ? i('body').off('click.fb-start', e).on('click.fb-start', e, { options: t }, n)
              : this.off('click.fb-start').on('click.fb-start', { items: this, options: t }, n),
            this
          );
        }),
        r.on('click.fb-start', '[data-fancybox]', n),
        r.on('click.fb-start', '[data-fancybox-trigger]', function (t) {
          i('[data-fancybox="' + i(this).attr('data-fancybox-trigger') + '"]')
            .eq(i(this).attr('data-fancybox-index') || 0)
            .trigger('click.fb-start', { $trigger: i(this) });
        }),
        (function () {
          var t = null;
          r.on('mousedown mouseup focus blur', '.fancybox-button', function (e) {
            switch (e.type) {
              case 'mousedown':
                t = i(this);
                break;
              case 'mouseup':
                t = null;
                break;
              case 'focusin':
                (i('.fancybox-button').removeClass('fancybox-focus'),
                  i(this).is(t) || i(this).is('[disabled]') || i(this).addClass('fancybox-focus'));
                break;
              case 'focusout':
                i('.fancybox-button').removeClass('fancybox-focus');
            }
          });
        })());
    }
  })(window, document, jQuery),
  (function (t) {
    'use strict';
    var e = {
        youtube: {
          matcher:
            /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
          params: {
            autoplay: 1,
            autohide: 1,
            fs: 1,
            rel: 0,
            hd: 1,
            wmode: 'transparent',
            enablejsapi: 1,
            html5: 1,
          },
          paramPlace: 8,
          type: 'iframe',
          url: 'https://www.youtube-nocookie.com/embed/$4',
          thumb: 'https://img.youtube.com/vi/$4/hqdefault.jpg',
        },
        vimeo: {
          matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
          params: {
            autoplay: 1,
            hd: 1,
            show_title: 1,
            show_byline: 1,
            show_portrait: 0,
            fullscreen: 1,
          },
          paramPlace: 3,
          type: 'iframe',
          url: '//player.vimeo.com/video/$2',
        },
        instagram: {
          matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
          type: 'image',
          url: '//$1/p/$2/media/?size=l',
        },
        gmap_place: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
          type: 'iframe',
          url: function (t) {
            return (
              '//maps.google.' +
              t[2] +
              '/?ll=' +
              (t[9]
                ? t[9] + '&z=' + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, '&') : '')
                : t[12] + ''
              ).replace(/\?/, '&') +
              '&output=' +
              (t[12] && t[12].indexOf('layer=c') > 0 ? 'svembed' : 'embed')
            );
          },
        },
        gmap_search: {
          matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
          type: 'iframe',
          url: function (t) {
            return (
              '//maps.google.' +
              t[2] +
              '/maps?q=' +
              t[5].replace('query=', 'q=').replace('api=1', '') +
              '&output=embed'
            );
          },
        },
      },
      i = function (e, i, o) {
        if (e)
          return (
            (o = o || ''),
            'object' === t.type(o) && (o = t.param(o, !0)),
            t.each(i, function (t, i) {
              e = e.replace('$' + t, i || '');
            }),
            o.length && (e += (e.indexOf('?') > 0 ? '&' : '?') + o),
            e
          );
      };
    t(document).on('objectNeedsType.fb', function (o, n, s) {
      var a,
        r,
        l,
        c,
        d,
        p,
        u,
        f = s.src || '',
        h = !1;
      ((a = t.extend(!0, {}, e, s.opts.media)),
        t.each(a, function (e, o) {
          if ((l = f.match(o.matcher))) {
            if (((h = o.type), (u = e), (p = {}), o.paramPlace && l[o.paramPlace])) {
              ('?' == (d = l[o.paramPlace])[0] && (d = d.substring(1)), (d = d.split('&')));
              for (var n = 0; n < d.length; ++n) {
                var a = d[n].split('=', 2);
                2 == a.length && (p[a[0]] = decodeURIComponent(a[1].replace(/\+/g, ' ')));
              }
            }
            return (
              (c = t.extend(!0, {}, o.params, s.opts[e], p)),
              (f = 'function' === t.type(o.url) ? o.url.call(this, l, c, s) : i(o.url, l, c)),
              (r = 'function' === t.type(o.thumb) ? o.thumb.call(this, l, c, s) : i(o.thumb, l)),
              'youtube' === e
                ? (f = f.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, i, o) {
                    return '&start=' + ((i ? 60 * parseInt(i, 10) : 0) + parseInt(o, 10));
                  }))
                : 'vimeo' === e && (f = f.replace('&%23', '#')),
              !1
            );
          }
        }),
        h
          ? (s.opts.thumb || (s.opts.$thumb && s.opts.$thumb.length) || (s.opts.thumb = r),
            'iframe' === h &&
              (s.opts = t.extend(!0, s.opts, {
                iframe: { preload: !1, attr: { scrolling: 'no' } },
              })),
            t.extend(s, {
              type: h,
              src: f,
              origSrc: s.src,
              contentSource: u,
              contentType:
                'image' === h ? 'image' : 'gmap_place' == u || 'gmap_search' == u ? 'map' : 'video',
            }))
          : f && (s.type = s.opts.defaultType));
    });
    var o = {
      youtube: { src: 'https://www.youtube.com/iframe_api', class: 'YT', loading: !1, loaded: !1 },
      vimeo: {
        src: 'https://player.vimeo.com/api/player.js',
        class: 'Vimeo',
        loading: !1,
        loaded: !1,
      },
      load: function (t) {
        var e,
          i = this;
        this[t].loaded
          ? setTimeout(function () {
              i.done(t);
            })
          : this[t].loading ||
            ((this[t].loading = !0),
            ((e = document.createElement('script')).type = 'text/javascript'),
            (e.src = this[t].src),
            'youtube' === t
              ? (window.onYouTubeIframeAPIReady = function () {
                  ((i[t].loaded = !0), i.done(t));
                })
              : (e.onload = function () {
                  ((i[t].loaded = !0), i.done(t));
                }),
            document.body.appendChild(e));
      },
      done: function (e) {
        var i, o;
        ('youtube' === e && delete window.onYouTubeIframeAPIReady,
          (i = t.fancybox.getInstance()) &&
            ((o = i.current.$content.find('iframe')),
            'youtube' === e && void 0 !== YT && YT
              ? new YT.Player(o.attr('id'), {
                  events: {
                    onStateChange: function (t) {
                      0 == t.data && i.next();
                    },
                  },
                })
              : 'vimeo' === e &&
                void 0 !== Vimeo &&
                Vimeo &&
                new Vimeo.Player(o).on('ended', function () {
                  i.next();
                })));
      },
    };
    t(document).on({
      'afterShow.fb': function (t, e, i) {
        e.group.length > 1 &&
          ('youtube' === i.contentSource || 'vimeo' === i.contentSource) &&
          o.load(i.contentSource);
      },
    });
  })(jQuery),
  (function (t, e, i) {
    'use strict';
    var o =
        t.requestAnimationFrame ||
        t.webkitRequestAnimationFrame ||
        t.mozRequestAnimationFrame ||
        t.oRequestAnimationFrame ||
        function (e) {
          return t.setTimeout(e, 1e3 / 60);
        },
      n =
        t.cancelAnimationFrame ||
        t.webkitCancelAnimationFrame ||
        t.mozCancelAnimationFrame ||
        t.oCancelAnimationFrame ||
        function (e) {
          t.clearTimeout(e);
        },
      s = function (e) {
        var i = [];
        for (var o in (e =
          (e = e.originalEvent || e || t.e).touches && e.touches.length
            ? e.touches
            : e.changedTouches && e.changedTouches.length
              ? e.changedTouches
              : [e]))
          e[o].pageX
            ? i.push({ x: e[o].pageX, y: e[o].pageY })
            : e[o].clientX && i.push({ x: e[o].clientX, y: e[o].clientY });
        return i;
      },
      a = function (t, e, i) {
        return e && t
          ? 'x' === i
            ? t.x - e.x
            : 'y' === i
              ? t.y - e.y
              : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
          : 0;
      },
      r = function (t) {
        if (
          t.is(
            'a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe',
          ) ||
          i.isFunction(t.get(0).onclick) ||
          t.data('selectable')
        )
          return !0;
        for (var e = 0, o = t[0].attributes, n = o.length; e < n; e++)
          if ('data-fancybox-' === o[e].nodeName.substr(0, 14)) return !0;
        return !1;
      },
      l = function (e) {
        var i = t.getComputedStyle(e)['overflow-y'],
          o = t.getComputedStyle(e)['overflow-x'],
          n = ('scroll' === i || 'auto' === i) && e.scrollHeight > e.clientHeight,
          s = ('scroll' === o || 'auto' === o) && e.scrollWidth > e.clientWidth;
        return n || s;
      },
      c = function (t) {
        for (
          var e = !1;
          !(e = l(t.get(0))) &&
          (t = t.parent()).length &&
          !t.hasClass('fancybox-stage') &&
          !t.is('body');

        );
        return e;
      },
      d = function (t) {
        var e = this;
        ((e.instance = t),
          (e.$bg = t.$refs.bg),
          (e.$stage = t.$refs.stage),
          (e.$container = t.$refs.container),
          e.destroy(),
          e.$container.on('touchstart.fb.touch mousedown.fb.touch', i.proxy(e, 'ontouchstart')));
      };
    ((d.prototype.destroy = function () {
      var t = this;
      (t.$container.off('.fb.touch'),
        i(e).off('.fb.touch'),
        t.requestId && (n(t.requestId), (t.requestId = null)),
        t.tapped && (clearTimeout(t.tapped), (t.tapped = null)));
    }),
      (d.prototype.ontouchstart = function (o) {
        var n = this,
          l = i(o.target),
          d = n.instance,
          p = d.current,
          u = p.$slide,
          f = p.$content,
          h = 'touchstart' == o.type;
        if (
          (h && n.$container.off('mousedown.fb.touch'),
          (!o.originalEvent || 2 != o.originalEvent.button) &&
            u.length &&
            l.length &&
            !r(l) &&
            !r(l.parent()) &&
            (l.is('img') || !(o.originalEvent.clientX > l[0].clientWidth + l.offset().left)))
        ) {
          if (!p || d.isAnimating || p.$slide.hasClass('fancybox-animated'))
            return (o.stopPropagation(), void o.preventDefault());
          ((n.realPoints = n.startPoints = s(o)),
            n.startPoints.length &&
              (p.touch && o.stopPropagation(),
              (n.startEvent = o),
              (n.canTap = !0),
              (n.$target = l),
              (n.$content = f),
              (n.opts = p.opts.touch),
              (n.isPanning = !1),
              (n.isSwiping = !1),
              (n.isZooming = !1),
              (n.isScrolling = !1),
              (n.canPan = d.canPan()),
              (n.startTime = new Date().getTime()),
              (n.distanceX = n.distanceY = n.distance = 0),
              (n.canvasWidth = Math.round(u[0].clientWidth)),
              (n.canvasHeight = Math.round(u[0].clientHeight)),
              (n.contentLastPos = null),
              (n.contentStartPos = i.fancybox.getTranslate(n.$content) || { top: 0, left: 0 }),
              (n.sliderStartPos = i.fancybox.getTranslate(u)),
              (n.stagePos = i.fancybox.getTranslate(d.$refs.stage)),
              (n.sliderStartPos.top -= n.stagePos.top),
              (n.sliderStartPos.left -= n.stagePos.left),
              (n.contentStartPos.top -= n.stagePos.top),
              (n.contentStartPos.left -= n.stagePos.left),
              i(e)
                .off('.fb.touch')
                .on(
                  h
                    ? 'touchend.fb.touch touchcancel.fb.touch'
                    : 'mouseup.fb.touch mouseleave.fb.touch',
                  i.proxy(n, 'ontouchend'),
                )
                .on(h ? 'touchmove.fb.touch' : 'mousemove.fb.touch', i.proxy(n, 'ontouchmove')),
              i.fancybox.isMobile && e.addEventListener('scroll', n.onscroll, !0),
              (((n.opts || n.canPan) && (l.is(n.$stage) || n.$stage.find(l).length)) ||
                (l.is('.fancybox-image') && o.preventDefault(),
                i.fancybox.isMobile && l.parents('.fancybox-caption').length)) &&
                ((n.isScrollable = c(l) || c(l.parent())),
                (i.fancybox.isMobile && n.isScrollable) || o.preventDefault(),
                (1 === n.startPoints.length || p.hasError) &&
                  (n.canPan
                    ? (i.fancybox.stop(n.$content), (n.isPanning = !0))
                    : (n.isSwiping = !0),
                  n.$container.addClass('fancybox-is-grabbing')),
                2 === n.startPoints.length &&
                  'image' === p.type &&
                  (p.isLoaded || p.$ghost) &&
                  ((n.canTap = !1),
                  (n.isSwiping = !1),
                  (n.isPanning = !1),
                  (n.isZooming = !0),
                  i.fancybox.stop(n.$content),
                  (n.centerPointStartX =
                    0.5 * (n.startPoints[0].x + n.startPoints[1].x) - i(t).scrollLeft()),
                  (n.centerPointStartY =
                    0.5 * (n.startPoints[0].y + n.startPoints[1].y) - i(t).scrollTop()),
                  (n.percentageOfImageAtPinchPointX =
                    (n.centerPointStartX - n.contentStartPos.left) / n.contentStartPos.width),
                  (n.percentageOfImageAtPinchPointY =
                    (n.centerPointStartY - n.contentStartPos.top) / n.contentStartPos.height),
                  (n.startDistanceBetweenFingers = a(n.startPoints[0], n.startPoints[1]))))));
        }
      }),
      (d.prototype.onscroll = function (t) {
        ((this.isScrolling = !0), e.removeEventListener('scroll', this.onscroll, !0));
      }),
      (d.prototype.ontouchmove = function (t) {
        var e = this;
        return void 0 !== t.originalEvent.buttons && 0 === t.originalEvent.buttons
          ? void e.ontouchend(t)
          : e.isScrolling
            ? void (e.canTap = !1)
            : ((e.newPoints = s(t)),
              void (
                (e.opts || e.canPan) &&
                e.newPoints.length &&
                e.newPoints.length &&
                ((e.isSwiping && !0 === e.isSwiping) || t.preventDefault(),
                (e.distanceX = a(e.newPoints[0], e.startPoints[0], 'x')),
                (e.distanceY = a(e.newPoints[0], e.startPoints[0], 'y')),
                (e.distance = a(e.newPoints[0], e.startPoints[0])),
                e.distance > 0 &&
                  (e.isSwiping
                    ? e.onSwipe(t)
                    : e.isPanning
                      ? e.onPan()
                      : e.isZooming && e.onZoom()))
              ));
      }),
      (d.prototype.onSwipe = function (e) {
        var s,
          a = this,
          r = a.instance,
          l = a.isSwiping,
          c = a.sliderStartPos.left || 0;
        if (!0 !== l)
          ('x' == l &&
            (a.distanceX > 0 &&
            (a.instance.group.length < 2 ||
              (0 === a.instance.current.index && !a.instance.current.opts.loop))
              ? (c += Math.pow(a.distanceX, 0.8))
              : a.distanceX < 0 &&
                  (a.instance.group.length < 2 ||
                    (a.instance.current.index === a.instance.group.length - 1 &&
                      !a.instance.current.opts.loop))
                ? (c -= Math.pow(-a.distanceX, 0.8))
                : (c += a.distanceX)),
            (a.sliderLastPos = { top: 'x' == l ? 0 : a.sliderStartPos.top + a.distanceY, left: c }),
            a.requestId && (n(a.requestId), (a.requestId = null)),
            (a.requestId = o(function () {
              a.sliderLastPos &&
                (i.each(a.instance.slides, function (t, e) {
                  var o = e.pos - a.instance.currPos;
                  i.fancybox.setTranslate(e.$slide, {
                    top: a.sliderLastPos.top,
                    left: a.sliderLastPos.left + o * a.canvasWidth + o * e.opts.gutter,
                  });
                }),
                a.$container.addClass('fancybox-is-sliding'));
            })));
        else if (Math.abs(a.distance) > 10) {
          if (
            ((a.canTap = !1),
            r.group.length < 2 && a.opts.vertical
              ? (a.isSwiping = 'y')
              : r.isDragging ||
                  !1 === a.opts.vertical ||
                  ('auto' === a.opts.vertical && i(t).width() > 800)
                ? (a.isSwiping = 'x')
                : ((s = Math.abs((180 * Math.atan2(a.distanceY, a.distanceX)) / Math.PI)),
                  (a.isSwiping = s > 45 && s < 135 ? 'y' : 'x')),
            'y' === a.isSwiping && i.fancybox.isMobile && a.isScrollable)
          )
            return void (a.isScrolling = !0);
          ((r.isDragging = a.isSwiping),
            (a.startPoints = a.newPoints),
            i.each(r.slides, function (t, e) {
              var o, n;
              (i.fancybox.stop(e.$slide),
                (o = i.fancybox.getTranslate(e.$slide)),
                (n = i.fancybox.getTranslate(r.$refs.stage)),
                e.$slide
                  .css({ transform: '', opacity: '', 'transition-duration': '' })
                  .removeClass('fancybox-animated')
                  .removeClass(function (t, e) {
                    return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(' ');
                  }),
                e.pos === r.current.pos &&
                  ((a.sliderStartPos.top = o.top - n.top),
                  (a.sliderStartPos.left = o.left - n.left)),
                i.fancybox.setTranslate(e.$slide, { top: o.top - n.top, left: o.left - n.left }));
            }),
            r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop());
        }
      }),
      (d.prototype.onPan = function () {
        var t = this;
        a(t.newPoints[0], t.realPoints[0]) < (i.fancybox.isMobile ? 10 : 5)
          ? (t.startPoints = t.newPoints)
          : ((t.canTap = !1),
            (t.contentLastPos = t.limitMovement()),
            t.requestId && n(t.requestId),
            (t.requestId = o(function () {
              i.fancybox.setTranslate(t.$content, t.contentLastPos);
            })));
      }),
      (d.prototype.limitMovement = function () {
        var t,
          e,
          i,
          o,
          n,
          s,
          a = this,
          r = a.canvasWidth,
          l = a.canvasHeight,
          c = a.distanceX,
          d = a.distanceY,
          p = a.contentStartPos,
          u = p.left,
          f = p.top,
          h = p.width,
          v = p.height;
        return (
          (n = h > r ? u + c : u),
          (s = f + d),
          (t = Math.max(0, 0.5 * r - 0.5 * h)),
          (e = Math.max(0, 0.5 * l - 0.5 * v)),
          (i = Math.min(r - h, 0.5 * r - 0.5 * h)),
          (o = Math.min(l - v, 0.5 * l - 0.5 * v)),
          c > 0 && n > t && (n = t - 1 + Math.pow(-t + u + c, 0.8) || 0),
          c < 0 && n < i && (n = i + 1 - Math.pow(i - u - c, 0.8) || 0),
          d > 0 && s > e && (s = e - 1 + Math.pow(-e + f + d, 0.8) || 0),
          d < 0 && s < o && (s = o + 1 - Math.pow(o - f - d, 0.8) || 0),
          { top: s, left: n }
        );
      }),
      (d.prototype.limitPosition = function (t, e, i, o) {
        var n = this.canvasWidth,
          s = this.canvasHeight;
        return (
          i > n ? (t = (t = t > 0 ? 0 : t) < n - i ? n - i : t) : (t = Math.max(0, n / 2 - i / 2)),
          o > s ? (e = (e = e > 0 ? 0 : e) < s - o ? s - o : e) : (e = Math.max(0, s / 2 - o / 2)),
          { top: e, left: t }
        );
      }),
      (d.prototype.onZoom = function () {
        var e = this,
          s = e.contentStartPos,
          r = s.width,
          l = s.height,
          c = s.left,
          d = s.top,
          p = a(e.newPoints[0], e.newPoints[1]) / e.startDistanceBetweenFingers,
          u = Math.floor(r * p),
          f = Math.floor(l * p),
          h = (r - u) * e.percentageOfImageAtPinchPointX,
          v = (l - f) * e.percentageOfImageAtPinchPointY,
          g = (e.newPoints[0].x + e.newPoints[1].x) / 2 - i(t).scrollLeft(),
          m = (e.newPoints[0].y + e.newPoints[1].y) / 2 - i(t).scrollTop(),
          b = g - e.centerPointStartX,
          y = { top: d + (v + (m - e.centerPointStartY)), left: c + (h + b), scaleX: p, scaleY: p };
        ((e.canTap = !1),
          (e.newWidth = u),
          (e.newHeight = f),
          (e.contentLastPos = y),
          e.requestId && n(e.requestId),
          (e.requestId = o(function () {
            i.fancybox.setTranslate(e.$content, e.contentLastPos);
          })));
      }),
      (d.prototype.ontouchend = function (t) {
        var o = this,
          a = o.isSwiping,
          r = o.isPanning,
          l = o.isZooming,
          c = o.isScrolling;
        if (
          ((o.endPoints = s(t)),
          (o.dMs = Math.max(new Date().getTime() - o.startTime, 1)),
          o.$container.removeClass('fancybox-is-grabbing'),
          i(e).off('.fb.touch'),
          e.removeEventListener('scroll', o.onscroll, !0),
          o.requestId && (n(o.requestId), (o.requestId = null)),
          (o.isSwiping = !1),
          (o.isPanning = !1),
          (o.isZooming = !1),
          (o.isScrolling = !1),
          (o.instance.isDragging = !1),
          o.canTap)
        )
          return o.onTap(t);
        ((o.speed = 100),
          (o.velocityX = (o.distanceX / o.dMs) * 0.5),
          (o.velocityY = (o.distanceY / o.dMs) * 0.5),
          r ? o.endPanning() : l ? o.endZooming() : o.endSwiping(a, c));
      }),
      (d.prototype.endSwiping = function (t, e) {
        var o = this,
          n = !1,
          s = o.instance.group.length,
          a = Math.abs(o.distanceX),
          r = 'x' == t && s > 1 && ((o.dMs > 130 && a > 10) || a > 50);
        ((o.sliderLastPos = null),
          'y' == t && !e && Math.abs(o.distanceY) > 50
            ? (i.fancybox.animate(
                o.instance.current.$slide,
                { top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY, opacity: 0 },
                200,
              ),
              (n = o.instance.close(!0, 250)))
            : r && o.distanceX > 0
              ? (n = o.instance.previous(300))
              : r && o.distanceX < 0 && (n = o.instance.next(300)),
          !1 !== n || ('x' != t && 'y' != t) || o.instance.centerSlide(200),
          o.$container.removeClass('fancybox-is-sliding'));
      }),
      (d.prototype.endPanning = function () {
        var t,
          e,
          o,
          n = this;
        n.contentLastPos &&
          (!1 === n.opts.momentum || n.dMs > 350
            ? ((t = n.contentLastPos.left), (e = n.contentLastPos.top))
            : ((t = n.contentLastPos.left + 500 * n.velocityX),
              (e = n.contentLastPos.top + 500 * n.velocityY)),
          ((o = n.limitPosition(t, e, n.contentStartPos.width, n.contentStartPos.height)).width =
            n.contentStartPos.width),
          (o.height = n.contentStartPos.height),
          i.fancybox.animate(n.$content, o, 366));
      }),
      (d.prototype.endZooming = function () {
        var t,
          e,
          o,
          n,
          s = this,
          a = s.instance.current,
          r = s.newWidth,
          l = s.newHeight;
        s.contentLastPos &&
          ((t = s.contentLastPos.left),
          (n = {
            top: (e = s.contentLastPos.top),
            left: t,
            width: r,
            height: l,
            scaleX: 1,
            scaleY: 1,
          }),
          i.fancybox.setTranslate(s.$content, n),
          r < s.canvasWidth && l < s.canvasHeight
            ? s.instance.scaleToFit(150)
            : r > a.width || l > a.height
              ? s.instance.scaleToActual(s.centerPointStartX, s.centerPointStartY, 150)
              : ((o = s.limitPosition(t, e, r, l)), i.fancybox.animate(s.$content, o, 150)));
      }),
      (d.prototype.onTap = function (e) {
        var o,
          n = this,
          a = i(e.target),
          r = n.instance,
          l = r.current,
          c = (e && s(e)) || n.startPoints,
          d = c[0] ? c[0].x - i(t).scrollLeft() - n.stagePos.left : 0,
          p = c[0] ? c[0].y - i(t).scrollTop() - n.stagePos.top : 0,
          u = function (t) {
            var o = l.opts[t];
            if ((i.isFunction(o) && (o = o.apply(r, [l, e])), o))
              switch (o) {
                case 'close':
                  r.close(n.startEvent);
                  break;
                case 'toggleControls':
                  r.toggleControls();
                  break;
                case 'next':
                  r.next();
                  break;
                case 'nextOrClose':
                  r.group.length > 1 ? r.next() : r.close(n.startEvent);
                  break;
                case 'zoom':
                  'image' == l.type &&
                    (l.isLoaded || l.$ghost) &&
                    (r.canPan()
                      ? r.scaleToFit()
                      : r.isScaledDown()
                        ? r.scaleToActual(d, p)
                        : r.group.length < 2 && r.close(n.startEvent));
              }
          };
        if (
          (!e.originalEvent || 2 != e.originalEvent.button) &&
          (a.is('img') || !(d > a[0].clientWidth + a.offset().left))
        ) {
          if (a.is('.fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container'))
            o = 'Outside';
          else if (a.is('.fancybox-slide')) o = 'Slide';
          else {
            if (!r.current.$content || !r.current.$content.find(a).addBack().filter(a).length)
              return;
            o = 'Content';
          }
          if (n.tapped) {
            if (
              (clearTimeout(n.tapped),
              (n.tapped = null),
              Math.abs(d - n.tapX) > 50 || Math.abs(p - n.tapY) > 50)
            )
              return this;
            u('dblclick' + o);
          } else
            ((n.tapX = d),
              (n.tapY = p),
              l.opts['dblclick' + o] && l.opts['dblclick' + o] !== l.opts['click' + o]
                ? (n.tapped = setTimeout(function () {
                    ((n.tapped = null), r.isAnimating || u('click' + o));
                  }, 500))
                : u('click' + o));
          return this;
        }
      }),
      i(e)
        .on('onActivate.fb', function (t, e) {
          e && !e.Guestures && (e.Guestures = new d(e));
        })
        .on('beforeClose.fb', function (t, e) {
          e && e.Guestures && e.Guestures.destroy();
        }));
  })(window, document, jQuery),
  (function (t, e) {
    'use strict';
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        slideShow:
          '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
      },
      slideShow: { autoStart: !1, speed: 3e3, progress: !0 },
    });
    var i = function (t) {
      ((this.instance = t), this.init());
    };
    (e.extend(i.prototype, {
      timer: null,
      isActive: !1,
      $button: null,
      init: function () {
        var t = this,
          i = t.instance,
          o = i.group[i.currIndex].opts.slideShow;
        ((t.$button = i.$refs.toolbar.find('[data-fancybox-play]').on('click', function () {
          t.toggle();
        })),
          i.group.length < 2 || !o
            ? t.$button.hide()
            : o.progress &&
              (t.$progress = e('<div class="fancybox-progress"></div>').appendTo(i.$refs.inner)));
      },
      set: function (t) {
        var i = this,
          o = i.instance,
          n = o.current;
        n && (!0 === t || n.opts.loop || o.currIndex < o.group.length - 1)
          ? i.isActive &&
            'video' !== n.contentType &&
            (i.$progress &&
              e.fancybox.animate(i.$progress.show(), { scaleX: 1 }, n.opts.slideShow.speed),
            (i.timer = setTimeout(function () {
              o.current.opts.loop || o.current.index != o.group.length - 1 ? o.next() : o.jumpTo(0);
            }, n.opts.slideShow.speed)))
          : (i.stop(), (o.idleSecondsCounter = 0), o.showControls());
      },
      clear: function () {
        var t = this;
        (clearTimeout(t.timer),
          (t.timer = null),
          t.$progress && t.$progress.removeAttr('style').hide());
      },
      start: function () {
        var t = this,
          e = t.instance.current;
        e &&
          (t.$button
            .attr('title', (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP)
            .removeClass('fancybox-button--play')
            .addClass('fancybox-button--pause'),
          (t.isActive = !0),
          e.isComplete && t.set(!0),
          t.instance.trigger('onSlideShowChange', !0));
      },
      stop: function () {
        var t = this,
          e = t.instance.current;
        (t.clear(),
          t.$button
            .attr('title', (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START)
            .removeClass('fancybox-button--pause')
            .addClass('fancybox-button--play'),
          (t.isActive = !1),
          t.instance.trigger('onSlideShowChange', !1),
          t.$progress && t.$progress.removeAttr('style').hide());
      },
      toggle: function () {
        var t = this;
        t.isActive ? t.stop() : t.start();
      },
    }),
      e(t).on({
        'onInit.fb': function (t, e) {
          e && !e.SlideShow && (e.SlideShow = new i(e));
        },
        'beforeShow.fb': function (t, e, i, o) {
          var n = e && e.SlideShow;
          o ? n && i.opts.slideShow.autoStart && n.start() : n && n.isActive && n.clear();
        },
        'afterShow.fb': function (t, e, i) {
          var o = e && e.SlideShow;
          o && o.isActive && o.set();
        },
        'afterKeydown.fb': function (i, o, n, s, a) {
          var r = o && o.SlideShow;
          !r ||
            !n.opts.slideShow ||
            (80 !== a && 32 !== a) ||
            e(t.activeElement).is('button,a,input') ||
            (s.preventDefault(), r.toggle());
        },
        'beforeClose.fb onDeactivate.fb': function (t, e) {
          var i = e && e.SlideShow;
          i && i.stop();
        },
      }),
      e(t).on('visibilitychange', function () {
        var i = e.fancybox.getInstance(),
          o = i && i.SlideShow;
        o && o.isActive && (t.hidden ? o.clear() : o.set());
      }));
  })(document, jQuery),
  (function (t, e) {
    'use strict';
    var i = (function () {
      for (
        var e = [
            [
              'requestFullscreen',
              'exitFullscreen',
              'fullscreenElement',
              'fullscreenEnabled',
              'fullscreenchange',
              'fullscreenerror',
            ],
            [
              'webkitRequestFullscreen',
              'webkitExitFullscreen',
              'webkitFullscreenElement',
              'webkitFullscreenEnabled',
              'webkitfullscreenchange',
              'webkitfullscreenerror',
            ],
            [
              'webkitRequestFullScreen',
              'webkitCancelFullScreen',
              'webkitCurrentFullScreenElement',
              'webkitCancelFullScreen',
              'webkitfullscreenchange',
              'webkitfullscreenerror',
            ],
            [
              'mozRequestFullScreen',
              'mozCancelFullScreen',
              'mozFullScreenElement',
              'mozFullScreenEnabled',
              'mozfullscreenchange',
              'mozfullscreenerror',
            ],
            [
              'msRequestFullscreen',
              'msExitFullscreen',
              'msFullscreenElement',
              'msFullscreenEnabled',
              'MSFullscreenChange',
              'MSFullscreenError',
            ],
          ],
          i = {},
          o = 0;
        o < e.length;
        o++
      ) {
        var n = e[o];
        if (n && n[1] in t) {
          for (var s = 0; s < n.length; s++) i[e[0][s]] = n[s];
          return i;
        }
      }
      return !1;
    })();
    if (i) {
      var o = {
        request: function (e) {
          (e = e || t.documentElement)[i.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
        },
        exit: function () {
          t[i.exitFullscreen]();
        },
        toggle: function (e) {
          ((e = e || t.documentElement), this.isFullscreen() ? this.exit() : this.request(e));
        },
        isFullscreen: function () {
          return Boolean(t[i.fullscreenElement]);
        },
        enabled: function () {
          return Boolean(t[i.fullscreenEnabled]);
        },
      };
      (e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
          fullScreen:
            '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
        },
        fullScreen: { autoStart: !1 },
      }),
        e(t).on(i.fullscreenchange, function () {
          var t = o.isFullscreen(),
            i = e.fancybox.getInstance();
          i &&
            (i.current &&
              'image' === i.current.type &&
              i.isAnimating &&
              ((i.isAnimating = !1), i.update(!0, !0, 0), i.isComplete || i.complete()),
            i.trigger('onFullscreenChange', t),
            i.$refs.container.toggleClass('fancybox-is-fullscreen', t),
            i.$refs.toolbar
              .find('[data-fancybox-fullscreen]')
              .toggleClass('fancybox-button--fsenter', !t)
              .toggleClass('fancybox-button--fsexit', t));
        }));
    }
    e(t).on({
      'onInit.fb': function (t, e) {
        i
          ? e && e.group[e.currIndex].opts.fullScreen
            ? (e.$refs.container.on(
                'click.fb-fullscreen',
                '[data-fancybox-fullscreen]',
                function (t) {
                  (t.stopPropagation(), t.preventDefault(), o.toggle());
                },
              ),
              e.opts.fullScreen && !0 === e.opts.fullScreen.autoStart && o.request(),
              (e.FullScreen = o))
            : e && e.$refs.toolbar.find('[data-fancybox-fullscreen]').hide()
          : e.$refs.toolbar.find('[data-fancybox-fullscreen]').remove();
      },
      'afterKeydown.fb': function (t, e, i, o, n) {
        e && e.FullScreen && 70 === n && (o.preventDefault(), e.FullScreen.toggle());
      },
      'beforeClose.fb': function (t, e) {
        e && e.FullScreen && e.$refs.container.hasClass('fancybox-is-fullscreen') && o.exit();
      },
    });
  })(document, jQuery),
  (function (t, e) {
    'use strict';
    var i = 'fancybox-thumbs';
    e.fancybox.defaults = e.extend(
      !0,
      {
        btnTpl: {
          thumbs:
            '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
        },
        thumbs: { autoStart: !1, hideOnClose: !0, parentEl: '.fancybox-container', axis: 'y' },
      },
      e.fancybox.defaults,
    );
    var o = function (t) {
      this.init(t);
    };
    (e.extend(o.prototype, {
      $button: null,
      $grid: null,
      $list: null,
      isVisible: !1,
      isActive: !1,
      init: function (t) {
        var e = this,
          i = t.group,
          o = 0;
        ((e.instance = t),
          (e.opts = i[t.currIndex].opts.thumbs),
          (t.Thumbs = e),
          (e.$button = t.$refs.toolbar.find('[data-fancybox-thumbs]')));
        for (var n = 0, s = i.length; n < s && (i[n].thumb && o++, !(o > 1)); n++);
        o > 1 && e.opts
          ? (e.$button.removeAttr('style').on('click', function () {
              e.toggle();
            }),
            (e.isActive = !0))
          : e.$button.hide();
      },
      create: function () {
        var t,
          o = this,
          n = o.instance,
          s = o.opts.parentEl,
          a = [];
        (o.$grid ||
          ((o.$grid = e('<div class="' + i + ' ' + i + '-' + o.opts.axis + '"></div>').appendTo(
            n.$refs.container.find(s).addBack().filter(s),
          )),
          o.$grid.on('click', 'a', function () {
            n.jumpTo(e(this).attr('data-index'));
          })),
          o.$list || (o.$list = e('<div class="' + i + '__list">').appendTo(o.$grid)),
          e.each(n.group, function (e, i) {
            ((t = i.thumb) || 'image' !== i.type || (t = i.src),
              a.push(
                '<a href="javascript:;" tabindex="0" data-index="' +
                  e +
                  '"' +
                  (t && t.length
                    ? ' style="background-image:url(' + t + ')"'
                    : 'class="fancybox-thumbs-missing"') +
                  '></a>',
              ));
          }),
          (o.$list[0].innerHTML = a.join('')),
          'x' === o.opts.axis &&
            o.$list.width(
              parseInt(o.$grid.css('padding-right'), 10) +
                n.group.length * o.$list.children().eq(0).outerWidth(!0),
            ));
      },
      focus: function (t) {
        var e,
          i,
          o = this,
          n = o.$list,
          s = o.$grid;
        o.instance.current &&
          ((i = (e = n
            .children()
            .removeClass('fancybox-thumbs-active')
            .filter('[data-index="' + o.instance.current.index + '"]')
            .addClass('fancybox-thumbs-active')).position()),
          'y' === o.opts.axis && (i.top < 0 || i.top > n.height() - e.outerHeight())
            ? n.stop().animate({ scrollTop: n.scrollTop() + i.top }, t)
            : 'x' === o.opts.axis &&
              (i.left < s.scrollLeft() || i.left > s.scrollLeft() + (s.width() - e.outerWidth())) &&
              n.parent().stop().animate({ scrollLeft: i.left }, t));
      },
      update: function () {
        var t = this;
        (t.instance.$refs.container.toggleClass('fancybox-show-thumbs', this.isVisible),
          t.isVisible
            ? (t.$grid || t.create(), t.instance.trigger('onThumbsShow'), t.focus(0))
            : t.$grid && t.instance.trigger('onThumbsHide'),
          t.instance.update());
      },
      hide: function () {
        ((this.isVisible = !1), this.update());
      },
      show: function () {
        ((this.isVisible = !0), this.update());
      },
      toggle: function () {
        ((this.isVisible = !this.isVisible), this.update());
      },
    }),
      e(t).on({
        'onInit.fb': function (t, e) {
          var i;
          e && !e.Thumbs && (i = new o(e)).isActive && !0 === i.opts.autoStart && i.show();
        },
        'beforeShow.fb': function (t, e, i, o) {
          var n = e && e.Thumbs;
          n && n.isVisible && n.focus(o ? 0 : 250);
        },
        'afterKeydown.fb': function (t, e, i, o, n) {
          var s = e && e.Thumbs;
          s && s.isActive && 71 === n && (o.preventDefault(), s.toggle());
        },
        'beforeClose.fb': function (t, e) {
          var i = e && e.Thumbs;
          i && i.isVisible && !1 !== i.opts.hideOnClose && i.$grid.hide();
        },
      }));
  })(document, jQuery),
  (function (t, e) {
    'use strict';
    (e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        share:
          '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
      },
      share: {
        url: function (t, e) {
          return (
            (!t.currentHash && 'inline' !== e.type && 'html' !== e.type && (e.origSrc || e.src)) ||
            window.location
          );
        },
        tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
      },
    }),
      e(t).on('click', '[data-fancybox-share]', function () {
        var t,
          i,
          o = e.fancybox.getInstance(),
          n = o.current || null;
        n &&
          ('function' === e.type(n.opts.share.url) && (t = n.opts.share.url.apply(n, [o, n])),
          (i = n.opts.share.tpl
            .replace(/\{\{media\}\}/g, 'image' === n.type ? encodeURIComponent(n.src) : '')
            .replace(/\{\{url\}\}/g, encodeURIComponent(t))
            .replace(
              /\{\{url_raw\}\}/g,
              (function (t) {
                var e = {
                  '&': '&amp;',
                  '<': '&lt;',
                  '>': '&gt;',
                  '"': '&quot;',
                  "'": '&#39;',
                  '/': '&#x2F;',
                  '`': '&#x60;',
                  '=': '&#x3D;',
                };
                return String(t).replace(/[&<>"'`=\/]/g, function (t) {
                  return e[t];
                });
              })(t),
            )
            .replace(/\{\{descr\}\}/g, o.$caption ? encodeURIComponent(o.$caption.text()) : '')),
          e.fancybox.open({
            src: o.translate(o, i),
            type: 'html',
            opts: {
              touch: !1,
              animationEffect: !1,
              afterLoad: function (t, e) {
                (o.$refs.container.one('beforeClose.fb', function () {
                  t.close(null, 0);
                }),
                  e.$content.find('.fancybox-share__button').click(function () {
                    return (window.open(this.href, 'Share', 'width=550, height=450'), !1);
                  }));
              },
              mobile: { autoFocus: !1 },
            },
          }));
      }));
  })(document, jQuery),
  (function (t, e, i) {
    'use strict';
    function o() {
      var e = t.location.hash.substr(1),
        i = e.split('-'),
        o = (i.length > 1 && /^\+?\d+$/.test(i[i.length - 1]) && parseInt(i.pop(-1), 10)) || 1;
      return { hash: e, index: o < 1 ? 1 : o, gallery: i.join('-') };
    }
    function n(t) {
      '' !== t.gallery &&
        i("[data-fancybox='" + i.escapeSelector(t.gallery) + "']")
          .eq(t.index - 1)
          .focus()
          .trigger('click.fb-start');
    }
    function s(t) {
      var e, i;
      return (
        !!t &&
        '' !==
          (i =
            (e = t.current ? t.current.opts : t.opts).hash ||
            (e.$orig ? e.$orig.data('fancybox') || e.$orig.data('fancybox-trigger') : '')) &&
        i
      );
    }
    (i.escapeSelector ||
      (i.escapeSelector = function (t) {
        return (t + '').replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (t, e) {
          return e
            ? '\0' === t
              ? '�'
              : t.slice(0, -1) + '\\' + t.charCodeAt(t.length - 1).toString(16) + ' '
            : '\\' + t;
        });
      }),
      i(function () {
        !1 !== i.fancybox.defaults.hash &&
          (i(e).on({
            'onInit.fb': function (t, e) {
              var i, n;
              !1 !== e.group[e.currIndex].opts.hash &&
                ((i = o()),
                (n = s(e)) && i.gallery && n == i.gallery && (e.currIndex = i.index - 1));
            },
            'beforeShow.fb': function (i, o, n, a) {
              var r;
              n &&
                !1 !== n.opts.hash &&
                (r = s(o)) &&
                ((o.currentHash = r + (o.group.length > 1 ? '-' + (n.index + 1) : '')),
                t.location.hash !== '#' + o.currentHash &&
                  (a && !o.origHash && (o.origHash = t.location.hash),
                  o.hashTimer && clearTimeout(o.hashTimer),
                  (o.hashTimer = setTimeout(function () {
                    ('replaceState' in t.history
                      ? (t.history[a ? 'pushState' : 'replaceState'](
                          {},
                          e.title,
                          t.location.pathname + t.location.search + '#' + o.currentHash,
                        ),
                        a && (o.hasCreatedHistory = !0))
                      : (t.location.hash = o.currentHash),
                      (o.hashTimer = null));
                  }, 300))));
            },
            'beforeClose.fb': function (i, o, n) {
              n &&
                !1 !== n.opts.hash &&
                (clearTimeout(o.hashTimer),
                o.currentHash && o.hasCreatedHistory
                  ? t.history.back()
                  : o.currentHash &&
                    ('replaceState' in t.history
                      ? t.history.replaceState(
                          {},
                          e.title,
                          t.location.pathname + t.location.search + (o.origHash || ''),
                        )
                      : (t.location.hash = o.origHash)),
                (o.currentHash = null));
            },
          }),
          i(t).on('hashchange.fb', function () {
            var t = o(),
              e = null;
            (i.each(i('.fancybox-container').get().reverse(), function (t, o) {
              var n = i(o).data('FancyBox');
              if (n && n.currentHash) return ((e = n), !1);
            }),
              e
                ? e.currentHash === t.gallery + '-' + t.index ||
                  (1 === t.index && e.currentHash == t.gallery) ||
                  ((e.currentHash = null), e.close())
                : '' !== t.gallery && n(t));
          }),
          setTimeout(function () {
            i.fancybox.getInstance() || n(o());
          }, 50));
      }));
  })(window, document, jQuery),
  (function (t, e) {
    'use strict';
    var i = new Date().getTime();
    e(t).on({
      'onInit.fb': function (t, e, o) {
        e.$refs.stage.on('mousewheel DOMMouseScroll wheel MozMousePixelScroll', function (t) {
          var o = e.current,
            n = new Date().getTime();
          e.group.length < 2 ||
            !1 === o.opts.wheel ||
            ('auto' === o.opts.wheel && 'image' !== o.type) ||
            (t.preventDefault(),
            t.stopPropagation(),
            o.$slide.hasClass('fancybox-animated') ||
              ((t = t.originalEvent || t),
              n - i < 250 ||
                ((i = n),
                e[
                  (-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0 ? 'next' : 'previous'
                ]())));
        });
      },
    });
  })(document, jQuery),
  (function (t, e) {
    'object' == typeof exports && 'undefined' != typeof module
      ? (module.exports = e())
      : 'function' == typeof define && define.amd
        ? define(e)
        : ((t = 'undefined' != typeof globalThis ? globalThis : t || self).LazyLoad = e());
  })(this, function () {
    'use strict';
    function t() {
      return (t =
        Object.assign ||
        function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var i = arguments[e];
            for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
          }
          return t;
        }).apply(this, arguments);
    }
    var e = 'undefined' != typeof window,
      i =
        (e && !('onscroll' in window)) ||
        ('undefined' != typeof navigator &&
          /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent)),
      o = e && 'IntersectionObserver' in window,
      n = e && 'classList' in document.createElement('p'),
      s = e && window.devicePixelRatio > 1,
      a = {
        elements_selector: '.lazy',
        container: i || e ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: 'src',
        data_srcset: 'srcset',
        data_sizes: 'sizes',
        data_bg: 'bg',
        data_bg_hidpi: 'bg-hidpi',
        data_bg_multi: 'bg-multi',
        data_bg_multi_hidpi: 'bg-multi-hidpi',
        data_poster: 'poster',
        class_applied: 'applied',
        class_loading: 'loading',
        class_loaded: 'loaded',
        class_error: 'error',
        class_entered: 'entered',
        class_exited: 'exited',
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1,
      },
      r = function (e) {
        return t({}, a, e);
      },
      l = function (t, e) {
        var i,
          o = 'LazyLoad::Initialized',
          n = new t(e);
        try {
          i = new CustomEvent(o, { detail: { instance: n } });
        } catch (t) {
          (i = document.createEvent('CustomEvent')).initCustomEvent(o, !1, !1, { instance: n });
        }
        window.dispatchEvent(i);
      },
      c = 'loading',
      d = 'loaded',
      p = 'applied',
      u = 'error',
      f = 'native',
      h = function (t, e) {
        return t.getAttribute('data-' + e);
      },
      v = function (t) {
        return h(t, 'll-status');
      },
      g = function (t, e) {
        return (function (t, e, i) {
          var o = 'data-ll-status';
          null !== i ? t.setAttribute(o, i) : t.removeAttribute(o);
        })(t, 0, e);
      },
      m = function (t) {
        return g(t, null);
      },
      b = function (t) {
        return null === v(t);
      },
      y = function (t) {
        return v(t) === f;
      },
      w = [c, d, p, u],
      $ = function (t, e, i, o) {
        t && (void 0 === o ? (void 0 === i ? t(e) : t(e, i)) : t(e, i, o));
      },
      x = function (t, e) {
        n ? t.classList.add(e) : (t.className += (t.className ? ' ' : '') + e);
      },
      _ = function (t, e) {
        n
          ? t.classList.remove(e)
          : (t.className = t.className
              .replace(new RegExp('(^|\\s+)' + e + '(\\s+|$)'), ' ')
              .replace(/^\s+/, '')
              .replace(/\s+$/, ''));
      },
      k = function (t) {
        return t.llTempImage;
      },
      C = function (t, e) {
        if (e) {
          var i = e._observer;
          i && i.unobserve(t);
        }
      },
      S = function (t, e) {
        t && (t.loadingCount += e);
      },
      T = function (t, e) {
        t && (t.toLoadCount = e);
      },
      z = function (t) {
        for (var e, i = [], o = 0; (e = t.children[o]); o += 1) 'SOURCE' === e.tagName && i.push(e);
        return i;
      },
      A = function (t, e, i) {
        i && t.setAttribute(e, i);
      },
      P = function (t, e) {
        t.removeAttribute(e);
      },
      L = function (t) {
        return !!t.llOriginalAttrs;
      },
      E = function (t) {
        if (!L(t)) {
          var e = {};
          ((e.src = t.getAttribute('src')),
            (e.srcset = t.getAttribute('srcset')),
            (e.sizes = t.getAttribute('sizes')),
            (t.llOriginalAttrs = e));
        }
      },
      I = function (t) {
        if (L(t)) {
          var e = t.llOriginalAttrs;
          (A(t, 'src', e.src), A(t, 'srcset', e.srcset), A(t, 'sizes', e.sizes));
        }
      },
      M = function (t, e) {
        (A(t, 'sizes', h(t, e.data_sizes)),
          A(t, 'srcset', h(t, e.data_srcset)),
          A(t, 'src', h(t, e.data_src)));
      },
      O = function (t) {
        (P(t, 'src'), P(t, 'srcset'), P(t, 'sizes'));
      },
      H = function (t, e) {
        var i = t.parentNode;
        i && 'PICTURE' === i.tagName && z(i).forEach(e);
      },
      j = {
        IMG: function (t, e) {
          (H(t, function (t) {
            (E(t), M(t, e));
          }),
            E(t),
            M(t, e));
        },
        IFRAME: function (t, e) {
          A(t, 'src', h(t, e.data_src));
        },
        VIDEO: function (t, e) {
          (!(function (t, i) {
            z(t).forEach(function (t) {
              A(t, 'src', h(t, e.data_src));
            });
          })(t),
            A(t, 'poster', h(t, e.data_poster)),
            A(t, 'src', h(t, e.data_src)),
            t.load());
        },
      },
      F = function (t, e) {
        var i = j[t.tagName];
        i && i(t, e);
      },
      q = function (t, e, i) {
        (S(i, 1), x(t, e.class_loading), g(t, c), $(e.callback_loading, t, i));
      },
      D = ['IMG', 'IFRAME', 'VIDEO'],
      B = function (t, e) {
        !e ||
          (function (t) {
            return t.loadingCount > 0;
          })(e) ||
          (function (t) {
            return t.toLoadCount > 0;
          })(e) ||
          $(t.callback_finish, e);
      },
      R = function (t, e, i) {
        (t.addEventListener(e, i), (t.llEvLisnrs[e] = i));
      },
      W = function (t, e, i) {
        t.removeEventListener(e, i);
      },
      N = function (t) {
        return !!t.llEvLisnrs;
      },
      V = function (t) {
        if (N(t)) {
          var e = t.llEvLisnrs;
          for (var i in e) {
            var o = e[i];
            W(t, i, o);
          }
          delete t.llEvLisnrs;
        }
      },
      X = function (t, e, i) {
        (!(function (t) {
          delete t.llTempImage;
        })(t),
          S(i, -1),
          (function (t) {
            t && (t.toLoadCount -= 1);
          })(i),
          _(t, e.class_loading),
          e.unobserve_completed && C(t, i));
      },
      Y = function (t, e, i) {
        var o = k(t) || t;
        N(o) ||
          (function (t, e, i) {
            N(t) || (t.llEvLisnrs = {});
            var o = 'VIDEO' === t.tagName ? 'loadeddata' : 'load';
            (R(t, o, e), R(t, 'error', i));
          })(
            o,
            function (n) {
              (!(function (t, e, i, o) {
                var n = y(e);
                (X(e, i, o),
                  x(e, i.class_loaded),
                  g(e, d),
                  $(i.callback_loaded, e, o),
                  n || B(i, o));
              })(0, t, e, i),
                V(o));
            },
            function (n) {
              (!(function (t, e, i, o) {
                var n = y(e);
                (X(e, i, o), x(e, i.class_error), g(e, u), $(i.callback_error, e, o), n || B(i, o));
              })(0, t, e, i),
                V(o));
            },
          );
      },
      U = function (t, e, i) {
        !(function (t) {
          return D.indexOf(t.tagName) > -1;
        })(t)
          ? (function (t, e, i) {
              (!(function (t) {
                t.llTempImage = document.createElement('IMG');
              })(t),
                Y(t, e, i),
                (function (t, e, i) {
                  var o = h(t, e.data_bg),
                    n = h(t, e.data_bg_hidpi),
                    a = s && n ? n : o;
                  a &&
                    ((t.style.backgroundImage = 'url("'.concat(a, '")')),
                    k(t).setAttribute('src', a),
                    q(t, e, i));
                })(t, e, i),
                (function (t, e, i) {
                  var o = h(t, e.data_bg_multi),
                    n = h(t, e.data_bg_multi_hidpi),
                    a = s && n ? n : o;
                  a &&
                    ((t.style.backgroundImage = a),
                    (function (t, e, i) {
                      (x(t, e.class_applied),
                        g(t, p),
                        e.unobserve_completed && C(t, e),
                        $(e.callback_applied, t, i));
                    })(t, e, i));
                })(t, e, i));
            })(t, e, i)
          : (function (t, e, i) {
              (Y(t, e, i), F(t, e), q(t, e, i));
            })(t, e, i);
      },
      G = ['IMG', 'IFRAME'],
      Q = function (t) {
        return t.use_native && 'loading' in HTMLImageElement.prototype;
      },
      Z = function (t) {
        return Array.prototype.slice.call(t);
      },
      J = function (t) {
        return t.container.querySelectorAll(t.elements_selector);
      },
      K = function (t) {
        return (function (t) {
          return v(t) === u;
        })(t);
      },
      tt = function (t, e) {
        return (function (t) {
          return Z(t).filter(b);
        })(t || J(e));
      },
      et = function (t, i) {
        var n = r(t);
        ((this._settings = n),
          (this.loadingCount = 0),
          (function (t, e) {
            o &&
              !Q(t) &&
              (e._observer = new IntersectionObserver(
                function (i) {
                  !(function (t, e, i) {
                    t.forEach(function (t) {
                      return (function (t) {
                        return t.isIntersecting || t.intersectionRatio > 0;
                      })(t)
                        ? (function (t, e, i, o) {
                            var n = (function (t) {
                              return w.indexOf(v(t)) >= 0;
                            })(t);
                            (g(t, 'entered'),
                              x(t, i.class_entered),
                              _(t, i.class_exited),
                              (function (t, e, i) {
                                e.unobserve_entered && C(t, i);
                              })(t, i, o),
                              $(i.callback_enter, t, e, o),
                              n || U(t, i, o));
                          })(t.target, t, e, i)
                        : (function (t, e, i, o) {
                            b(t) ||
                              (x(t, i.class_exited),
                              (function (t, e, i, o) {
                                i.cancel_on_exit &&
                                  (function (t) {
                                    return v(t) === c;
                                  })(t) &&
                                  'IMG' === t.tagName &&
                                  (V(t),
                                  (function (t) {
                                    (H(t, function (t) {
                                      O(t);
                                    }),
                                      O(t));
                                  })(t),
                                  (function (t) {
                                    (H(t, function (t) {
                                      I(t);
                                    }),
                                      I(t));
                                  })(t),
                                  _(t, i.class_loading),
                                  S(o, -1),
                                  m(t),
                                  $(i.callback_cancel, t, e, o));
                              })(t, e, i, o),
                              $(i.callback_exit, t, e, o));
                          })(t.target, t, e, i);
                    });
                  })(i, t, e);
                },
                (function (t) {
                  return {
                    root: t.container === document ? null : t.container,
                    rootMargin: t.thresholds || t.threshold + 'px',
                  };
                })(t),
              ));
          })(n, this),
          (function (t, i) {
            e &&
              window.addEventListener('online', function () {
                !(function (t, e) {
                  var i;
                  (((i = J(t)), Z(i).filter(K)).forEach(function (e) {
                    (_(e, t.class_error), m(e));
                  }),
                    e.update());
                })(t, i);
              });
          })(n, this),
          this.update(i));
      };
    return (
      (et.prototype = {
        update: function (t) {
          var e,
            n,
            s = this._settings,
            a = tt(t, s);
          (T(this, a.length),
            !i && o
              ? Q(s)
                ? (function (t, e, i) {
                    (t.forEach(function (t) {
                      -1 !== G.indexOf(t.tagName) &&
                        (t.setAttribute('loading', 'lazy'),
                        (function (t, e, i) {
                          (Y(t, e, i), F(t, e), g(t, f));
                        })(t, e, i));
                    }),
                      T(i, 0));
                  })(a, s, this)
                : ((n = a),
                  (function (t) {
                    t.disconnect();
                  })((e = this._observer)),
                  (function (t, e) {
                    e.forEach(function (e) {
                      t.observe(e);
                    });
                  })(e, n))
              : this.loadAll(a));
        },
        destroy: function () {
          (this._observer && this._observer.disconnect(),
            J(this._settings).forEach(function (t) {
              delete t.llOriginalAttrs;
            }),
            delete this._observer,
            delete this._settings,
            delete this.loadingCount,
            delete this.toLoadCount);
        },
        loadAll: function (t) {
          var e = this,
            i = this._settings;
          tt(t, i).forEach(function (t) {
            (C(t, e), U(t, i, e));
          });
        },
      }),
      (et.load = function (t, e) {
        var i = r(e);
        U(t, i);
      }),
      (et.resetStatus = function (t) {
        m(t);
      }),
      e &&
        (function (t, e) {
          if (e)
            if (e.length) for (var i, o = 0; (i = e[o]); o += 1) l(t, i);
            else l(t, e);
        })(et, window.lazyLoadOptions),
      et
    );
  }));
var confetti = {
  maxCount: 150,
  speed: 2,
  frameInterval: 15,
  alpha: 1,
  gradient: !1,
  start: null,
  stop: null,
  toggle: null,
  pause: null,
  resume: null,
  togglePause: null,
  remove: null,
  isPaused: null,
  isRunning: null,
};
function validate_email(t) {
  return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(
    t,
  );
}
function set_discount(t) {
  'undefined' != typeof Storage &&
    (0 == t
      ? null !== sessionStorage.getItem('automatic_discount_code') &&
        sessionStorage.removeItem('automatic_discount_code')
      : sessionStorage.setItem('automatic_discount_code', t));
}
(!(function () {
  ((confetti.start = u),
    (confetti.stop = f),
    (confetti.toggle = function () {
      i ? f() : u();
    }),
    (confetti.pause = c),
    (confetti.resume = d),
    (confetti.togglePause = function () {
      o ? d() : c();
    }),
    (confetti.isPaused = function () {
      return o;
    }),
    (confetti.remove = function () {
      (stop(), (o = !1), (s = []));
    }),
    (confetti.isRunning = function () {
      return i;
    }));
  var t =
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame,
    e = [
      'rgba(30,144,255,',
      'rgba(107,142,35,',
      'rgba(255,215,0,',
      'rgba(255,192,203,',
      'rgba(106,90,205,',
      'rgba(173,216,230,',
      'rgba(238,130,238,',
      'rgba(152,251,152,',
      'rgba(70,130,180,',
      'rgba(244,164,96,',
      'rgba(210,105,30,',
      'rgba(220,20,60,',
    ],
    i = !1,
    o = !1,
    n = Date.now(),
    s = [],
    a = 0,
    r = null;
  function l(t, i, o) {
    return (
      (t.color = e[(Math.random() * e.length) | 0] + (confetti.alpha + ')')),
      (t.color2 = e[(Math.random() * e.length) | 0] + (confetti.alpha + ')')),
      (t.x = Math.random() * i),
      (t.y = Math.random() * o - o),
      (t.diameter = 10 * Math.random() + 5),
      (t.tilt = 10 * Math.random() - 10),
      (t.tiltAngleIncrement = 0.07 * Math.random() + 0.05),
      (t.tiltAngle = Math.random() * Math.PI),
      t
    );
  }
  function c() {
    o = !0;
  }
  function d() {
    ((o = !1), p());
  }
  function p() {
    if (!o)
      if (0 === s.length) r.clearRect(0, 0, window.innerWidth, window.innerHeight);
      else {
        var e = Date.now(),
          c = e - n;
        ((!t || c > confetti.frameInterval) &&
          (r.clearRect(0, 0, window.innerWidth, window.innerHeight),
          (function () {
            var t,
              e = window.innerWidth,
              o = window.innerHeight;
            a += 0.01;
            for (var n = 0; n < s.length; n++)
              ((t = s[n]),
                !i && t.y < -15
                  ? (t.y = o + 100)
                  : ((t.tiltAngle += t.tiltAngleIncrement),
                    (t.x += Math.sin(a) - 0.5),
                    (t.y += 0.5 * (Math.cos(a) + t.diameter + confetti.speed)),
                    (t.tilt = 15 * Math.sin(t.tiltAngle))),
                (t.x > e + 20 || t.x < -20 || t.y > o) &&
                  (i && s.length <= confetti.maxCount ? l(t, e, o) : (s.splice(n, 1), n--)));
          })(),
          (function (t) {
            for (var e, i, o, n, a = 0; a < s.length; a++) {
              if (
                ((e = s[a]),
                t.beginPath(),
                (t.lineWidth = e.diameter),
                (i = (o = e.x + e.tilt) + e.diameter / 2),
                (n = e.y + e.tilt + e.diameter / 2),
                confetti.gradient)
              ) {
                var r = t.createLinearGradient(i, e.y, o, n);
                (r.addColorStop('0', e.color),
                  r.addColorStop('1.0', e.color2),
                  (t.strokeStyle = r));
              } else t.strokeStyle = e.color;
              (t.moveTo(i, e.y), t.lineTo(o, n), t.stroke());
            }
          })(r),
          (n = e - (c % confetti.frameInterval))),
          requestAnimationFrame(p));
      }
  }
  function u(t, e, n) {
    var a = window.innerWidth,
      c = window.innerHeight;
    window.requestAnimationFrame =
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (t) {
        return window.setTimeout(t, confetti.frameInterval);
      };
    var d = document.getElementById('confetti-canvas');
    null === d
      ? ((d = document.createElement('canvas')).setAttribute('id', 'confetti-canvas'),
        d.setAttribute(
          'style',
          'display:block;z-index:999999;pointer-events:none;position:fixed;top:0',
        ),
        document.body.prepend(d),
        (d.width = a),
        (d.height = c),
        window.addEventListener(
          'resize',
          function () {
            ((d.width = window.innerWidth), (d.height = window.innerHeight));
          },
          !0,
        ),
        (r = d.getContext('2d')))
      : null === r && (r = d.getContext('2d'));
    var u = confetti.maxCount;
    if (e)
      if (n)
        if (e == n) u = s.length + n;
        else {
          if (e > n) {
            var h = e;
            ((e = n), (n = h));
          }
          u = s.length + ((Math.random() * (n - e) + e) | 0);
        }
      else u = s.length + e;
    else n && (u = s.length + n);
    for (; s.length < u; ) s.push(l({}, a, c));
    ((i = !0), (o = !1), p(), t && window.setTimeout(f, t));
  }
  function f() {
    i = !1;
  }
})(),
  -1 != navigator.userAgent.indexOf('Chrome') && $('body').addClass('chrome'),
  -1 != navigator.userAgent.indexOf('Firefox') && $('body').addClass('firefox'),
  -1 != navigator.userAgent.indexOf('Safari') && $('body').addClass('safari'),
  -1 != navigator.userAgent.indexOf('Instagram') && $('body').addClass('instagram'),
  navigator.userAgent.match(/Trident.*rv:11\./) && $('body').addClass('ie11'),
  navigator.userAgent.match(/Edge/) && $('body').addClass('edge'),
  -1 != navigator.userAgent.indexOf('MSIE') && $('body').addClass('ie'),
  navigator.userAgent.match(/iPhone/i) && $('body').addClass('iphone-ios'),
  navigator.userAgent.match(/iPad/i) && $('body').addClass('ipad-ios'),
  ($.fancybox.defaults.buttons = ['close']),
  ($.fancybox.defaults.clickContent = !1),
  ($.fancybox.defaults.dblclickContent = !1),
  ($.fancybox.defaults.hideScrollbar = !0),
  ($.fancybox.defaults.infobar = !1),
  ($.fancybox.defaults.hash = !1));
var lazyLoad = new LazyLoad({ elements_selector: '.lazy' });
function calculate_hh() {
  var t = document.getElementById('top').offsetHeight;
  if (
    (document.documentElement.style.setProperty('--hh', t + 'px'),
    $('body').hasClass('ie') || $('body').hasClass('ie11') || $('body').hasClass('edge'))
  ) {
    var e = t + 96,
      i = t + 32;
    ($('section.top-banner div.top-banner__slides div.slide').css('padding-top', t + 'px'),
      $('section.top-banner div.editorial').css('padding-top', t + 'px'),
      $('section.top-banner div.collection').css('margin-top', t + 'px'),
      $('section.showroom').css('margin-top', i + 'px'),
      $('section.single-product').css('margin-top', i + 'px'),
      $('section.top-banner div.basic-title').css('margin-top', i + 'px'),
      $('section.top-element').css('padding-top', e + 'px'),
      $('div.flexible-layouts.top-element').css('margin-top', t + 'px'));
  }
}
function scrolling_header() {
  $('body').hasClass('template-article') ||
    ($(window).scrollTop() > 1
      ? $('body').addClass('scrolled')
      : $('body').removeClass('scrolled'));
}
function get_cookie(t) {
  var e = document.cookie,
    i = t + '=',
    o = e.indexOf('; ' + i);
  if (-1 == o) {
    if (0 != (o = e.indexOf(i))) return null;
  } else {
    o += 2;
    var n = document.cookie.indexOf(';', o);
    -1 == n && (n = e.length);
  }
  return decodeURI(e.substring(o + i.length, n));
}
function desktop_menu() {
  window.innerWidth <= 1280 &&
    ($('body').removeClass('offset-menu-active'), hide_active_offset_sub_menus());
}
function hide_active_offset_sub_menus() {
  ($(
    'div.offset-menu div.offset-menu-wrapper div.offset-menu-columns div.column.column-2',
  ).removeClass('add-border'),
    $(
      'div.offset-menu div.offset-menu-wrapper div.offset-menu-columns div.column nav.sub-menu ul.menu li.level-1',
    ).each(function () {
      $(this).removeClass('active');
    }));
}
function check_offset_sub_menus_visibility() {
  var t = !1;
  ($(
    'div.offset-menu div.offset-menu-wrapper div.offset-menu-columns div.column nav.sub-menu ul.menu li.level-1 div.sub-sub-menu-wrapper',
  ).each(function () {
    t = !!$(this).is(':visible');
  }),
    1 == t
      ? $(
          'div.offset-menu div.offset-menu-wrapper div.offset-menu-columns div.column.column-2',
        ).addClass('add-border')
      : $(
          'div.offset-menu div.offset-menu-wrapper div.offset-menu-columns div.column.column-2',
        ).removeClass('add-border'));
}
function mobile_menu() {
  window.innerWidth >= 1280 && $('body').removeClass('mobile-menu-active');
}
function collection_page_colour() {
  if ($('body').hasClass('template-collection')) {
    var t = $('div.page-shift').data('colour'),
      e = $('div.page-shift').data('text');
    t &&
      e &&
      ($('div.page-shift').css({ 'background-color': t }),
      $(window).scrollTop() > 200
        ? ($('div.page-shift').css({ 'background-color': '#ffffff' }),
          'text-white' == e && $('div.page-shift').removeClass('text-white'),
          $('div.page-shift').addClass('switch-logo'))
        : ($('div.page-shift').css({ 'background-color': t }),
          'text-white' == e && $('div.page-shift').addClass('text-white'),
          $('div.page-shift').removeClass('switch-logo')));
  }
}
function get_selected_sizes() {
  var t = $('.sizes div.option-wrapper input[type="checkbox"]:checked'),
    e = t
      .map(function () {
        return this.value;
      })
      .get()
      .join(',');
  $('input#filter-sizes').val(t.length > 0 ? e : '');
}
function get_selected_price_range() {
  var t = $('div.filter-results'),
    e = t.find('div.filter-results__tags'),
    i = parseInt(t.find('span.filter-count').text()),
    o = get_url_parameter('filter.v.price.gte'),
    n = get_url_parameter('filter.v.price.lte');
  if (o || n)
    if (parseInt(o) < parseInt(n)) {
      if (parseInt(o) >= 0 && parseInt(o) <= 450 && parseInt(n) >= 50)
        if (o && n) {
          if (
            (initialise_price_range_slider(o, n),
            $('input#filter-price-range').val(o + ',' + n),
            $('input#price-range').val(o + ',' + n),
            (r = (a = o + ',' + n).split(',')).length > 0)
          ) {
            if (((i += 1), parseInt(r[1]) >= 500)) var s = '500+';
            else s = r[1];
            (t.find('span.filter-count').text(i),
              e.append(
                '<span class="tag uppercase">' +
                  currency_symbol +
                  r[0] +
                  ' - ' +
                  currency_symbol +
                  s +
                  '</span>',
              ));
          }
        } else {
          if (o) {
            (initialise_price_range_slider(o, 500),
              $('input#filter-price-range').val(o + ',500'),
              $('input#price-range').val(o + ',500'));
            var a = o + ',500';
          }
          if (n) {
            (initialise_price_range_slider(0, n),
              $('input#filter-price-range').val('0,' + n),
              $('input#price-range').val('0,' + n));
            var a = '0,' + n;
          }
          if ((r = a.split(',')).length > 0) {
            if (((i += 1), parseInt(r[1]) >= 500)) s = '500+';
            else s = r[1];
            (t.find('span.filter-count').text(i),
              e.append(
                '<span class="tag uppercase">' +
                  currency_symbol +
                  r[0] +
                  ' - ' +
                  currency_symbol +
                  s +
                  '</span>',
              ));
          }
        }
      else if (
        (initialise_price_range_slider(0, 500),
        $('input#filter-price-range').val('0, 500'),
        $('input#price-range').val('0, 500'),
        (r = (a = '0, 500').split(',')).length > 0)
      ) {
        if (((i += 1), parseInt(r[1]) >= 500)) s = '500+';
        else s = r[1];
        (t.find('span.filter-count').text(i),
          e.append(
            '<span class="tag uppercase">' +
              currency_symbol +
              r[0] +
              ' - ' +
              currency_symbol +
              s +
              '</span>',
          ));
      }
    } else {
      if (o) {
        (initialise_price_range_slider(o, 500),
          $('input#filter-price-range').val(o + ',500'),
          $('input#price-range').val(o + ',500'));
        a = o + ',500';
      }
      if (n) {
        (initialise_price_range_slider(0, n),
          $('input#filter-price-range').val('0,' + n),
          $('input#price-range').val('0,' + n));
        a = '0,' + n;
      }
      var r;
      if ((r = a.split(',')).length > 0) {
        if (((i += 1), parseInt(r[1]) >= 500)) s = '500+';
        else s = r[1];
        (t.find('span.filter-count').text(i),
          e.append(
            '<span class="tag uppercase">' +
              currency_symbol +
              r[0] +
              ' - ' +
              currency_symbol +
              s +
              '</span>',
          ));
      }
    }
  else (initialise_price_range_slider(0, 500), $('input#filter-price-range').val('0, 500'));
}
function initialise_price_range_slider(t, e) {
  (e > 500 && (e = 500),
    $('div.price-range div.price-range__slider').slider({
      range: !0,
      step: 50,
      min: 0,
      max: 500,
      values: [t, e],
      create: function () {
        ($(this)
          .parents('div.price-range')
          .find('span.price-range__min')
          .html(currency_symbol + t),
          500 == e
            ? $(this)
                .parents('div.price-range')
                .find('span.price-range__max')
                .html(currency_symbol + e + '+')
            : $(this)
                .parents('div.price-range')
                .find('span.price-range__max')
                .html(currency_symbol + e));
      },
      slide: function (t, e) {
        if (e.values[0] + 50 > e.values[1]) return !1;
        ($(e.handle)
          .parents('div.price-range')
          .find('span.price-range__min')
          .html(currency_symbol + e.values[0]),
          500 == e.values[1]
            ? $(e.handle)
                .parents('div.price-range')
                .find('span.price-range__max')
                .html(currency_symbol + e.values[1] + '+')
            : $(e.handle)
                .parents('div.price-range')
                .find('span.price-range__max')
                .html(currency_symbol + e.values[1]),
          e.values[1] < 500
            ? $('input#filter-price-range').val(e.values[0] + ',' + e.values[1])
            : $('input#filter-price-range').val(e.values[0] + ',500'));
      },
    }));
}
function get_selected_custom_one() {
  var t = $('.custom-one div.option-wrapper input[type="checkbox"]:checked'),
    e = t
      .map(function () {
        return $(this).data('title');
      })
      .get()
      .join(',');
  $('input#filter-custom-one').val(t.length > 0 ? e : '');
}
function get_selected_custom_two() {
  var t = $('.custom-two div.option-wrapper input[type="checkbox"]:checked'),
    e = t
      .map(function () {
        return $(this).data('title');
      })
      .get()
      .join(',');
  $('input#filter-custom-two').val(t.length > 0 ? e : '');
}
function get_selected_colours() {
  var t = $('.colours ul.colour-filters li input[type="checkbox"]:checked'),
    e = t
      .map(function () {
        return $(this).data('title');
      })
      .get()
      .join(',');
  $('input#filter-colours').val(t.length > 0 ? e : '');
}
function get_selected_themes() {
  var t = $('.themes ul.theme-filters li input[type="checkbox"]:checked'),
    e = t
      .map(function () {
        return this.value;
      })
      .get()
      .join(',');
  $('input#filter-themes').val(t.length > 0 ? e : '');
}
function find_common_elements(t, e) {
  for (let i = 0; i < t.length; i++)
    for (let o = 0; o < e.length; o++) if (t[i] === e[o]) return !0;
  return !1;
}
function find_matching_elements(t, e) {
  var i = t.length;
  if (!(i <= e.length)) return !1;
  for (var o = 0; o < i; o++) if (!(e.indexOf(t[o]) >= 0)) return !1;
  return !0;
}
function collection_filter_all(t) {
  var e = $('select#sort-by option:selected').val(),
    i = $('div.filter-results input#filter-url').val(),
    o = '';
  if (((o = '' !== e ? '?sort_by=' + e + '&view=filter' : '?view=filter'), '' !== i)) {
    var n = i + o;
    $.ajax({
      url: n,
      type: 'GET',
      beforeSend: function () {
        $('section.collection div.products__wrapper button.view-all-products').append(
          '<span class="ajax-loader"></span>',
        );
      },
      success: function (e) {
        var i = JSON.parse(e);
        (i.products &&
          (i.products.splice(0, t),
          $.each(i.products, function (t, e) {
            $('section.collection div.products__wrapper div.products').append(e.data);
          })),
          $('section.collection div.products__wrapper div.pagination').remove(),
          $('section.collection div.products__wrapper div.view-all-wrapper').remove(),
          $(
            'section.collection div.products__wrapper button.view-all-products span.ajax-loader',
          ).remove());
      },
      complete: function () {
        (lazyLoad.update(),
          initialise_quickview(),
          initialise_size_guide(),
          initialise_stock_notification());
      },
    });
  }
}
function get_url_parameter(t) {
  t = t.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var e = new RegExp('[\\?&]' + t + '=([^&#]*)').exec(location.search);
  return null === e ? '' : decodeURIComponent(e[1].replace(/\+/g, ' '));
}
function get_filtered_state() {
  var t = window.location.pathname.split('/');
  if (t.length >= 3 && -1 !== $.inArray('collections', t)) {
    if (t.length > 3) {
      var e = window.location.pathname.split('/').pop().split('+').filter(Boolean);
      e.length > 0 &&
        ($.each(e, function (t, e) {
          var i = e.toLowerCase().replace(/ /g, '-');
          ($('ul.theme-filters li.' + i).addClass('checked'),
            $('ul.theme-filters li.' + i + ' input[value="' + i + '"]').attr('checked', !0),
            $('ul.colour-filters li.' + i).addClass('checked'),
            $('ul.colour-filters li.' + i + ' input[value="' + i + '"]').attr('checked', !0),
            $('div.sliding-filter div.option-wrapper.' + i + ' input[value="' + i + '"]').attr(
              'checked',
              !0,
            ));
        }),
        get_selected_themes(),
        get_selected_colours(),
        get_selected_custom_one(),
        get_selected_custom_two());
    }
    get_selected_price_range();
  }
}
function collection_filter(t = !1) {
  var e = $('select#sort-by option:selected').val(),
    i = $('select#sort-by option:selected').attr('data-discount'),
    o = $('div.filter-results input#sizes').val(),
    n = $('div.filter-results input#price-range').val().split(',');
  if (parseInt(n[1]) >= 500) var s = 'filter.v.price.gte=' + n[0];
  else s = 'filter.v.price.gte=' + n[0] + '&filter.v.price.lte=' + n[1];
  var a = $('div.filter-results input#tags').val(),
    r = $('div.filter-results input#filter-url').val();
  if (0 == t) var l = $('div.filter-results input#collection-url').val();
  else l = t;
  if (void 0 !== i)
    if ('true' == i) var c = !0;
    else c = !1;
  else c = !1;
  var d = '',
    p = '?' + s;
  d = '' !== e ? '?sort_by=' + e + '&' + s + '&view=filter' : '?' + s + '&view=filter';
  var u = [];
  if ('' !== l) {
    var f = l + d;
    $.ajax({
      url: f,
      type: 'GET',
      beforeSend: function () {
        ($('section.collection div.products__wrapper div.products').remove(),
          $('section.collection div.products__wrapper div.pagination').remove(),
          $('section.collection div.products__wrapper div.view-all-wrapper').remove(),
          $('section.collection div.products__wrapper div.results p.no-results').remove());
        $('section.collection div.products__wrapper').prepend(
          '<svg version="1.1" class="ajax-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24.1 9.4" style="enable-background:new 0 0 24.1 9.4;" xml:space="preserve"><path d="M9.6,3C9,1.5,7.5,0.4,5.8,0.4c-1.9,0-3.5,1.3-3.9,3.1H0.5v2.4H2c0.6,1.6,2.1,2.8,3.8,2.8c1.9,0,3.6-1.4,4-3.3h5.5v2.7h1.9 V6.6h1.1v2.1h1.9V6.6h0.9v2.2H23V5.4h0.7V3H9.6z M5.8,6.7c-1.1,0-2-0.9-2-2.1c0-1.1,0.9-2.1,2-2.1c1.1,0,2,0.9,2,2.1 C7.8,5.7,6.9,6.7,5.8,6.7z" /></svg>',
        );
      },
      success: function (t) {
        var e = a.toLowerCase().replace(/ /g, '-').split(',').join('+');
        r == l
          ? ($('div.filter-results input#filter-url').val(l + '/' + e),
            window.history.replaceState(null, null, l + '/' + e + p))
          : (window.history.replaceState(null, null, e + p),
            $('div.filter-results input#filter-url').val(l + '/' + e));
        var i = o.split(','),
          n = a.split(','),
          s = 0,
          d = JSON.parse(t);
        (d.products &&
          ($('section.collection div.products__wrapper').append(
            '<div class="products with-border grid-container grid-one-forth"></div>',
          ),
          $.each(d.products, function (t, e) {
            var o = find_common_elements(n, e.tags);
            (-1 == $.inArray('all', i)
              ? '' == a
                ? 1 == c
                  ? 1 == e.sale &&
                    1 == e.availability &&
                    $.each(e.variants, function (t, o) {
                      var n = o.title.toLowerCase().replace(/ /g, '-');
                      -1 !== $.inArray(n, i) &&
                        o.inventory_quantity > 0 &&
                        (u.includes(e.id) || u.push(e.id));
                    })
                  : 1 == e.availability &&
                    $.each(e.variants, function (t, o) {
                      var n = o.title.toLowerCase().replace(/ /g, '-');
                      -1 !== $.inArray(n, i) &&
                        o.inventory_quantity > 0 &&
                        (u.includes(e.id) || u.push(e.id));
                    })
                : 1 == c
                  ? 1 == e.sale &&
                    1 == o &&
                    1 == e.availability &&
                    $.each(e.variants, function (t, o) {
                      var n = o.title.toLowerCase().replace(/ /g, '-');
                      -1 !== $.inArray(n, i) &&
                        o.inventory_quantity > 0 &&
                        (u.includes(e.id) || u.push(e.id));
                    })
                  : 1 == o &&
                    1 == e.availability &&
                    $.each(e.variants, function (t, o) {
                      var n = o.title.toLowerCase().replace(/ /g, '-');
                      -1 !== $.inArray(n, i) &&
                        o.inventory_quantity > 0 &&
                        (u.includes(e.id) || u.push(e.id));
                    })
              : '' == a
                ? 1 == c
                  ? 1 == e.sale && (u.includes(e.id) || u.push(e.id))
                  : u.includes(e.id) || u.push(e.id)
                : 1 == c
                  ? 1 == e.sale && 1 == o && (u.includes(e.id) || u.push(e.id))
                  : 1 == o && (u.includes(e.id) || u.push(e.id)),
              -1 !== $.inArray(e.id, u) &&
                (s++, $('section.collection div.products__wrapper div.products').append(e.data)));
          })),
          0 == parseInt(s) &&
            ($('section.collection div.products__wrapper div.products').remove(),
            $('section.collection div.products__wrapper div.results').append(
              '<p class="no-results">No products available</p>',
            )),
          $('section.collection div.products__wrapper div.results input#product-count').val(s),
          $('section.collection div.products__wrapper svg.ajax-loader').remove());
      },
      complete: function () {
        (lazyLoad.update(),
          initialise_quickview(),
          initialise_size_guide(),
          initialise_stock_notification());
      },
    });
  }
}
function product_gallery_mobile() {
  window.innerWidth >= 600 && $('body').removeClass('gallery-active');
}
function get_fit_information(t, e) {
  $.ajax({
    url: 'https://cdn.percivalclo.com/api/?action=get-fit-data&title=' + t,
    type: 'GET',
    success: function (t) {
      var i = JSON.parse(t);
      if (1 == i.success && null !== i.data) {
        var o = $('<ul class="info" />');
        ($.each(i.data[0].list_items, function (t, e) {
          $('<li/>').html(e).appendTo(o);
        }),
          e.append(o).css('display', 'block'));
      }
    },
  });
}
if (
  (calculate_hh(),
  window.addEventListener('resize', calculate_hh, { passive: !0 }),
  window.addEventListener('orientationchange', calculate_hh, { passive: !0 }),
  scrolling_header(),
  $(window).scroll(function () {
    scrolling_header();
  }),
  $(window).scroll(function () {
    ($('body').addClass('scrolling'),
      clearTimeout($.data(this, 'scrollCheck')),
      $.data(
        this,
        'scrollCheck',
        setTimeout(function () {
          $('body').removeClass('scrolling');
        }, 250),
      ));
  }),
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (t) {
      if ('/pages/outfit-builder' == window.location.pathname) var e = 145;
      else e = 74;
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        var i = $(this.hash);
        (i = i.length ? i : $('[name=' + this.hash.slice(1) + ']')).length &&
          (t.preventDefault(),
          $('html, body').animate({ scrollTop: i.offset().top - e }, 1e3, function () {
            var t = $(i);
            if ((t.focus(), t.is(':focus'))) return !1;
            (t.attr('tabindex', '-1'), t.focus());
          }));
      }
    }),
  $('div.selected-country').on('click', function () {
    $.fancybox.open({
      src: '#country-selector',
      clickOutside: !1,
      clickSlide: !1,
      autoFocus: !1,
      arrows: !1,
      touch: !1,
      btnTpl: {
        close: !1,
        smallBtn:
          '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
        arrowLeft: '',
        arrowRight: '',
      },
    });
  }),
  $('form.shopify-localization-form div.select-wrapper select#shopify-localization').on(
    'change',
    function () {
      var t = $(this).parents('form.shopify-localization-form');
      (t.find('input.country-code').val($(this).val()), t.submit());
    },
  ),
  $('nav.secondary-menu ul li.cart a').on('click', function (t) {
    (t.preventDefault(), $('body').addClass('cart-active'));
  }),
  $('div.mask, a.close-cart').on('click', function (t) {
    (t.preventDefault(), $('body').removeClass('cart-active'));
  }),
  $('header nav li.desktop-menu div.hamburger-btn').on('click', function (t) {
    (t.preventDefault(),
      $('body').addClass('offset-menu-active'),
      $('.offset-menu').find('[data-src]').addClass('lazy'),
      lazyLoad.update());
  }),
  $('div.mask, a.close-offset-menu').on('click', function (t) {
    (t.preventDefault(),
      $('body').removeClass('offset-menu-active'),
      hide_active_offset_sub_menus());
  }),
  window.addEventListener('resize', desktop_menu),
  window.addEventListener('orientationchange', desktop_menu),
  $(
    '.no-touchevents div.offset-menu div.offset-menu-wrapper div.offset-menu-columns div.column nav.sub-menu ul.menu li.level-1.has-sub > a',
  ).hover(function () {
    $(this).hasClass('offer-link') ||
      ($(this).parent('li').siblings().removeClass('active'),
      $(this).parent('li').addClass('active'),
      check_offset_sub_menus_visibility());
  }),
  $('a.close-offset-menu-level-1').on('click', function (t) {
    (t.preventDefault(),
      $(this).parents('li').removeClass('active'),
      $(
        'div.offset-menu div.offset-menu-wrapper div.offset-menu-columns div.column.column-2',
      ).removeClass('add-border'));
  }),
  $('a.disabled, a.disable').on('click', function (t) {
    t.preventDefault();
  }),
  $('nav.main-menu ul li.mobile-menu div.hamburger-btn').on('click', function (t) {
    (t.preventDefault(),
      $('body').addClass('mobile-menu-active'),
      $('.mobile-menu').find('[data-src]').addClass('lazy'),
      lazyLoad.update());
  }),
  $('div.mask, a.close-mobile-menu').on('click', function (t) {
    (t.preventDefault(), $('body').removeClass('mobile-menu-active'));
  }),
  $('a.open-cart').on('click', function (t) {
    (t.preventDefault(), $('body').removeClass('mobile-menu-active').addClass('cart-active'));
  }),
  window.addEventListener('resize', mobile_menu),
  window.addEventListener('orientationchange', mobile_menu),
  $(window).scroll(function () {
    collection_page_colour();
  }),
  $('.read-more').click(function (t) {
    t.preventDefault();
    var e = $(this).text();
    ($(this).text('Read More' == e ? 'Read Less' : 'Read More'),
      $('section.top-banner-v2').length > 0
        ? $(this).prev('div.description').toggleClass('has-clamp')
        : $(this).prev('h2').toggleClass('has-clamp'));
  }),
  $('div.product-filter').on('click', function () {
    $('body').addClass('filter-active');
  }),
  $(document).on('click', 'div.filter-results__tags span.tag', function () {
    $('body').addClass('filter-active');
  }),
  $('div.mask, a.close-filter').on('click', function (t) {
    (t.preventDefault(), $('body').removeClass('filter-active'));
  }),
  $(document).on('click', 'div.option-wrapper label', function (t) {
    var e = $(this).parents('div.option-wrapper').find('input');
    (e.attr('checked', !e.attr('checked')),
      get_selected_sizes(),
      get_selected_custom_one(),
      get_selected_custom_two());
  }),
  $(document).on('click', 'ul.colour-filters li', function () {
    $(this).toggleClass('checked');
    var t = $(this).find('input');
    (t.attr('checked', !t.attr('checked')), get_selected_colours());
  }),
  $(document).on('click', 'ul.theme-filters li', function () {
    $(this).toggleClass('checked');
    var t = $(this).find('input');
    (t.attr('checked', !t.attr('checked')), get_selected_themes());
  }),
  $('a.apply-filters').on('click', function (t) {
    t.preventDefault();
    var e = $('input#filter-themes').val(),
      i = $('input#filter-colours').val(),
      o = $('input#filter-sizes').val(),
      n = $('input#filter-price-range').val(),
      s = $('input#filter-custom-one').val(),
      a = $('input#filter-custom-two').val();
    if ('' == e && '' == i && '' == o && '' == s && '' == a && '' == n)
      alert('No filters selected');
    else {
      var r = o.split(','),
        l = '' == o ? ['all'] : r,
        c = [e, i, s, a].filter(Boolean).join(',');
      if ('' !== (d = [e, i, s, a].filter(Boolean).join(',')))
        var d = d.split(','),
          p = l.concat(d);
      else p = l;
      var u = $('div.filter-results'),
        f = u.find('div.filter-results__tags');
      f.empty();
      var h = 0;
      p.length > 0 &&
        $.each(p, function (t, e) {
          if ('all' !== e) {
            if ('xs' == e || 's' == e || 'm' == e || 'l' == e || 'xl' == e || 'xxl' == e)
              var i = 'uppercase';
            else i = 'capitalize';
            (f.append('<span class="tag ' + i + '">' + e.replace('and', '&') + '</span>'), h++);
          }
        });
      var v = n.split(',');
      if (v.length > 0) {
        if (((h += 1), parseInt(v[1]) >= 500)) var g = '500+';
        else g = v[1];
        f.append(
          '<span class="tag uppercase">' +
            currency_symbol +
            v[0] +
            ' - ' +
            currency_symbol +
            g +
            '</span>',
        );
      }
      (u.find('input#price-range').val(n),
        u.find('input#sizes').val(l),
        u.find('input#tags').val(c),
        u.find('span.filter-count').text(h),
        u.removeClass('hide'),
        $('body').removeClass('filter-active'),
        collection_filter());
    }
  }),
  (String.prototype.includes = function (t) {
    var e = !1;
    return (-1 !== this.indexOf(t) && (e = !0), e);
  }),
  get_filtered_state(),
  $(document).on('click', 'div.collection-filters div.collection-filters__filter', function () {
    ($(this).siblings().removeClass('active'),
      $(this).addClass('active'),
      collection_filter($(this).data('collection')));
  }),
  $('select#sort-by').on('change', function () {
    collection_filter();
  }),
  $('button.view-all-products').on('click', function (t) {
    (t.preventDefault(),
      $(this).attr('disabled', !0),
      collection_filter_all(
        parseInt($(this).parent('div.view-all-wrapper').find('input#products-per-page').val()) *
          parseInt($(this).parent('div.view-all-wrapper').find('input#page').val()),
      ));
  }),
  $('a.gallery-view').on('click', function (t) {
    (t.preventDefault(),
      $('body').addClass('gallery-active'),
      $('.gallery-images').find('[data-src]').addClass('lazy'),
      lazyLoad.update());
  }),
  $('a.close-gallery-view').on('click', function (t) {
    (t.preventDefault(), $('body').removeClass('gallery-active'));
  }),
  window.addEventListener('resize', product_gallery_mobile),
  window.addEventListener('orientationchange', product_gallery_mobile),
  $('body').hasClass('fit-guide') &&
    $('section.fit-guide div.guide').each(function () {
      var t = $(this).find('div.guide__fit-information');
      get_fit_information(t.data('type'), t);
    }),
  $('div.get-guide-measurements').on('click', function () {
    var t = $(this).parent('div.guide__measurements').data('type'),
      e =
        'https://cdn.percivalclo.com/api/api/?action=get-sizing-data&title=' +
        t +
        '&type=fit-guide',
      i = $(this).parent('div.guide__measurements').find('div.accordion__hidden');
    i.is(':empty') &&
      '' !== t &&
      '' !== e &&
      i.load(e, function (t, e, o) {
        if ('error' == e)
          alert(
            'An error occurred, if the issue persists please contact the website administrator.',
          );
        else {
          initialise_diagram_slider();
          var n = i.find('div.size-guide'),
            s = n
              .find('div.size-guide__content div.sizing ul.sizing__sizing-options li:first-child')
              .data('size'),
            a = n
              .find('div.size-guide__content div.sizing ul.sizing__sizing-options li:first-child')
              .data('order');
          (n
            .find('div.size-guide__content div.sizing ul.sizing__sizing-options li:first-child')
            .addClass('checked'),
            n
              .find(
                'div.size-guide__content div.sizing div.sizing__measurements div.table-wrapper table tr th[data-size="' +
                  s +
                  '"]',
              )
              .addClass('selected'),
            n
              .find(
                'div.size-guide__content div.sizing div.sizing__measurements div.table-wrapper table tr td[data-size="' +
                  s +
                  '"]',
              )
              .addClass('selected'),
            n
              .find('div.size-guide__content div.sizing div.diagram__slider')
              .slick('slickGoTo', a - 1),
            lazyLoad.update());
        }
      });
  }),
  ($.fn.isInViewport = function () {
    var t = $(this).offset().top,
      e = t + $(this).outerHeight(),
      i = $(window).scrollTop(),
      o = i + $(window).height();
    return e > i && t < o;
  }),
  $('form.search input')
    .on('blur', function () {
      $(this).parents('form.search').removeClass('focus-active');
    })
    .on('focus', function () {
      $(this).parents('form.search').addClass('focus-active');
    }),
  $('form.search input')
    .on('focus', function () {
      $(this).parents('form.search').removeClass('focus-active');
    })
    .on('focus', function () {
      $(this).parents('form.search').addClass('focus-active');
    }),
  $('form.search input').hover(
    function () {
      $(this).parents('form.search').addClass('hover-active');
    },
    function () {
      $(this).parents('form.search').removeClass('hover-active');
    },
  ),
  $('form.search button').hover(
    function () {
      $(this).parents('form.search').addClass('hover-active');
    },
    function () {
      $(this).parents('form.search').removeClass('hover-active');
    },
  ),
  $('form.search input').on('keyup', function () {
    $(this).val().length > 0
      ? $(this).parents('form.search').addClass('has-value')
      : $(this).parents('form.search').removeClass('has-value');
  }),
  $(document).on('click', 'div.checkbox-wrapper label', function (t) {
    var e = $(this).parents('div.checkbox-wrapper').find('input');
    'no' == e.val()
      ? (e.addClass('checked'), e.val('yes'))
      : (e.removeClass('checked'), e.val('no'));
  }),
  $('section.faqs div.faqs__blocks div.faq div.faq-heading').on('click', function () {
    ($(this).parent('div.faq').toggleClass('open'),
      $(this).parent('div.faq').find('div.hidden-content').stop().slideToggle());
  }),
  $('section.top-banner div.editorial div.menu-wrapper select#category-filter').on(
    'change',
    function (t) {
      t.preventDefault();
      var e = $(this).val();
      e && (window.location = e);
    },
  ),
  $('section.video-banner').length > 0)
) {
  var first_section = $('section:first');
  if (first_section.hasClass('video-banner')) {
    var menu_colour = first_section.data('menu');
    $('header div.header-bottom').addClass(menu_colour);
  }
}
function initialise_outfit_slider() {
  $('div.product-info__outfits div.outfit-slider').slick({
    infinite: !0,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: !0,
    arrows: !0,
    prevArrow:
      '<button class="slick-prev"><span class="sr-only">Previous</span><svg version="1.1" id="chevron-left" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 7.5 13.4" xml:space="preserve"><path d="M6.7,0.7l-6,6l6,6" fill="none" stroke="#000" stroke-linecap="round" /></svg></button>',
    nextArrow:
      '<button class="slick-next"><span class="sr-only">Next</span><svg version="1.1" id="chevron-right" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 7.5 13.4" xml:space="preserve"><path d="M.7 12.7l6-6-6-6" fill="none" stroke="#000" stroke-linecap="round" /></svg></button>',
    speed: 800,
    fade: !1,
    autoplay: !1,
    lazyLoad: 'ondemand',
    pauseOnHover: !0,
    responsive: [{ breakpoint: 700, settings: { slidesToShow: 2, slidesToScroll: 2 } }],
  });
}
function initialise_quickview_slider() {
  var t = $('div#product-quickview div.product-images div.slides');
  t.slick({
    infinite: !0,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: !0,
    arrows: !0,
    prevArrow:
      '<button class="slick-prev"><span class="sr-only">Previous</span><svg version="1.1" id="arrow-left" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24.8 18.7" xml:space="preserve"><path d="M4.8 10.6h19.5V8H4.8L12.7.3H9.3l-8.9 9 8.9 9h3.4l-7.9-7.7z" /></svg></button>',
    nextArrow:
      '<button class="slick-next"><span class="sr-only">Next</span><svg version="1.1" id="arrow-right" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24.8 18.7" xml:space="preserve"><path d="M19.9 8H.4v2.6h19.5L12 18.3h3.4l8.9-9-8.9-9H12L19.9 8z" /></svg></button>',
    speed: 600,
    fade: !1,
    autoplay: !1,
    variableWidth: !0,
    lazyLoad: 'ondemand',
    appendArrows: t.parents('div#product-quickview').find('div.arrows'),
    appendDots: t.parents('div#product-quickview').find('div.dots'),
  });
}
function initialise_diagram_slider() {
  $('div.size-guide div.diagram div.diagram__slider').each(function () {
    $(this).not('.slick-initialized').slick({
      infinite: !0,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: !1,
      arrows: !1,
      speed: 600,
      fade: !0,
      autoplay: !1,
      lazyLoad: 'ondemand',
    });
  });
}
function trigger_sizing_chart() {
  $.fancybox.open({
    src: '#product-sizing-chart',
    autoFocus: !1,
    arrows: !1,
    touch: !1,
    spinnerTpl: '<div class="fancybox-loading"><span class="ajax-loader large"></span></div>',
    btnTpl: {
      close: !1,
      smallBtn:
        '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
      arrowLeft: '',
      arrowRight: '',
    },
    afterLoad: function () {
      lazyLoad.update();
    },
    afterClose: function (t, e) {
      (e.$content.find('iframe#deferred-media').remove(),
        $('ul.tabs li[data-tab-id="2"]').removeClass('active'),
        $('ul.tabs li[data-tab-id="1"]').trigger('click'));
    },
  });
}
function product_sizing() {
  $('div.product-info__sizing').length > 0 &&
    $('div.product-info__sizing ul.sizing li').length >= 1 &&
    $('div.product-info__sizing').css('display', 'block');
}
function cm_to_inches(t) {
  var e = (t / 2.54).toFixed(1);
  return parseFloat(e);
}
function product_colour_swatches() {
  $('div.product-info__colours').length > 0 &&
    $('div.product-info__colours ul.colours li').length > 1 &&
    $('div.product-info__colours').css('display', 'block');
}
function check_product_options(t) {
  var e = $('ul.options.waist').attr('data-option'),
    i = $('ul.options.length').attr('data-option');
  if ('' !== e && '' !== i) {
    var o = JSON.parse($('#inventory-data').html()),
      n = '',
      s = '',
      a = '';
    if (
      (o.variants.length > 0 &&
        $.each(o.variants, function (t, o) {
          o.title == e + ' / ' + i && ((n += o.id), (s += o.title), (a += o.inventory_quantity));
        }),
      a > 0)
    )
      ($('div.product-info__bundles').length > 0 &&
        t.parents('div.bundle').find('input[type="hidden"]').val(n),
        $('input#variant').val(n),
        $('button.add-to-bag').removeClass('disabled').removeClass('hidden'),
        $('a.stock-notification').addClass('hidden'),
        $('span.out-of-stock').addClass('hidden'));
    else
      ($('button.add-to-bag').addClass('disabled').addClass('hidden'),
        $('a.stock-notification').attr('data-id', n).attr('data-title', s).removeClass('hidden'),
        $('span.out-of-stock').removeClass('hidden'));
  }
}
function check_bundles() {
  var t = $('div.product-info__bundles');
  if (t.length > 0) {
    var e = [],
      i = 0;
    (t.find('div.bundle').each(function (t) {
      var o = $(this).find('input[type="hidden"]').val();
      (o && e.push({ id: o, quantity: 1 }), i++);
    }),
      e.length == i
        ? $('button.add-bundle').attr('disabled', !1)
        : $('button.add-bundle').attr('disabled', !0));
  }
}
function get_out_of_stock_options(t) {
  if (t.parents('ul.options').hasClass('waist'))
    var e = t.attr('data-title'),
      i = $('ul.options.length').attr('data-option');
  else ((e = $('ul.options.waist').attr('data-option')), (i = t.attr('data-title')));
  var o = !1;
  if ('' !== e && '' !== i) {
    var n = JSON.parse($('#inventory-data').html());
    n.variants.length > 0 &&
      $.each(n.variants, function (t, n) {
        n.title == e + ' / ' + i && (o += n.id);
      });
  }
  return o;
}
function initialise_size_guide() {
  $('[data-fancybox="size-guide"]').fancybox({
    type: 'ajax',
    arrows: !1,
    touch: !1,
    spinnerTpl: '<div class="fancybox-loading"><span class="ajax-loader large"></span></div>',
    btnTpl: {
      close: !1,
      smallBtn:
        '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
      arrowLeft: '',
      arrowRight: '',
    },
    afterLoad: function () {
      var t;
      (initialise_diagram_slider(),
      '' !==
        (t = $('div.product-info div.product-info__sizing ul.sizing li.checked').data('title')))
        ? set_size_guide_sizing(t, null)
        : set_size_guide_sizing(
            (t = $('div.product-info div.product-info__sizing ul.sizing li:first-child').data(
              'title',
            )),
            null,
          );
      lazyLoad.update();
    },
  });
}
function set_size_guide_sizing(t, e) {
  if (null !== e) {
    var i = e.parents('div.size-guide');
    i.find('div.sizing__measurements div.table-wrapper table tr').each(function () {
      ($(this).find('th').removeClass('selected'),
        $(this).find('td').removeClass('selected'),
        $(this)
          .find('th[data-size="' + t + '"]')
          .addClass('selected'),
        $(this)
          .find('td[data-size="' + t + '"]')
          .addClass('selected'));
    });
    var o = i.find('ul.sizing__sizing-options');
    (o.find('li').each(function () {
      ($(this).removeClass('checked'), $(this).data('size') == t && $(this).addClass('checked'));
    }),
      (s = o.find('li[data-size="' + t + '"]')).addClass('selected'));
    var n = s.data('order');
    i.find('div.diagram div.diagram__slider').slick('slickGoTo', n - 1);
  } else {
    var s;
    ($('div.sizing__measurements div.table-wrapper table tr').each(function () {
      ($(this).find('th').removeClass('selected'),
        $(this).find('td').removeClass('selected'),
        $(this)
          .find('th[data-size="' + t + '"]')
          .addClass('selected'),
        $(this)
          .find('td[data-size="' + t + '"]')
          .addClass('selected'));
    }),
      $('ul.sizing__sizing-options li').each(function () {
        ($(this).removeClass('checked'), $(this).data('size') == t && $(this).addClass('checked'));
      }),
      (s = $('ul.sizing__sizing-options li[data-size="' + t + '"]')).addClass('selected'));
    n = s.data('order');
    $('div.size-guide div.diagram div.diagram__slider').slick('slickGoTo', n - 1);
  }
}
function initialise_quickview() {
  $('[data-fancybox="quickview"]').fancybox({
    type: 'ajax',
    arrows: !1,
    touch: !1,
    spinnerTpl: '<div class="fancybox-loading"><span class="ajax-loader large"></span></div>',
    btnTpl: {
      close: !1,
      smallBtn:
        '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
      arrowLeft: '',
      arrowRight: '',
    },
    afterLoad: function (t, e) {
      initialise_quickview_slider();
      var i = JSON.parse($('#product-json').html()),
        o = '';
      (i.variants.length > 0 &&
        $.each(i.variants, function (t, e) {
          if (1 == e.available) return ((o += e.id), e.title, !1);
        }),
        e.$content.find('input#variant').val(o),
        e.$content.find('ul.sizing li[data-id="' + o + '"]').addClass('checked'),
        product_sizing(),
        product_colour_swatches(),
        lazyLoad.update(),
        (window.KlarnaOnsiteService = window.KlarnaOnsiteService || []),
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' }),
        initialise_outfit_slider(),
        initialise_size_guide());
    },
  });
}
function initialise_quick_add() {
  $('[data-fancybox="quick-add"]').fancybox({
    type: 'ajax',
    arrows: !1,
    touch: !1,
    spinnerTpl: '<div class="fancybox-loading"><span class="ajax-loader large"></span></div>',
    btnTpl: {
      close: !1,
      smallBtn:
        '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
      arrowLeft: '',
      arrowRight: '',
    },
    afterLoad: function (t, e) {
      var i = JSON.parse($('#product-json').html()),
        o = '';
      (i.variants.length > 0 &&
        $.each(i.variants, function (t, e) {
          if (1 == e.available) return ((o += e.id), e.title, !1);
        }),
        e.$content.find('input#variant').val(o),
        e.$content.find('ul.sizing li[data-id="' + o + '"]').addClass('checked'),
        product_sizing(),
        initialise_size_guide());
    },
  });
}
function initialise_stock_notification() {
  $('[data-fancybox="stock-notification"]').fancybox({
    type: 'ajax',
    clickOutside: !1,
    clickSlide: !1,
    autoFocus: !1,
    arrows: !1,
    touch: !1,
    spinnerTpl: '<div class="fancybox-loading"><span class="ajax-loader large"></span></div>',
    btnTpl: {
      close: !1,
      smallBtn:
        '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
      arrowLeft: '',
      arrowRight: '',
    },
    afterLoad: function (t, e) {
      var i = e.$content.find('#product-json'),
        o = JSON.parse(i.html()),
        n = '';
      if (o.variants.length > 0) {
        var s = o.variants.length;
        $.each(o.variants, function (t, e) {
          if (0 == e.available) {
            var i = '';
            ((i += e.title
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/-$/, '')
              .replace(/^-/, '')),
              e.title.length > 3 && (i += ' wide'),
              1 == s && (i += ' checked'),
              (n +=
                '<li class="' +
                i +
                '" data-id="' +
                e.id +
                '"><span class="sizing__text">' +
                e.title +
                '</span>'));
          }
        });
      }
      var a = o.title.split('|');
      (e.$content.find('div.product-info__title span.heading').text(a[0]),
        e.$content.find('div.product-info__title p.subtitle').text(a[1]));
      var r = e.$content.find('div.product-info__title p.subtitle');
      (a[2] && $('<p>' + a[2] + '</p>').insertAfter(r[0]),
        a[3] && $('<p>' + a[3] + '</p>').insertAfter(r[0]),
        e.$content.find('div.product-info__sizing ul.sizing').empty().append(n),
        e.$content.find('form#stock-notification input#sn-product-id').val(o.id),
        product_sizing());
    },
    afterClose: function () {
      ($('form#stock-notification div.alert').remove(),
        $('div#product-stock-notification div.product-info__sizing span.title').removeClass(
          'error',
        ),
        $('form#stock-notification input#sn-email').removeClass('error'));
    },
  });
}
function output_cart_item(t) {
  var e = t.title.split('|'),
    i = e[0] ? e[0] : '',
    o = e[1] ? e[1].split('-') : '',
    n = o[0] ? o[0] : '',
    s = t.variant_title ? '<p class="size">Size: ' + t.variant_title + '</p>' : '',
    a = '';
  ($.isEmptyObject(t.properties) ||
    $.each(t.properties, function (t, e) {
      'gift_message' == t &&
        '' !== e &&
        (a += '<div class="message"><span class="title">Message</span><p>' + e + '</p></div>');
    }),
    $('div.sliding-cart div.sliding-cart__wrapper div.cart-items').append(
      $(
        '<div class="cart-items__item" data-id="' +
          t.id +
          '"><div class="product-image"><a href="' +
          t.url +
          '"><img class="lazy" data-src="' +
          t.image +
          '" alt="" /></a></div><div class="product-info"><div class="product-info__top"><a href="' +
          t.url +
          '"><p class="title">' +
          i +
          '</p><p class="variant">' +
          n +
          '</p>' +
          s +
          a +
          '</a></div><div class="product-info__bottom"><div class="quantity-btns"><button type="button" class="minus ajax"><span class="text">-</span></button><div class="quantity"><span class="quantity__input">' +
          t.quantity +
          '</span></div><button type="button" class="plus ajax"><span class="text">+</span></button></div><div class="price"><span class="price"><span class="money" data-currency-gbp="£' +
          (t.price / 100).toFixed(2) +
          '">' +
          currency_symbol +
          (t.price / 100).toFixed(2) +
          '</span></span></div></div></div></div>',
      ),
    ));
}
function update_cart(t, e) {
  $.ajax({
    url: '/cart/change',
    dataType: 'json',
    method: 'POST',
    data: { quantity: t, id: e },
  }).done(function (e) {
    get_cart(t > 0);
  });
}
function get_cart(t) {
  $.ajax({
    type: 'GET',
    url: '/cart',
    dataType: 'json',
    beforeSend: function () {
      1 == t
        ? $('div.sliding-cart div.sliding-cart__wrapper div.cart-items').addClass('disabled')
        : $('div.sliding-cart div.sliding-cart__wrapper div.cart-items')
            .empty()
            .addClass('disabled');
    },
    success: function (e) {
      if (
        ($('div.sliding-cart div.sliding-cart__wrapper div.cart-items').removeClass('disabled'),
        $('span.cart-count').text(e.item_count),
        e.item_count > 0)
      ) {
        if (
          ($('div.sliding-cart div.sliding-cart__wrapper p.cart-empty').remove(),
          1 == t
            ? $.each(e.items, function (t, e) {
                $('div.cart-items__item[data-id="' + e.id + '"]')
                  .find('span.quantity__input')
                  .text(e.quantity);
              })
            : $.each(e.items, function (t, e) {
                output_cart_item(e);
              }),
          0 !== e.total_discount)
        )
          ($(
            'div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money',
          ).text(currency_symbol + (e.total_discount / 100).toFixed(2)),
            $(
              'div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money',
            ).attr('data-currency-gbp', '£' + i),
            $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount').removeClass(
              'hidden',
            ));
        else {
          var i = 0;
          ($(
            'div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money',
          ).text(currency_symbol + i),
            $(
              'div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money',
            ).attr('data-currency-gbp', '£' + i),
            $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount').addClass(
              'hidden',
            ));
        }
        $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer').removeClass('hidden');
      } else
        ($('div.sliding-cart div.sliding-cart__wrapper div.cart-items').empty(),
          $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer').addClass('hidden'),
          $('div.sliding-cart div.sliding-cart__wrapper').prepend(
            $('<p class="cart-empty">Cart empty</p>'),
          ));
      var o = (e.total_price / 100).toFixed(2);
      $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.subtotal span.money')
        .text(currency_symbol + o)
        .attr('data-currency-gbp', '£' + o);
    },
  }).done(function (t) {
    lazyLoad.update();
  });
}
function check_discount(t) {
  var e = [];
  (t.items.length >= 2 || t.items[0].quantity >= 2) &&
    t.items.forEach(function (t) {
      e.push({
        id: t.product_id,
        quantity: t.quantity,
        productType: t.product_type,
        price: t.final_line_price,
      });
    });
  var i = t.items_subtotal_price.toFixed(2);
  e.length
    ? get_discount(e, i)
    : ($('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money').text(
        currency_symbol + 0,
      ),
      $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money').attr(
        'data-currency-gbp',
        '£0',
      ),
      $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount').addClass('hidden'),
      $('form.checkout').attr('action', '/checkout'),
      set_discount(!1));
}
function get_discount(t, e) {
  $.ajax({
    url: 'https://db-app.percivalclo.com/discount',
    method: 'POST',
    data: { products: t, subtotal: e },
  }).done(function (i) {
    if (i.success) apply_discount(t, i.discount, e);
    else {
      ($('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money').text(
        currency_symbol + 0,
      ),
        $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money').attr(
          'data-currency-gbp',
          '£0',
        ),
        $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount').addClass(
          'hidden',
        ),
        $('form.checkout').attr('action', '/checkout'),
        set_discount(!1));
    }
  });
}
function get_product_entitlement_total(t, e, i) {
  var o = t.filter(t => e.find(({ id: e }) => t.id === parseInt(e)));
  o.sort(function (t, e) {
    return t.price - e.price;
  });
  var n = 0,
    s = 0;
  return (
    $.each(o, function (t, e) {
      s <= i && ((s += e.quantity), (n += e.price / 100));
    }),
    n.toFixed(2)
  );
}
function apply_discount(t, e, i) {
  i /= 100;
  var o = '',
    n = '';
  if (
    ((o =
      'free' === e.type
        ? 'FREE'
        : 'percentage' === e.type
          ? e.value + '%'
          : currency_symbol + e.value),
    'percentage' === e.type)
  ) {
    var s =
      (get_product_entitlement_total(t, e.entitlements.products, e.prerequisites.quantity) *
        e.value) /
      100;
    n = currency_symbol + (i - s).toFixed(2);
  } else n = currency_symbol + (i - e.value).toFixed(2);
  ($('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money').text(o),
    'percentage' == e.type
      ? $(
          'div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money',
        ).removeAttr('data-currency-gbp')
      : $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount span.money')
          .data('currency-gbp', o)
          .attr('data-currency-gbp', o),
    $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.discount').removeClass(
      'hidden',
    ),
    $('div.sliding-cart div.sliding-cart__wrapper div.cart-footer p.subtotal span.money')
      .text(n)
      .data('currency-gbp', n)
      .attr('data-currency-gbp', n));
  var a = $('body').find('form[action="/checkout"]').attr('action');
  a &&
    (-1 === a.indexOf('?')
      ? (a += '?discount=' + encodeURI(e.code))
      : (a += '&discount=' + encodeURI(e.code)),
    set_discount(e.code),
    $('body').find('form[action="/checkout"]').attr('action', a));
}
($('section.top-banner div.top-banner__static-slides.first-banner').on('load', function () {
  $('header div.header-bottom')
    .removeClass('black')
    .removeClass('white')
    .removeClass('white-solid');
  var t = $(this).data('menu');
  $('header div.header-bottom').addClass(t);
}),
  $('section.top-banner div.top-banner__slides').on('init', function (t, e) {
    e.slideCount > 1 && $(this).addClass('multiple-slides');
    var i = $(this).find('div.slick-current').find('div.slide'),
      o = i.data('menu'),
      n = i.data('dots'),
      s = i.data('arrows');
    i.data('text');
    ($('header div.header-bottom')
      .removeClass('black')
      .removeClass('white')
      .removeClass('white-solid'),
      $('header div.header-bottom').addClass(o),
      $('section.top-banner div.top-banner__dots').removeClass('black').removeClass('white'),
      $('section.top-banner div.top-banner__dots').addClass(n),
      $('section.top-banner div.top-banner__arrows').removeClass('black').removeClass('white'),
      $('section.top-banner div.top-banner__arrows').addClass(s));
    var a = i.data('confetti'),
      r = i.data('animation');
    (1 == a && 0 == r && (confetti.start(1200, 50, 150), i.data('animation', !0)),
      1 == i.data('bats')
        ? $('section.top-banner').addClass('show-bats')
        : $('section.top-banner').removeClass('show-bats'));
  }),
  $('section.top-banner div.top-banner__slides').slick({
    infinite: !0,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: !0,
    appendDots: $('section.top-banner div.top-banner__dots'),
    arrows: !0,
    appendArrows: $('section.top-banner div.top-banner__arrows'),
    prevArrow:
      '<button class="slick-prev"><span class="sr-only">Previous</span><svg version="1.1" id="chevron-left" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 7.5 13.4" xml:space="preserve"><path d="M6.7,0.7l-6,6l6,6" fill="none" stroke="#000" stroke-linecap="round" /></svg></button>',
    nextArrow:
      '<button class="slick-next"><span class="sr-only">Next</span><svg version="1.1" id="chevron-right" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 7.5 13.4" xml:space="preserve"><path d="M.7 12.7l6-6-6-6" fill="none" stroke="#000" stroke-linecap="round" /></svg></button>',
    speed: 600,
    fade: !1,
    autoplay: !0,
    autoplaySpeed: 6e3,
    lazyLoad: 'ondemand',
    pauseOnHover: !0,
  }),
  $('section.top-banner div.top-banner__slides').on('beforeChange', function (t, e, i, o) {
    var n = $(e.$slides[o]).find('div.slide'),
      s = n.data('menu'),
      a = n.data('dots'),
      r = n.data('arrows');
    n.data('text');
    ($('header div.header-bottom')
      .removeClass('black')
      .removeClass('white')
      .removeClass('white-solid'),
      $('header div.header-bottom').addClass(s),
      $('section.top-banner div.top-banner__dots').removeClass('black').removeClass('white'),
      $('section.top-banner div.top-banner__dots').addClass(a),
      $('section.top-banner div.top-banner__arrows').removeClass('black').removeClass('white'),
      $('section.top-banner div.top-banner__arrows').addClass(r));
    var l = n.data('confetti'),
      c = n.data('animation');
    (1 == l && 0 == c && (confetti.start(1200, 50, 150), n.data('animation', !0)),
      1 == n.data('bats')
        ? $('section.top-banner').addClass('show-bats')
        : $('section.top-banner').removeClass('show-bats'));
  }),
  $('article.product div.slides').each(function () {
    $(this).slick({
      infinite: !0,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: !0,
      arrows: !1,
      speed: 600,
      fade: !1,
      autoplay: !0,
      autoplaySpeed: 6e3,
      lazyLoad: 'ondemand',
      pauseOnHover: !0,
      adaptiveHeight: !0,
      appendDots: $(this).parents('article.product').find('div.slider-pagination'),
    });
  }),
  $(document).on('click', 'ul.slider-toggle li', function () {
    ($('ul.slider-toggle li').removeClass('active'), $(this).addClass('active'));
    var t = $(this).data('slider-id'),
      e = '1' == t ? '2' : '1';
    ($(this)
      .parents('section.related-products')
      .find('div.related-slider-' + e)
      .hide(),
      $(this)
        .parents('section.related-products')
        .find('div.related-slider-' + t)
        .show()
        .slick('refresh'));
  }),
  $('section.related-products div.related-slides-toggle').slick({
    infinite: !0,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: !1,
    arrows: !1,
    speed: 800,
    fade: !1,
    autoplay: !1,
    lazyLoad: 'ondemand',
    responsive: [
      { breakpoint: 1e3, settings: { slidesToShow: 2 } },
      { breakpoint: 700, settings: { slidesToShow: 1 } },
    ],
  }),
  $('section.related-products div.related-slides').on('init', function (t, e) {
    var i = e.slideCount;
    $(this).addClass('related-slides-' + i);
  }),
  $('section.related-products div.related-slides').slick({
    infinite: !0,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: !1,
    arrows: !1,
    speed: 800,
    fade: !1,
    autoplay: !0,
    autoplaySpeed: 1e3,
    lazyLoad: 'ondemand',
    pauseOnHover: !0,
    responsive: [
      { breakpoint: 1e3, settings: { slidesToShow: 2, autoplay: !1 } },
      { breakpoint: 700, settings: { slidesToShow: 1, autoplay: !1 } },
    ],
  }),
  $('section.outfit-builder div.outfits__slider').slick({
    infinite: !0,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: !0,
    arrows: !1,
    speed: 800,
    fade: !1,
    autoplay: !1,
    lazyLoad: 'ondemand',
    pauseOnHover: !0,
    responsive: [
      { breakpoint: 1e3, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 700, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    ],
  }),
  initialise_outfit_slider(),
  $('section.fit-guide div.guide div.guide__slides').each(function () {
    $(this)
      .not('.slick-initialized')
      .slick({
        infinite: !0,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: !0,
        appendDots: $(this).parents('div.guide').find('div.slider-pagination'),
        arrows: !0,
        prevArrow:
          '<button class="slick-prev"><span class="sr-only">Previous</span><svg version="1.1" id="chevron-left" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 7.5 13.4" xml:space="preserve"><path d="M6.7,0.7l-6,6l6,6" fill="none" stroke="#000" stroke-linecap="round" /></svg></button>',
        nextArrow:
          '<button class="slick-next"><span class="sr-only">Next</span><svg version="1.1" id="chevron-right" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 7.5 13.4" xml:space="preserve"><path d="M.7 12.7l6-6-6-6" fill="none" stroke="#000" stroke-linecap="round" /></svg></button>',
        speed: 800,
        fade: !1,
        autoplay: !1,
        lazyLoad: 'ondemand',
        responsive: [
          { breakpoint: 1e3, settings: { slidesToShow: 2, autoplay: !1 } },
          { breakpoint: 600, settings: { slidesToShow: 1, autoplay: !1 } },
        ],
      });
  }),
  $('section.showroom div.showroom__slider').slick({
    infinite: !0,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: !1,
    arrows: !1,
    speed: 600,
    fade: !0,
    autoplay: !0,
    autoplaySpeed: 6e3,
    adaptiveHeight: !0,
    lazyLoad: 'ondemand',
  }),
  $('section.sliding-image-block div.image-wrapper').slick({
    infinite: !0,
    slidesToScroll: 1,
    dots: !1,
    arrows: !1,
    fade: !1,
    speed: 800,
    autoplay: !0,
    autoplaySpeed: 1e3,
    pauseOnHover: !0,
    variableWidth: !0,
    lazyLoad: 'ondemand',
    responsive: [{ breakpoint: 850, settings: { slidesToShow: 1 } }],
  }),
  $(window).on('load resize orientationchange', function () {
    var t = $('div.product-images div.slider div.slider__slides');
    $(window).width() > 950
      ? t.hasClass('slick-initialized') && t.slick('unslick')
      : t.hasClass('slick-initialized') ||
        t.slick({
          infinite: !0,
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: !0,
          arrows: !1,
          speed: 600,
          fade: !1,
          autoplay: !1,
          variableWidth: !0,
          adaptiveHeight: !1,
          draggable: !0,
          appendDots: t.parents('div.slider').find('div.slider__pagination'),
          lazyLoad: 'ondemand',
          responsive: [
            {
              breakpoint: 600,
              settings: { slidesToShow: 1, variableWidth: !1, adaptiveHeight: !0 },
            },
          ],
        });
  }),
  $(document).on('click', 'ul.tabs li', function () {
    ($('ul.tabs li').removeClass('active'),
      $('.tab-content').removeClass('active'),
      $(this).addClass('active'));
    var t = $(this).data('tab-id');
    2 == t ? trigger_sizing_chart() : $('div.product-info__tabs div#tab-' + t).addClass('active');
  }),
  $('span.play-icon').on('click', function () {
    var t = $(this).data('type'),
      e = $(this).data('src');
    $(this)
      .parent('div.video-wrapper')
      .append(
        '<iframe id="deferred-media" class="' +
          t +
          '-video" src="' +
          e +
          '" width="100%" height="310" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>',
      );
  }),
  $(document).on('keyup', 'textarea#gift-message-text', function () {
    var t = $(this).val().length;
    ($('div.gift-message div.gift-message__wrapper div.counter span.current').text(t),
      t > 120
        ? $('div.gift-message div.gift-message__wrapper div.counter').addClass('error')
        : $('div.gift-message div.gift-message__wrapper div.counter').removeClass('error'));
    var e = $('input#gift-message-final');
    e.length > 0 && e.val($(this).val());
  }),
  product_sizing(),
  $(document).on('click', 'ul.auto-units li', function () {
    ($(this).siblings().removeClass('checked'),
      $(this).addClass('checked'),
      'inches' == $(this).data('unit')
        ? $(this)
            .parents('div.sizing-charts')
            .find('div.table-wrapper table td')
            .each(function () {
              ((cm_unit = $(this).text()),
                $(this).attr('data-cm', cm_unit),
                void 0 === $(this).data('inches')
                  ? ((inches_unit = cm_to_inches(cm_unit)),
                    $(this).attr('data-inches', inches_unit),
                    $(this).text(inches_unit))
                  : ((inches_unit = $(this).data('inches')), $(this).text(inches_unit)));
            })
        : $(this)
            .parents('div.sizing-charts')
            .find('div.table-wrapper table td')
            .each(function () {
              void 0 !== $(this).data('cm') &&
                ((cm_unit = $(this).data('cm')), $(this).text(cm_unit));
            }));
  }),
  product_colour_swatches(),
  $(document).on(
    {
      mouseenter: function () {
        var t = $(this).data('colour');
        $(this).parents('div.product-info__colours').find('span.colour').text(t);
      },
      mouseleave: function () {
        var t = $(this).parents('div.product-info__colours').find('span.title').data('colour');
        $(this).parents('div.product-info__colours').find('span.colour').text(t);
      },
    },
    '.no-touchevents ul.colours li.available > span',
  ),
  $(document).on('click', 'span.sizing-quick-add', function () {
    ($(this).toggleClass('active'),
      $(this).parents('article.product').find('div.product__quick-add').toggleClass('active'));
  }),
  $(document).on('click', 'ul.sizing.product-listing li', function () {
    if (!$(this).hasClass('not-available')) {
      ($(this).siblings().removeClass('checked'), $(this).addClass('checked'));
      var t = $(this).data('id');
      $(this).parent('ul.sizing').data('id');
      ($('input#variant').val(t),
        $('div.product-info__bundles').length > 0 &&
          $(this).parents('div.bundle').find('input[type="hidden"]').val(t),
        $('body').hasClass('template-product') &&
          window.history.replaceState(null, null, '?variant=' + t),
        check_bundles());
    }
  }),
  $(document).on('click', 'ul.sizing.quick-add li', function () {
    if (!$(this).hasClass('not-available')) {
      var t = $(this),
        e = $(this).data('id');
      '' !== e &&
        $.ajax({
          url: '/cart/add',
          dataType: 'json',
          method: 'POST',
          data: { quantity: 1, id: parseInt(e) },
          beforeSend: function () {
            t.addClass('disabled');
          },
          error: function (t, e, i) {
            422 == t.status &&
              $.fancybox.open({
                src: '#sizing-error',
                clickOutside: !1,
                clickSlide: !1,
                autoFocus: !1,
                arrows: !1,
                touch: !1,
                btnTpl: {
                  close: !1,
                  smallBtn:
                    '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
                  arrowLeft: '',
                  arrowRight: '',
                },
              });
          },
          success: function (t) {},
        }).done(function (e) {
          (t.removeClass('disabled'),
            get_cart(!1),
            $.fancybox.close(),
            $('body').addClass('cart-active'));
        });
    }
  }),
  $(document).on('click', 'ul.options.product-listing li', function () {
    if (!$(this).hasClass('not-available')) {
      ($(this).siblings().removeClass('checked'), $(this).addClass('checked'));
      var t = $(this).data('title');
      ($(this).parent('ul.options').attr('data-option', t),
        check_product_options($(this)),
        check_bundles());
    }
  }),
  $(document).on(
    'mouseover',
    '.no-touchevents article.product div.image-wrapper.standard',
    function () {
      var t = $(this).find('img.rollover');
      t &&
        '0' == t.data('loaded') &&
        t.attr('src', t.data('rollover')).addClass('loaded').attr('data-loaded', 1);
    },
  ),
  $(document).on(
    'click',
    'a.stock-notification, ul.sizing.product-listing li.not-available',
    function (t) {
      t.preventDefault();
      var e = $(this).data('id');
      $(this).data('title');
      ($.fancybox.close(),
        $.fancybox.open({
          src: '#stock-notification',
          clickOutside: !1,
          clickSlide: !1,
          autoFocus: !1,
          arrows: !1,
          touch: !1,
          btnTpl: {
            close: !1,
            smallBtn:
              '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
            arrowLeft: '',
            arrowRight: '',
          },
          afterLoad: function (t, i) {
            var o = JSON.parse($('#product-json').html()),
              n = '';
            if (o.variants.length > 0) {
              var s = o.variants.length;
              $.each(o.variants, function (t, i) {
                if (0 == i.available) {
                  var o = '';
                  ((o += i.title
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, '-')
                    .replace(/-$/, '')
                    .replace(/^-/, '')),
                    i.title.length > 3 && (o += ' wide'),
                    void 0 !== e && e == i.id && (o += ' checked'),
                    1 == s && (o += ' checked'),
                    (n +=
                      '<li class="' +
                      o +
                      '" data-id="' +
                      i.id +
                      '" data-title="' +
                      i.title.toLowerCase() +
                      '"><span class="sizing__text">' +
                      i.title +
                      '</span>'));
                }
              });
            }
            var a = o.title.split('|');
            (i.$content.find('div.product-info__title span.heading').text(a[0].trim()),
              i.$content.find('div.product-info__title p.subtitle').text(a[1].trim()));
            var r = i.$content.find('div.product-info__title');
            (a[2] && $(r[0]).append('<p class="sub-subtitle">' + a[2].trim() + '</p>'),
              i.$content.find('div.product-info__sizing ul.sizing').empty().append(n),
              i.$content.find('form#stock-notification input#sn-product-id').val(o.id),
              void 0 !== e &&
                i.$content.find('form#stock-notification input#sn-product-variant').val(e),
              product_sizing());
          },
          afterClose: function () {
            ($('form#stock-notification div.alert')
              .removeClass('success')
              .removeClass('danger')
              .empty(),
              $('div#stock-notification div.product-info__sizing span.title').removeClass('error'),
              $('form#stock-notification input#sn-email').removeClass('error'),
              $('form#stock-notification')[0].reset(),
              $('form#stock-notification input#sn-product-variant').val(''),
              $('div#stock-notification div.product-info__title p.sub-subtitle').remove(),
              $('div#stock-notification div.product-info__title p.sub-sub-subtitle').remove());
          },
        }));
    },
  ),
  $(document).on('click', 'ul.options.product-listing li.not-available', function (t) {
    t.preventDefault();
    var e = get_out_of_stock_options($(this));
    ($.fancybox.close(),
      $.fancybox.open({
        src: '#stock-notification',
        clickOutside: !1,
        clickSlide: !1,
        autoFocus: !1,
        arrows: !1,
        touch: !1,
        btnTpl: {
          close: !1,
          smallBtn:
            '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
          arrowLeft: '',
          arrowRight: '',
        },
        afterLoad: function (t, i) {
          var o = JSON.parse($('#inventory-data').html()),
            n = '';
          o.variants.length > 0 &&
            $.each(o.variants, function (t, i) {
              if (i.inventory_quantity <= 0) {
                var o = '';
                ((o += i.title
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, '-')
                  .replace(/-$/, '')
                  .replace(/^-/, '')),
                  i.title.length > 3 && (o += ' wide'),
                  void 0 !== e && !1 !== e && e == i.id && (o += ' checked'),
                  (n +=
                    '<li class="' +
                    o +
                    '" data-id="' +
                    i.id +
                    '" data-title="' +
                    i.title.toLowerCase() +
                    '"><span class="sizing__text">' +
                    i.title +
                    '</span>'));
              }
            });
          var s = o.title.split('|');
          (i.$content.find('div.product-info__title span.heading').text(s[0].trim()),
            i.$content.find('div.product-info__title p.subtitle').text(s[1].trim()));
          var a = i.$content.find('div.product-info__title');
          (s[2] && $(a[0]).append('<p class="sub-subtitle">' + s[2].trim() + '</p>'),
            i.$content.find('div.product-info__sizing ul.sizing').empty().append(n),
            i.$content.find('form#stock-notification input#sn-product-id').val(o.id),
            void 0 !== e &&
              !1 !== e &&
              i.$content.find('form#stock-notification input#sn-product-variant').val(e),
            product_sizing());
        },
        afterClose: function () {
          ($('form#stock-notification div.alert')
            .removeClass('success')
            .removeClass('danger')
            .empty(),
            $('div#stock-notification div.product-info__sizing span.title').removeClass('error'),
            $('form#stock-notification input#sn-email').removeClass('error'),
            $('form#stock-notification')[0].reset(),
            $('form#stock-notification input#sn-product-variant').val(''),
            $('div#stock-notification div.product-info__title p.sub-subtitle').remove(),
            $('div#stock-notification div.product-info__title p.sub-sub-subtitle').remove());
        },
      }));
  }),
  $(document).on(
    'click',
    'ul.sizing.quick-add li.not-available,  ul.sizing.product-outfit li.not-available',
    function (t) {
      t.preventDefault();
      var e = $(this).data('id');
      $(this).data('title');
      if ($(this).parent('ul.sizing').hasClass('quick-add'))
        var i = $(this).parents('div.product__quick-add').find('#product-json');
      else {
        var o = $(this).parents('ul.sizing').attr('data-id');
        i = $(
          'div.product-filters__products div.products div.product.checked[data-id="' + o + '"]',
        ).children('#product-json');
      }
      ($.fancybox.close(),
        $.fancybox.open({
          src: '#stock-notification',
          clickOutside: !1,
          clickSlide: !1,
          autoFocus: !1,
          arrows: !1,
          touch: !1,
          btnTpl: {
            close: !1,
            smallBtn:
              '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
            arrowLeft: '',
            arrowRight: '',
          },
          afterLoad: function (t, o) {
            var n = JSON.parse(i.html()),
              s = '';
            n.variants.length > 0 &&
              $.each(n.variants, function (t, i) {
                if (0 == i.available) {
                  var o = '';
                  ((o += i.title
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, '-')
                    .replace(/-$/, '')
                    .replace(/^-/, '')),
                    i.title.length > 3 && (o += ' wide'),
                    void 0 !== e && parseInt(e) == i.id && (o += ' checked'),
                    (s +=
                      '<li class="' +
                      o +
                      '" data-id="' +
                      i.id +
                      '" data-title="' +
                      i.title.toLowerCase() +
                      '"><span class="sizing__text">' +
                      i.title +
                      '</span>'));
                }
              });
            var a = n.title.split('|');
            (o.$content.find('div.product-info__title span.heading').text(a[0].trim()),
              o.$content.find('div.product-info__title p.subtitle').text(a[1].trim()));
            var r = o.$content.find('div.product-info__title');
            (a[2] && $(r[0]).append('<p class="sub-subtitle">' + a[2].trim() + '</p>'),
              o.$content.find('div.product-info__sizing ul.sizing').empty().append(s),
              o.$content.find('form#stock-notification input#sn-product-id').val(n.id),
              void 0 !== e &&
                o.$content.find('form#stock-notification input#sn-product-variant').val(e),
              product_sizing());
          },
          afterClose: function () {
            ($('form#stock-notification div.alert')
              .removeClass('success')
              .removeClass('danger')
              .empty(),
              $('div#stock-notification div.product-info__sizing span.title').removeClass('error'),
              $('form#stock-notification input#sn-email').removeClass('error'),
              $('form#stock-notification')[0].reset(),
              $('form#stock-notification input#sn-product-variant').val(''),
              $('div#stock-notification div.product-info__title p.sub-subtitle').remove(),
              $('div#stock-notification div.product-info__title p.sub-sub-subtitle').remove());
          },
        }));
    },
  ),
  $(document).on(
    'click',
    'div#product-stock-notification ul.sizing li, div#stock-notification ul.sizing li',
    function () {
      ($(this).siblings().removeClass('checked'), $(this).addClass('checked'));
      var t = $(this).data('id');
      $('form#stock-notification input#sn-product-variant').val(t);
    },
  ),
  $(document).on('submit', 'form#stock-notification', function (t) {
    t.preventDefault();
    var e = $(this),
      i = e.find('input#sn-product-id'),
      o = e.find('input#sn-product-variant'),
      n = e.find('input#sn-email'),
      s = ((n = e.find('input#sn-email')), e.find('input#sn-accepts-marketing'));
    if ('' != i.val() && '' != o.val() && validate_email(n.val())) {
      if (
        ('' == i.val() && alert('An error occurred, please contact the website administrator.'),
        '' == o.val()
          ? $('div.product-info__sizing span.title').addClass('error')
          : $('div.product-info__sizing span.title').removeClass('error'),
        validate_email(n.val()) ? n.removeClass('error') : n.addClass('error'),
        $('<span class="ajax-loader"></span>').insertAfter(
          'form#stock-notification button.notify-me',
        ),
        'yes' == s.val())
      )
        var a = { accepts_marketing: !0, quantity_required: 1 };
      else a = { quantity_required: 1 };
      BIS.create(n.val(), parseInt(o.val()), parseInt(i.val()), a).then(function (t) {
        ($('form#stock-notification div.alert')
          .removeClass('success')
          .removeClass('danger')
          .empty(),
          $('span.ajax-loader').remove());
        var e = 'OK' == t.status ? 'success' : 'danger',
          i = $('form#stock-notification div.alert');
        'OK' == t.status
          ? i.addClass(e).append('<p>' + t.message + '</p>')
          : (i.addClass(e),
            $.each(t.errors, function (t, e) {
              i.append('<p>' + e + '</p>');
            }));
      });
    } else
      ('' == i.val() && alert('An error occurred, please contact the website administrator.'),
        '' == o.val()
          ? ($('div#stock-notification div.product-info__sizing span.title').addClass('error'),
            $('div#product-stock-notification div.product-info__sizing span.title').addClass(
              'error',
            ))
          : ($('div#stock-notification div.product-info__sizing span.title').removeClass('error'),
            $('div#product-stock-notification div.product-info__sizing span.title').removeClass(
              'error',
            )),
        validate_email(n.val()) ? n.removeClass('error') : n.addClass('error'));
  }),
  $(document).on('click', 'div.accordion div.accordion__heading', function () {
    if (!$(this).hasClass('disabled')) {
      var t = $(this).parent('div.accordion');
      (t.toggleClass('open'), t.children('div.accordion__hidden').stop().slideToggle());
    }
  }),
  $('[data-fancybox="usp"]').fancybox({
    arrows: !1,
    btnTpl: {
      close: !1,
      smallBtn:
        '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
      arrowLeft: '',
      arrowRight: '',
    },
  }),
  $('[data-fancybox="video"]').fancybox({
    arrows: !1,
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg><span class=\'text\'>Close</span></button>',
      arrowLeft: '',
      arrowRight: '',
    },
    video: {
      tpl: '<video class="fancybox-video" muted controls disablepictureinpicture controlsList="nodownload noplaybackrate"><source src="{{src}}" type="{{format}}" />Your browser doesn\'t support HTML5 video</video>',
      format: '',
      autoStart: !0,
    },
  }),
  $('[data-fancybox="product"]').fancybox({
    wheel: !1,
    buttons: ['close'],
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg><span class=\'text\'>Close</span></button>',
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg version="1.1" id="arrow-left" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24.8 18.7" xml:space="preserve"><path d="M4.8 10.6h19.5V8H4.8L12.7.3H9.3l-8.9 9 8.9 9h3.4l-7.9-7.7z" /></svg></div><span class="sr-only">Previous</span></button>',
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg version="1.1" id="arrow-right" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24.8 18.7" xml:space="preserve"><path d="M19.9 8H.4v2.6h19.5L12 18.3h3.4l8.9-9-8.9-9H12L19.9 8z" /></svg></div><span class="sr-only">Previous</span></button>',
    },
    video: {
      tpl: '<video class="fancybox-video" muted controls disablepictureinpicture controlsList="nodownload noplaybackrate"><source src="{{src}}" type="{{format}}" />Your browser doesn\'t support HTML5 video</video>',
      format: '',
      autoStart: !0,
    },
    beforeLoad: function (t, e) {
      var i = $.fancybox.getInstance().current.src.replace('width=1080', 'width=2080');
      $('div.fancybox-content').zoom({
        on: 'click',
        url: i,
        onZoomIn: function () {
          $(this).addClass('zoomed-in');
        },
        onZoomOut: function () {
          $(this).removeClass('zoomed-in');
        },
      });
    },
  }),
  $(document).on('click', 'ul.units li', function () {
    ($(this).siblings().removeClass('checked'),
      $(this).addClass('checked'),
      (selected_unit = $(this).data('unit')),
      'cm' == selected_unit
        ? $('div.sizing__measurements div.table-wrapper').removeClass('inches').addClass('cm')
        : $('div.sizing__measurements div.table-wrapper').removeClass('cm').addClass('inches'));
  }),
  $(document).on('click', 'ul.sizing__sizing-options li', function () {
    var t = $(this),
      e = t.data('size');
    void 0 !== e && set_size_guide_sizing(e, t);
  }),
  $(document).on(
    'click',
    'div.sizing__measurements div.table-wrapper table tr th, div.sizing__measurements div.table-wrapper table tr td',
    function () {
      var t = $(this),
        e = t.data('size');
      void 0 !== e && set_size_guide_sizing(e, t);
    },
  ),
  $(document).on(
    'beforeChange',
    'div.size-guide div.diagram div.diagram__slider',
    function (t, e, i, o) {
      if (0 === i && o === e.$slides.length - 1) var n = $(e.$slides[o]);
      else if (o > i || (i === e.$slides.length - 1 && 0 === o)) n = $(e.$slides[o]);
      else n = $(e.$slides[o]);
      var s = $(this),
        a = n.find('div.image').data('size');
      void 0 !== a && set_size_guide_sizing(a, s);
    },
  ),
  initialise_quickview(),
  initialise_quick_add(),
  initialise_stock_notification(),
  initialise_size_guide(),
  (window.refresh_cart = function () {
    (get_cart(!1), $('body').addClass('cart-active'));
  }),
  $(document).on('click', 'button.minus', function (t) {
    t.preventDefault();
    var e = $(this).parents('div.cart-items__item').data('id'),
      i = $(this).next('div.quantity').find('span.quantity__input');
    (parseInt(i.text()) > 0 && i.text(parseInt(i.text()) - 1),
      $(this).hasClass('ajax') && update_cart(parseInt(i.text()), e),
      $(this).hasClass('outfit-quantity') &&
        (parseInt(i.text()) > 0
          ? $(this)
              .parents('div.cart-item')
              .find('input#cart-item-clothing-4')
              .attr('data-quantity', parseInt(i.text()))
          : ($(
              'div.outfit-filter[data-item="4"] div.column.product-filters div.product-filters__products div.products div.product',
            ).each(function (t) {
              $(this).removeClass('checked');
            }),
            $('div.outfit-filter[data-item="4"] div.column.product-preview')
              .empty()
              .append(
                '<div class="image-wrapper hidden"><span class="preview-btn"><svg version="1.1" id="search" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><path d="M20.7,23.4l-7-7c-1.3,0.8-2.9,1.3-4.5,1.3c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5c0,1.7-0.5,3.2-1.3,4.5l7,7C23.4,20.7,20.7,23.4,20.7,23.4z M9.2,15.8c3.7,0,6.6-3,6.6-6.6s-3-6.6-6.6-6.6s-6.6,3-6.6,6.6S5.5,15.8,9.2,15.8z" /></svg></span><img class="preview" src="#"><img class="rollover" src="#"></div>',
              ),
            $('div.outfit-filter[data-item="4"] div.column.product-data')
              .empty()
              .append(
                '<div class="product-data__info"><div class="column column-one"><p class="title"></p><div class="price"></div></div><div class="column column-two"><a class="cta cta-light quickview" data-fancybox="quickview" data-type="ajax" data-src="" href="javascript:;">Quickview</a></div></div><div class="product-data__match"><a class="product-match trouser-match hidden" href="#" data-products=""><span class="icon"><svg version="1.1" id="trousers" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24 24" xml:space="preserve"><path d="M6.606 23.995H9.48a.317.317 0 00.204-.072.325.325 0 00.113-.188L12 10.11l2.202 13.613a.319.319 0 00.318.26h2.875a.317.317 0 00.221-.09.326.326 0 00.098-.221L17.356 2.27V.324a.326.326 0 00-.093-.229.318.318 0 00-.227-.095H6.964a.317.317 0 00-.226.095.327.327 0 00-.094.23v1.94L6.286 23.67a.328.328 0 00.196.304c.04.017.081.025.124.025v-.005zM13.819.649h2.898v1.297h-2.898V.649zm2.898 1.945v1.598c-.768-.22-1.023-1.103-1.126-1.598h1.126zm-2.898 3.992V2.594h1.123c.127.85.616 2.075 1.818 2.27l.31 18.482h-2.28L12.374 8.405c1.067-.169 1.418-1.217 1.446-1.819zM12.319.65h.86v1.297h-.86V.649zm0 1.945h.86v3.977c0 .044-.061 1.011-.86 1.185V2.594zM7.284.649h4.397v1.297H7.283V.649zm0 1.945H8.42c-.092.495-.363 1.375-1.123 1.598l-.013-1.598zm-.043 2.27c1.202-.195 1.69-1.42 1.818-2.27h2.622V8.08L9.21 23.346H6.93l.31-18.482z"/></svg></span><span class="text">Match to Trousers</span></a><a class="product-match jacket-match hidden" href="#" data-products=""><span class="icon"><svg version="1.1" id="jacket" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 37.9 30" xml:space="preserve"><path d="M21.2 20.3l.2-.1 2.4 2.8-.2.1-2.4-2.8zm-8.6 2.5l2.8-2.3.1.2-2.8 2.3-.1-.2z"/><path d="M33.7 25.4l3.3-2.7-.9-1.5-9.2-16.4-3.4-1.2L22.4.9h-7.5l-1.3 2.9-3.7 1.3-8.4 17.7-.7 1.6L4.4 27l.8-1.5 4.5-9V29h17V15.6l5.5 7.7 1.5 2.1zm2.5-2.9l-2.3 1.9-.6-.7 2.3-1.9.6.7zM22.8 3.6l-2.6 1.9-.8-.6 2.8-2.7.6 1.4zm-1.1-2l-1.4 1.3h-3.4l-1.4-1.3h6.2zm-6.6.5l2.8 2.7-.8.6-2.7-1.9.7-1.4zm-10.9 24l-2.5-1.8.4-1 2.6 1.9-.5.9zM9.7 15l-4.8 9.6-2.6-1.9 7.8-16.5v.4c.1 1.8.1 5.3-.4 8.4zm8.6 13.3h-7.9v-1.1h7.9v1.1zm0-1.9h-7.9V15.2c.6-3.9.5-8.4.4-9.7v-.1l3.5-1.2 2.9 2.1 1.1-.9v21zm-.7-22.8h2l-1 1-1-1zm8.5 24.7H19v-1.1h7.1v1.1zm0-1.9H19v-21l1.2.9 2.9-2.1 2.6.9v.1c0 .9-.2 5.8.4 10v11.2zm.6-12c-.4-3.5-.4-7.3-.3-8.8v-.4l.2.3 8.7 15.6-2.4 1.9-6.2-8.6z"/><path d="M20.7 13.6h3.2V9.4h-3.2v4.2zm.7-3.5h1.8v2.8h-1.8v-2.8zm-9.6 12.6l.9 1 3.7-3.1-.9-1-3.7 3.1zm.9.5l-.4-.4 3.1-2.6.4.4-3.1 2.6zm7.7-3l3.1 3.7 1-.9-3.1-3.7-1 .9zm3.1 3.2l-2.6-3.1.4-.4 2.6 3.1-.4.4z"/></svg></span><span class="text">Match to Jacket</span></a></div><div class="product-data__sizing"><ul class="sizing product-outfit" data-id=""></ul></div>',
              )
              .addClass('hidden'),
            $(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.clothing div.cart-item.item-4',
            )
              .empty()
              .append(
                '<div class="cart-item__image"><img class="preview" src="#"></div><div class="cart-item__info"><div class="info-top"><p class="title"></p><p class="size"></p><div class="price"></div></div><div class="info-bottom"><div class="quantity-btns"><button type="button" class="minus outfit-quantity"><span class="text">-</span></button><div class="quantity"><span class="quantity__input">1</span></div><button type="button" class="plus outfit-quantity"><span class="text">+</span></button></div></div></div><input type="hidden" id="cart-item-clothing-4" value="" data-notice="" data-quantity="1" data-cost="0">',
              )
              .addClass('hidden')),
        update_outfit_cart()));
  }),
  $(document).on('click', 'button.plus', function (t) {
    t.preventDefault();
    var e = $(this).parents('div.cart-items__item').data('id'),
      i = $(this).prev('div.quantity').find('span.quantity__input');
    (i.text(parseInt(i.text()) + 1),
      $(this).hasClass('ajax') && update_cart(parseInt(i.text()), e),
      $(this).hasClass('outfit-quantity') &&
        ($(this)
          .parents('div.cart-item')
          .find('input#cart-item-clothing-4')
          .attr('data-quantity', parseInt(i.text())),
        update_outfit_cart()));
  }),
  $(document).on('submit', 'form[action="/cart/add"]', function (t) {
    t.preventDefault();
  }),
  $(document).on('click', 'button.add-bundle', function (t) {
    t.preventDefault();
    var e = $(this);
    e.append('<span class="ajax-loader"></span>');
    var i = $('div.product-info__bundles');
    if (i.length > 0) {
      var o = [];
      (i.find('div.bundle').each(function (t) {
        var e = $(this).find('input[type="hidden"]').val();
        e && o.push({ id: parseInt(e), quantity: 1 });
      }),
        o.length > 0 &&
          $.ajax({
            url: '/cart/add',
            dataType: 'json',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ items: o }),
            error: function (t, e, i) {
              422 == t.status &&
                $.fancybox.open({
                  src: '#sizing-error',
                  clickOutside: !1,
                  clickSlide: !1,
                  autoFocus: !1,
                  arrows: !1,
                  touch: !1,
                  btnTpl: {
                    close: !1,
                    smallBtn:
                      '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
                    arrowLeft: '',
                    arrowRight: '',
                  },
                });
            },
            success: function (t) {},
          }).done(function (t) {
            e.children('span.ajax-loader').remove();
          }));
    }
  }),
  $(document).on('submit', 'form.ometria-form-ajax', function (t) {
    t.preventDefault();
    var e = $(this),
      i = e.find('button.submit'),
      o = e.find('input#first-name'),
      n = e.find('input#last-name'),
      s = e.find('input#email'),
      a = e.find('input#success');
    if (a.length > 0) var r = a.val();
    else r = 'You have successfully signed up to the mailing list!';
    var l = e.find('input#age-verification');
    if ('' != o.val() && '' != n.val() && validate_email(s.val())) {
      ('' == o.val() && o.addClass('error'),
        '' == n.val() && n.addClass('error'),
        validate_email(s.val()) ? s.removeClass('error') : s.addClass('error'));
      var c = !0;
      if (
        (l.length > 0 &&
          ('no' == l.val()
            ? ((c = !1), l.parent('div.checkbox-wrapper').addClass('error'))
            : ((c = !0), l.parent('div.checkbox-wrapper').removeClass('error'))),
        1 == c)
      ) {
        var d = $(this).serialize();
        $.ajax({
          type: 'POST',
          url: 'https://api.ometria.com/forms/signup/ajax',
          data: d,
          beforeSend: function () {
            (e.find('div.alert').removeClass('danger').removeClass('success').empty(),
              i.attr('disabled', !0),
              $('<span class="ajax-loader"></span>').insertAfter(i));
          },
          success: function (t) {
            (i.attr('disabled', !1), e.find('span.ajax-loader').remove());
            var o = e.find('div.alert'),
              n = !0 !== t.ok ? 'danger' : 'success';
            (o.addClass(n),
              !0 !== t.ok
                ? $.each(t.errors, function (t, e) {
                    o.append('<p>' + e[1] + '</p>');
                  })
                : o.append('<p>' + r + '</p>'),
              e.find('div.alert').append(o));
          },
        });
      }
    } else
      ('' == o.val() && o.addClass('error'),
        '' == n.val() && n.addClass('error'),
        validate_email(s.val()) ? s.removeClass('error') : s.addClass('error'));
  }));
var current_url = window.location.pathname;
if ('/account/login' == current_url) {
  var wishlist = get_url_parameter('wishlist'),
    product_url = get_url_parameter('product_url');
  if (wishlist && 'true' == wishlist) {
    var bookmark_icon =
      '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100"><path d="M24,22.3c0-3.5,2.9-6.4,6.4-6.4v58.8l17.3-12.4c1.1-.8,2.6-.8,3.7,0l17.3,12.4V22.3H30.4v-6.4h38.3c3.5,0,6.4,2.9,6.4,6.4v58.6c0,1.2-.7,2.3-1.7,2.8s-2.3.5-3.3-.2l-20.5-14.6-20.5,14.6c-1,.7-2.2.8-3.3.2s-1.7-1.6-1.7-2.8V22.3Z"/></svg>';
    ($('div#customer-login')
      .find('div.text-wrapper')
      .append(
        '<div class="alert danger">' +
          bookmark_icon +
          ' You need to create an account to unlock our new wishlist feature.</div>',
      ),
      product_url
        ? $('form#customer_login').find('input#return_to').val(product_url)
        : $('form#customer_login').find('input#return_to').val('/pages/swym-wishlist'));
  }
}
$(window).on('load', function () {
  if (($('body').addClass('loaded'), $('div.yotpo.bottomLine').length > 0)) {
    var t = $('div.yotpo.bottomLine').find('a.text-m');
    if (t.length > 0) {
      var e = t.text().replace(/ Reviews/g, '');
      (t.text(e), $('div.yotpo.bottomLine').addClass('show'));
    }
  }
});
